import React , { useState, useRef, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom'; 

import icons from './icons'
import app from './app';
import { elementsProps} from "../preview/utility";
import { countryCode, svgIcon, template_categories, submenuColors } from "./utility";
import { elementBackground } from "../preview/app"; 
import { TabComponent } from "./elements"; 
import { MasterMenu } from "../components/MasterMenu";
import ManageMenu, { USE_NEW_MENU, migrateLegacyMenu } from "../components/ManageMenu";
import modulesJSON from "./modules.json"; 
import DivkitRender from "../appKit"



let colorPicker = null;
 
const socialIcons = [
  { icon: "icon-facebook", link: "https://www.facebook.com/" },
  { icon: "icon-twitter-rect", link: "https://twitter.com/" },
  { icon: "icon-youtube", link: "https://www.youtube.com/" },
  { icon: "icon-linkedin-rect", link: "https://www.linkedin.com/" },
  { icon: "icon-vimeo-rect", link: "https://vimeo.com/" },
  { icon: "icon-pinterest-1", link: "https://www.pinterest.com/" },
  { icon: "appyicon-snap-chat", link: "https://www.snapchat.com/" },
  { icon: "icon-skype-1", link: "https://skype.com/" },
  { icon: "appyicon-whatsapp", link: "https://wa.me/" }, 
   { icon: `<svg xmlns="http://www.w3.org/2000/svg" fill="#ffffff" width="18px" height="18px" viewBox="0 0 32 32" version="1.1">
<path xmlns="http://www.w3.org/2000/svg" d="M16.656 1.029c1.637-0.025 3.262-0.012 4.886-0.025 0.054 2.031 0.878 3.859 2.189 5.213l-0.002-0.002c1.411 1.271 3.247 2.095 5.271 2.235l0.028 0.002v5.036c-1.912-0.048-3.71-0.489-5.331-1.247l0.082 0.034c-0.784-0.377-1.447-0.764-2.077-1.196l0.052 0.034c-0.012 3.649 0.012 7.298-0.025 10.934-0.103 1.853-0.719 3.543-1.707 4.954l0.020-0.031c-1.652 2.366-4.328 3.919-7.371 4.011l-0.014 0c-0.123 0.006-0.268 0.009-0.414 0.009-1.73 0-3.347-0.482-4.725-1.319l0.040 0.023c-2.508-1.509-4.238-4.091-4.558-7.094l-0.004-0.041c-0.025-0.625-0.037-1.25-0.012-1.862 0.49-4.779 4.494-8.476 9.361-8.476 0.547 0 1.083 0.047 1.604 0.136l-0.056-0.008c0.025 1.849-0.050 3.699-0.050 5.548-0.423-0.153-0.911-0.242-1.42-0.242-1.868 0-3.457 1.194-4.045 2.861l-0.009 0.030c-0.133 0.427-0.21 0.918-0.21 1.426 0 0.206 0.013 0.41 0.037 0.61l-0.002-0.024c0.332 2.046 2.086 3.59 4.201 3.59 0.061 0 0.121-0.001 0.181-0.004l-0.009 0c1.463-0.044 2.733-0.831 3.451-1.994l0.010-0.018c0.267-0.372 0.45-0.822 0.511-1.311l0.001-0.014c0.125-2.237 0.075-4.461 0.087-6.698 0.012-5.036-0.012-10.060 0.025-15.083z"/>
</svg>`, link: "https://www.tiktok.com/@" }, 
  
]

export const AppLink = function (props) {
  return <a href={props.href} className={props.className} onClick={function(event){
    window.routerClick(event);
    event.preventDefault();
  }}>{props.children}</a>
}


 
export const getRootValue = function (data, type) {
 // return "Nitin"
//  console.log("data.elements", data.elements)
  let value = ""; 
  if(data.elements){
    for(var k in data.elements) {  
      // console.log("data.elements[k].viewType", data.elements[k].viewType) 
      if(data.elements[k]) {  
        if(data.elements[k].viewType === "text" || data.elements[k].viewType === "textHtml" || data.elements[k].viewType === "navigation" || data.elements[k].viewType === "footerNavigation" || data.elements[k].viewType === "copyRight"){
          if(data.elements[k]["properties"][type] !== undefined){
            value = data.elements[k]["properties"][type]; 
          }
        }else{ 
            if(data.elements[k].viewType === "grid") {
              if(data.elements[k]["items"]) {   
                data.elements[k]["items"].forEach(function(val, ind){ 
                  if(ind == 0){ 
                    for(var key in val) {  
                      if(val[key].viewType === "text" || val[key].viewType === "textHtml" || val[key].viewType === "navigation" || val[key].viewType === "footerNavigation" || val[key].viewType === "copyRight"){ 
                        if(val[key]["properties"][type] !== undefined){ 
                            value = val[key]["properties"][type] 
                        } 
                      }  
                    } 
                  } 
                })
              }  
            }
          }  
      }
      break;  
    }
  }else{
    for(var k in data) { 
      if(data[k]) {
        if(data[k].viewType === "text" || data[k].viewType === "textHtml" || data[k].viewType === "copyRight"){
          if(data[k]["properties"][type]  !== undefined){
            value = data[k]["properties"][type]; 
          }
        }
      } 
    } 
  } 
  return value;
}

export const AppWrapper = function (props) {
  return <div className="container-fluid p-0 w-100 h-100">
  <nav className="navbar navbar-expand-lg navbar-light bg-light">
<div className="container-fluid">
<AppLink className="navbar-brand" href="/">AI Editor</AppLink>
<button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
<span className="navbar-toggler-icon"></span>
</button>
<div className="collapse navbar-collapse">
<ul className="navbar-nav me-auto mb-2 mb-lg-0">
  <li className="nav-item">
    <AppLink className="nav-link" href="/master-blocks">Master Blocks</AppLink>
  </li>
  <li className="nav-item">
  <AppLink className="nav-link" href="/blocks">Blocks</AppLink>
  </li>
  <li className="nav-item">
  <AppLink className="nav-link" href="/pages">Pages</AppLink>
  </li>
</ul>

</div>
</div>
</nav>
<div className="container-fluid p-0 w-100 overflow-scroll" style={{height:"calc(100% - 56px)"}}>
  {props.children}
</div>
</div>
}


export const linkPopup = function (data, index, callback, identity, row) {
  let viewType = "";
  if(row && row.viewType){
    viewType = row.viewType
  }
  const div = document.createElement("div");
  // See app.imagePopup: marks an editor-created popup container so CSS can
  // raise it above the Manage Menu popup without touching host .modal markup.
  div.className = "ai-popup-layer";
  document.body.appendChild(div);
  ReactDOM.render(<LinkModel data={data} index={index} callback={callback} identity={identity} viewType={viewType}/>, div);
}

export const connectionModel = function (value, type, index, callback) {
  const div = document.createElement("div");
  div.className = "ai-popup-layer";
  document.body.appendChild(div);
  ReactDOM.render(<ConnectionModel value={value} type={type} index={index} callback={callback} />, div);
}

export const errorAlert = function(alertData, id) { 
  if(id.parentNode.querySelector(".popover")){
    return false
  }
  let div;  
  if(alertData){
    div = document.createElement("div");
    div.setAttribute("class", "popover bs-popover-bottom popover-custom"); 
    div.innerHTML = '<a>x</a><div class="popover-arrow"></div><div class="popover-body">' + alertData + '</div>'
    div.onclick = function () {
      this.parentElement.removeChild(this);
    };
    id.parentNode.appendChild(div);   
  } 
} 
  

export class CustomVideoUpload  extends React.Component {
  constructor(props) {
    super(props);
  
    this.state = {
      userVideos:app.userVideos()
    } 
    this.saveVideos = this.saveVideos.bind(this);
    this.removeVideo = this.removeVideo.bind(this);
  }
  componentDidMount(){
    this.getVideos()
  }

  getVideos(e) {
    let self = this;
    let { userVideos } = self.state; 
    app.fetchPost({
      "method":"getFolderVideoFilesFromAws",
      "appId":localStorage.getItem("aiAppId")
    }).then(function(response){ 
      const baseURL = 'https://d2wuvg8krwnvon.cloudfront.net/';
      let data = [];
      if(response.data){
        data = response.data.map(item => {
          item.video = baseURL + item.video;
          item.image = baseURL + item.image;
          return item;
        }); 
      } 
      app.userVideos(data);
      self.setState({
        userVideos:data
      })
      // app.toast(response.msg);
    })
}

  saveVideos(e) {
      let self = this;
      let { userVideos } = self.state;
      const file = e.currentTarget.files[0]; 
      const size = file.size / (1024 * 1024);

      if(file && file.name.toLowerCase().match(/\.(mp4)$/) ) {
        if(size>100) {
          alert(app.getLang("maxVideoSize"));
        }
        else {
          const fd = new FormData();
          fd.append("method", "uploadVideoForPage");
          fd.append("appId", localStorage.getItem("aiAppId"));
          fd.append("video", file); 
          app.postForm(fd).then(function(a){ 
            userVideos.push(a.data); 
            self.setState({
              userVideos
            })
            app.userVideos(userVideos);
          })
        }
      }
      else {
        app.showAlert("danger", app.getLang("onlyAllowedMp4")); 
      }
  }
  
  removeVideo(index) {
    let self = this;
    let { userVideos } = self.state; 
    let thum = userVideos[index].image;
    let video = userVideos[index].video;

    const baseURL = 'https://d2wuvg8krwnvon.cloudfront.net/';
    thum = thum.replace(baseURL, '');
    video = video.replace(baseURL, '');
    
    const url = `${thum},${video}`; 
    if(window.confirm(app.getLang("confirmDelete"))) { 
      app.fetchPost({
        "method":"removeVideoFile",
        "url":url
      }).then(function(response){
        userVideos.splice(index, 1);
        self.setState({
          userVideos
        })
        app.userVideos(userVideos);
        app.toast(response.message);
      })
    }
  }

  render() {
    let self = this;
    let {userVideos} = self.state;
    let showStyle = {display:"none"};
    if(window.location.hash.indexOf("template-") !== -1) {
      showStyle = {};
    }
     
    return <div className={`row ${app.isMobile()}`}>
    <div className="col-md-12">

      <h6 className="mb-3 small_title">
        {app.getLang("custom_upload")} 
      </h6>
 
      <div className="col-md-12">
        <div className="drag-area">
          <div className="icon">
            <i className="fas fa-cloud-upload-alt appyslim-network-cloud-upload"></i>
          </div>
          <header>{app.getLang("upload")}
          <small className='maxFileSize text-capitalize'>{app.getLang("maxVideoSize")}</small>
          </header>
          <input type="file" id='videoInput' accept="video/mp4" onChange={self.saveVideos} />
        </div>
      </div> 
      <div className='listParent'>
        <ul className="item-list">   
          {userVideos?userVideos.length? 
        
            userVideos.map(function (v, i) {  
              const image  = v.image;
              const video  = v.video;
              return <li>
                <input type="image" src={image} value={video} onClick={() => self.props.callback(v)} alt="" />
                <a className="fa fa-trash icon-trash" onClick={() => self.removeVideo(i)}></a>
              </li>
            })
            :null:null
          }
        </ul>
        </div>
      </div>
    </div>
  }
}

export class CustomHeaderUpload  extends React.Component {
  constructor(props) {
    super(props);
  
    this.state = {
      headerImages:app.headerImages(),
      portrait_list:false,
      landscape_list:false 
    }
     this.saveHeaderImages = this.saveHeaderImages.bind(this);
    this.removeImage = this.removeImage.bind(this);
    this.advancedSettings = this.advancedSettings.bind(this);
  }

  componentDidMount(){
    this.getHeaderAllImages();
    console.log("getHeaderAllImages") 
  }

  save(){ 
    this.props.callback(this.state.headerImages.app_header_image_potrait?this.state.headerImages.app_header_image_potrait:'#00000000');
    // this.props.updateBackgroundHeaderAi("custom");
    if(document.querySelector(".modal .modal-close")) {
      document.querySelector(".modal .modal-close").click();
    }
  }

  getHeaderAllImages(){ 
    let self = this;
    app.fetchPost({
      "method":"getHeaderImage",
      "appId":localStorage.getItem("aiAppId")
    }).then(function(response){ 
      if(response){
        if(response.status === "success"){
          self.setState({
            headerImages:response.data
          })
          app.headerImages(response.data); 
        }else{
          app.toast(response.msg) 
        } 
      }else{
        app.toast("API ERROR") 
      }
      
    })
  }

  saveHeaderImages(i, w, h, t) {
      let self = this; 
      const file = i;
      const size = i.size / (1024 * 1024);
      const width = w;
      const height = h;
      const type = t;
      
      if(file) {
        if(size>5) {
          alert(app.getLang("maxSize"));
        }
        else {
          const fd = new FormData();
          fd.append("method", "saveHeaderImage");
          fd.append("appId", localStorage.getItem("aiAppId"));  
          fd.append("width", width);
          fd.append("height", height);
          fd.append("type", type);
          fd.append("headerImage", file); 
          app.postForm(fd).then(function(response){ 
            console.log("response", response, file)
            if(response.status === "success"){ 
              self.setState({
                headerImages:response.data
              })
              app.headerImages(response.data);
              // self.props.updateBackgroundHeaderAi("custom")
            }else{
              app.toast(response.msg) 
            }
          })
        }
      }
      else {
        app.showAlert("danger", app.getLang("onlyAllowedFormats")); 
      }
  }
 
  removeImage(e) {
    let self = this; 
    const width = e.currentTarget.getAttribute('width');
    const height = e.currentTarget.getAttribute('height');
    const type = e.currentTarget.getAttribute('data-type');
    if(window.confirm(app.getLang("confirmDelete"))) {
      app.fetchPost({
        "method":"deleteHeaderImage",
        "appId":localStorage.getItem("aiAppId"),
        "type":type,
        "width":width,
        "height":height
      }).then(function(response){ 
        if(response.status === "success"){
          self.setState({
            headerImages:response.data
          })
          app.headerImages(response.data);
          app.toast(response.msg);
        }else{
          app.toast(response.msg);
        } 
      })
     
    }
  }

  advancedSettings = (e) => {
    let event = e.currentTarget;
    let type = event.getAttribute('data-type'); 
    // Toggle the current state value for `type`
    this.setState((prevState) => ({
      [type]: !prevState[type]
    }));
  }

  portraitLandscapeMode(val){
    let self = this;
    let value = val === 1 ? 0 : 1; 
    const fd = new FormData();
    fd.append("method", "saveHeaderImage");
    fd.append("appId", localStorage.getItem("aiAppId"));   
    fd.append("type", "portrait_landscape_mode");
    fd.append("portrait_landscape_mode", value); 
    app.postForm(fd).then(function(response){ 
      if(response.status === "success"){ 
        self.setState({
          headerImages:response.data
        })
        app.headerImages(response.data);
        // self.props.updateBackgroundHeaderAi("custom")
      }else{
        app.toast(response.msg) 
      }
    }) 
  }

cropingModel(e) {
  const fileInput = e.currentTarget.files;  
  const width = e.currentTarget.getAttribute('width');
  const height = e.currentTarget.getAttribute('height');
  const type = e.currentTarget.getAttribute('data-type');

  if (fileInput.length > 0) {
      const file = fileInput[0];  
      const div = document.createElement("div");
      document.body.appendChild(div);
      ReactDOM.render(
          <ImageCropperModal file={file} width={width} height={height} type={type} saveHeaderImages={this.saveHeaderImages} removeImage={this.removeImage} />,
          div
      ); 
  } else {
      alert(app.getLang("please_select_a_file"));
  }
}

  render() {
    let self = this; 
    let {headerImages} = self.state; 

    return <div className='headerUpload'>
      <div className={`listParent ${app.isMobile()}`}> 
      {/* For Portrait */}

        
      <div className='row'>
        <div className="col-md-7">
          <h6 className="mb-2 small_title">{app.getLang("portrait")}</h6> 
          <div class="iconsforSmartphones">
            <i class="icon-appstore"></i>
            <i class="icon-android"></i>
            <i class="icon-windows"></i>
            <i class="iconzu-blackberry"></i>
            <i class="icon-amazon"></i>
          </div> 
          <div class="form-check mt-3 small_hd ms-1 text-secondary cursor-pointer">
          <input className="form-check-input" type="checkbox" checked={self.state.headerImages.portrait_landscape_mode?true:false} id="portrait_landscape_mode" onChange={(e)=>self.portraitLandscapeMode(self.state.headerImages.portrait_landscape_mode)}/>
             <label class="form-check-label" for="portrait_landscape_mode">{app.getLang("sameImages")}</label>
          </div>
          <div data-type="portrait_list" onClick={(e)=>self.advancedSettings(e)} className='small_hd mt-1 cursor-pointer text-secondary ms-1' style={{fontSize: '13px'}}><i className='icon-cog'></i> {app.getLang("advanced_settings")}</div>
        
        </div>
        <div className="col-md-5 text-center mb-3"> 
            <div className={headerImages.app_header_image_potrait?`drag-area w-100 trash-on`:`drag-area w-100`}>
              {headerImages.app_header_image_potrait?<img src={headerImages.app_header_image_potrait}/>:
                <div className="icon">
                  <i className="fas fa-cloud-upload-alt appyslim-network-cloud-upload"></i>
                </div>
              }
              <input type="file" id='imageInput' accept="image/*" width='640' height='88' data-type="app_header_image_potrait" onChange={(e)=>self.cropingModel(e)}/>
              <a class="fa fa-trash icon-trash" width='640' height='88' data-type="app_header_image_potrait" onClick={self.removeImage}></a>
            </div> 
              <small className='maxFileSize text-capitalize'>640x88</small> 
        </div> 

        <div className='col-12 mt-3 portrait_list' style={self.state.portrait_list?{display:'block'}:{display:'none'}}>
          <div className='row'>
            {
              headerImages.headersmartphones.map(function(v,i){
                if(v){ 
                  let removeId = '';
                  if(v.image){
                    removeId = 'trash-on';
                  }
                   return <div className="col-md-6 text-center mb-3">
                    <div className={`drag-area w-100 ${removeId}`}>
                      {v.image?<img src={v.image}/>:
                        <div className="icon">
                          <i className="fas fa-cloud-upload-alt appyslim-network-cloud-upload"></i>
                        </div>
                      }
                      <input type="file" id='imageInput' accept="image/*" width={v.width} height={v.height} data-type="portrait_landscape_size" onChange={(e)=>self.cropingModel(e)}/>
                      <a class="fa fa-trash icon-trash" width={v.width} height={v.height} data-type="portrait_landscape_size" onClick={self.removeImage}></a>
                    </div> 
                    <small className='maxFileSize text-capitalize'>{v.width}x{v.height}</small> 
                  </div> 
                }
              })
            } 
          </div>
        </div> 
      </div> 

      {/* For Landscape */}
      <div className='row'>
        <div className='col-12'><hr className='mt-3 mb-4'/></div>
        <div className="col-md-7">
          <h6 className="mb-2 small_title">{app.getLang("landscape")}</h6> 
          <div class="iconsforSmartphones">
            <i class="icon-appstore"></i>
            <i class="icon-android"></i>
            <i class="icon-windows"></i>
            <i class="iconzu-blackberry"></i>
            <i class="icon-amazon"></i>
          </div>
          <div data-type="landscape_list" onClick={(e)=>self.advancedSettings(e)} className='mt-2 text-secondary cursor-pointer small_hd'><i className='icon-cog'></i> {app.getLang("advanced_settings")}</div>
        </div>

        {!self.state.headerImages.portrait_landscape_mode?<div className="col-md-5 text-center mb-3">
            <div className={headerImages.app_header_image_landscape?`drag-area w-100 trash-on`:`drag-area w-100`}>
              {headerImages.app_header_image_landscape?<img src={headerImages.app_header_image_landscape}/>:
                <div className="icon">
                  <i className="fas fa-cloud-upload-alt appyslim-network-cloud-upload"></i>
                </div>
              }
              <input type="file" id='imageInput' accept="image/*" width='1136' height='88' data-type="app_header_image_landscape" onChange={(e)=>self.cropingModel(e)}/>
              <a class="fa fa-trash icon-trash" width='1136' height='88' data-type="app_header_image_landscape" onClick={self.removeImage}></a>
            </div> 
              <small className='maxFileSize text-capitalize'>1136x88</small> 
        </div>:null}  

        <div className='col-12 mt-3 landscape_list' style={self.state.landscape_list?{display:'block'}:{display:'none'}}>
          <div className='row'>
            {
              headerImages.headertabletphones.map(function(v,i){
                if(v){
                  let removeId = '';
                  if(v.image){
                    removeId = 'trash-on';
                  }
                  return <div className="col-md-6 text-center mb-3">
                    <div className={`drag-area w-100 ${removeId}`}>
                    {v.image?<img src={v.image}/>:
                        <div className="icon">
                          <i className="fas fa-cloud-upload-alt appyslim-network-cloud-upload"></i>
                        </div>
                      }
                      <input type="file" id='imageInput' accept="image/*" width={v.width} height={v.height} data-type="portrait_landscape_size" onChange={(e)=>self.cropingModel(e)} />
                      <a class="fa fa-trash icon-trash" width={v.width} height={v.height} data-type="portrait_landscape_size" onClick={self.removeImage}></a>
                    </div> 
                    <small className='maxFileSize text-capitalize'>{v.width}x{v.height}</small> 
                  </div> 
                } 
              })
            }
              
          </div>
        </div>
      </div> 
      </div>
      <div class="w-100 d-inline-block pt-2"><button class="btn btn-primary float-end ms-3" onClick={()=>self.save()}>{app.getLang("save")}</button></div>
    </div> 
  }
}

export class CustomUpload  extends React.Component {
  constructor(props) {
    super(props);
  
    this.state = {
      userImages:app.userImages()
    }
    this.getImage = this.getImage.bind(this);
    this.saveImages = this.saveImages.bind(this);
    this.removeImage = this.removeImage.bind(this);
  }
  saveImages(e) {
      let self = this;
      let { userImages } = self.state;
      const file = e.currentTarget.files[0];
      const size = file.size / (1024 * 1024);;

      if(file && file.name.toLowerCase().match(/\.(jpg|jpeg|png|heic|svg)$/) ) {
        if(size>5) {
          alert(app.getLang("maxSize"));
        }
        else {
          const fd = new FormData();
          fd.append("method", "saveCustomImage");
          fd.append("appId", localStorage.getItem("aiAppId"));
          fd.append("customImage", e.currentTarget.files[0]);
    
          app.postForm(fd).then(function(a){
            userImages.push(a); 
            self.setState({
              userImages
            })
            app.userImages(userImages);
          })
        }
      }
      else {
        app.showAlert("danger", app.getLang("onlyAllowedFormats"));
        //alert(app.getLang("onlyAllowedFormats"));
      }
  }
  getImage() {
    const file = ReactDOM.findDOMNode(this).querySelector("#live-file") 
    if (file.value.trim() === "") {
      file.parentElement.classList.add("error-field");
      file.parentElement.classList.remove("valid-field"); 
      errorAlert(app.getLang("validImageUrl"), file)  
      return false;
    }
    if ((file.value.trim().indexOf("__CDN__PATH__") === -1)) {
      file.parentElement.classList.add("error-field");
      file.parentElement.classList.remove("valid-field"); 
      errorAlert(app.getLang("validImageUrl"), file)  
      return false;
    }
    
  }
  removeImage(index) {
    let self = this;
    let { userImages } = self.state;
    if(window.confirm(app.getLang("confirmDelete"))) {
      app.fetchPost({
        "method":"deleteCustomImage",
        "imageId":userImages[index].id
      }).then(function(response){
        userImages.splice(index, 1);
        self.setState({
          userImages
        })
        app.userImages(userImages);
        app.toast(response.msg);
      })
     
    }
  }
  render() {
    let self = this;
    let {userImages} = self.state;
    let showStyle = {display:"none"};
    if(window.location.hash.indexOf("template-") !== -1) {
      showStyle = {};
    }
     
    return <div className={`row ${app.isMobile()}`}>
    <div className="col-md-12">

      <h6 className="mb-3 small_title">
        {app.getLang("custom_upload")} 
      </h6>

      <div className="builder-widget img-upload" style={showStyle}>
        <label>{app.getLang("imageUrl")}</label>
        <div className="text-right ms-auto position-relative">
          <input type="text" className="form-control rounded-0" id="live-file" placeholder="https://path/to/the/image.jpg" />
          <a className="btn fa-duotone fa-check" id="basic-addon2" onClick={self.getImage}></a>
        </div> 
      </div>
      <div className="col-md-12">
        <div className="drag-area">
          <div className="icon">
            <i className="fas fa-cloud-upload-alt appyslim-network-cloud-upload"></i>
          </div>
          <header>{app.getLang("upload")}
          <small className='maxFileSize text-capitalize'>{app.getLang("maxSize")}</small>
          </header>
          <input type="file" id='imageInput' accept="image/*" onChange={self.saveImages} />

        </div>
      </div> 
      <div className='listParent'>
        <ul className="item-list"> 
          {
            userImages.map(function (v, i) {  
              const value  = `${app.config().bucket72}/media/user_space/${localStorage.getItem("aiAppId")}/ai_custom_img/${v.name}`;
              return <li key={'jx-'+i}>
                <input type="image" src={value} value={value} onClick={() => self.props.callback(value)} alt="" />
                <a className="fa fa-trash icon-trash" onClick={() => self.removeImage(i)}></a>
              </li>
            })
          }
        </ul>
        </div>
      </div>
    </div>
  }
}
 
export class ImageCropperModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      file:props.file,  
      width: props.width,
      height: props.height,
      type: props.type,
      croppedImage: ''
    };
    this.cropRef = React.createRef(); // Ref for the Jcrop instance
  } 
  componentDidMount(){ 
    const self = this; 
    app.loadScript("https://cdnjs.cloudflare.com/ajax/libs/jquery-jcrop/2.0.4/js/Jcrop.js", "jcrop-script-ai").then(function(){
      if(self.props.file){
        self.readFileAsBase64(self.props.file).then(base64String => {  
          self.setState({
            base64String
          }) 
        })  
        self.handleImageChange(self.props)
      } 
    })
   

    

    const link = document.createElement('link');
    link.id = 'jcrop-style-ai';  // Add an ID for reference
    link.rel = 'stylesheet';
    link.href = 'https://cdnjs.cloudflare.com/ajax/libs/jquery-jcrop/2.0.4/css/Jcrop.css';
    document.head.appendChild(link);


    
  }

  cleanUpScript() { 
    //  const script1 = document.getElementById('jquery-script-ai');
    //  const script2 = document.getElementById('jcrop-script-ai');
    //  if (script1) {
    //      document.body.removeChild(script1);
    //  }
    //  if (script2) {
    //      document.body.removeChild(script2);
    //  } 
    //  const link = document.getElementById('jcrop-style-ai');
    //  if (link) {
    //      document.head.removeChild(link);
    //  }
  }


  readFileAsBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = function() { 
            const base64String = reader.result;
            resolve(base64String);
        };

        reader.onerror = function(error) {
            reject(error);
        };

        // Check if the input file is a File or Blob object
        if (file instanceof Blob || file instanceof File) {
            reader.readAsDataURL(file);
        } else {
            reject(new Error('Invalid input. Expected Blob or File.'));
        }
    });
}

  handleImageChange = (props) => {
    const { width, height, file, ratio } = props; 
    const reader = new FileReader();
    reader.onload = (event) => {  
        const base64String = event.target.result;
        this.setState({ base64String }); // Ensure base64String is correctly set in state
      
      if (document.getElementById('cropModal')) { 
        window.jQuery(this.cropRef.current).Jcrop({
          boxWidth: 600,
          boxHeight: 400,
          setSelect: [0, 0, width, height],
          aspectRatio: ratio,
          onChange: this.updateCropPreview,
          onSelect: this.updateCropPreview
        });
      }
    };
    reader.readAsDataURL(file);
  };
 
  updateCropPreview = (c) => {
    let self = this;
    if (parseInt(c.w) > 0) {
      const canvas = document.createElement('canvas');
      // canvas.width = self.state.width;
      // canvas.height = self.state.height;

      canvas.width = c.w;   // use crop width
      canvas.height = c.h;  // use crop height

      const ctx = canvas.getContext('2d');
      const image = new Image();

      image.onload = () => {
        // ctx.drawImage(image, c.x, c.y, c.w, c.h, 0, 0, canvas.width, canvas.height);
        ctx.drawImage(image, c.x, c.y, c.w, c.h, 0, 0, c.w, c.h);

        // Generate base64 string from canvas
        const croppedBase64 = canvas.toDataURL('image/png'); // Specify the image format here
        // this.setState({ croppedImage: croppedBase64 });
        this.setState({ croppedImage: croppedBase64, cropWidth: c.w, cropHeight: c.h });
      };
      // Ensure image.src is set correctly
      image.src = this.state.base64String; 
    }
  };

  base64ToBlob = (base64) => {
    const parts = base64.split(';base64,');
    const contentType = parts[0].split(':')[1];
    const base64Data = parts[1];
  
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
  
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
  
    const byteArray = new Uint8Array(byteNumbers);
    //return new Blob([byteArray], { type: contentType });
    return new File([byteArray],  Date.now() + ".png", { type: contentType });
  };

  saveCropImage = () => {
    const { croppedImage, width, height, type } = this.state;

    this.cleanUpScript();

    const blobImage = this.base64ToBlob(croppedImage, "image/png");
    // Send the target width/height the modal was opened with, not Jcrop's
    // actual crop pixels — the backend needs the intended slot size.
    this.props.saveHeaderImages(blobImage, width, height, type);

    ReactDOM.findDOMNode(this).parentElement.remove();
  };

  remove() {
    this.cleanUpScript();
    ReactDOM.findDOMNode(this).parentElement.remove();
  }
  render() { 
    return <div className="modal d-block" id="cropModal" tabIndex="-1" aria-labelledby="cropModalLabel" aria-hidden="true" style={{display:'block'}}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="cropModalLabel">
                  {app.getLang("crop_image")}
                </h5>
                <button type="button" className="close-popup modal-close position-relative fa-sharp icon-cancel icon-cancel" onClick={() => this.remove()}></button> 
              </div>
              <div className="modal-body">
                <div className="crop text-center">
                  <img id="crop_source" src={`${this.state.base64String}`} alt="Cropped Image Preview" className="img-fluid" ref={this.cropRef} />
                </div>
              </div>
              <div className="modal-footer"> 
                <button type="button" className="btn btn-primary" onClick={this.saveCropImage}>
                  {app.getLang("save")}
                </button>
              </div>
            </div>
          </div>
        </div>  
  }
}

 

export class AdminUpload  extends React.Component {
  constructor(props) {
    super(props);
    let images = [];
    if (localStorage.getItem("adminImages")) {
      images = JSON.parse(localStorage.getItem("adminImages"));
    }
    this.state = {
      images
    }
    this.getImage = this.getImage.bind(this);
    this.saveImages = this.saveImages.bind(this);
    this.removeImage = this.removeImage.bind(this);
  }
  saveImages(e) {
      let self = this;
      let { images } = self.state;
      const obj = e.currentTarget;
      const fileSize = 5 * 1024 * 1024;
      if(obj.files) {
        if(obj.files[0]) {
          const file = obj.files[0];
          if(file.size < fileSize) {
            const reader = new FileReader(); 
            reader.onload = (theFile) => { 
              const name = file.name.toLowerCase().replace(/ /g, '-');
              const path = `samples/${name}`;
              app.fetchBuilder({
                method:"saveImage",
                data:theFile.target.result,
                path
              }).then(function(response){
                self.setState({
                  images:[...images, `https://mediadirhub.com/${path}`]
                })
              })
            }; 
            reader.readAsDataURL(file);
          }
        }
      }
  }
  getImage() {
    const file = ReactDOM.findDOMNode(this).querySelector("#live-file") 
    if (file.value.trim() === "") {
      file.parentElement.classList.add("error-field");
      file.parentElement.classList.remove("valid-field"); 
      errorAlert(app.getLang("validImageUrl"), file)  
      return false;
    }
    if ((file.value.trim().indexOf("__CDN__PATH__") === -1)) {
      file.parentElement.classList.add("error-field");
      file.parentElement.classList.remove("valid-field"); 
      errorAlert(app.getLang("validImageUrl"), file)  
      return false;
    }
   
  }
  removeImage(index) {
    let self = this;
    let { images } = self.state;
    if(window.confirm(app.getLang("confirmDelete"))) {
      app.fetchBuilder({
        method:"removeImage",
        path:images[index].replace("https://mediadirhub.com/", "")
      }).then(function(response){
        images.splice(index, 1);
        self.setState({
          images
        })
        app.toast(response.message);
      })
    }
  }
  render() {
    let self = this;
    let {images} = self.state;
    let showStyle = {display:"none"};
    if(window.location.hash.indexOf("template-") !== -1) {
      showStyle = {};
    }
    return <div className={`row ${app.isMobile()}`}>
    <div className="col-md-12">

      <h6 className="mb-3">{app.getLang("custom_upload")}</h6>

      <div className="builder-widget img-upload" style={showStyle}>
        <label>{app.getLang("imageUrl")}</label>
        <div className="text-right ms-auto position-relative">
          <input type="text" className="form-control rounded-0" id="live-file" placeholder="https://path/to/the/image.jpg" />
          <a className="btn fa-duotone fa-check" id="basic-addon2" onClick={self.getImage}></a>
        </div> 
      </div>
      <div className="col-md-12">
        <div className="drag-area">
          <div className="icon">
            <i className="fas fa-cloud-upload-alt appyslim-network-cloud-upload"></i>
          </div>
          <header>{app.getLang("upload")}</header>
          <input type="file" id='imageInput' accept="image/*" onChange={self.saveImages} />
        </div>
      </div> 

      <div className='listParent'>
        <ul className="item-list"> 
          {
            images.map(function (v, i) { 
              return <li>
                <input type="image" src={v} value={v} onClick={() => self.props.callback(v)} alt="" />
                <a className="fa fa-trash icon-trash" onClick={() => self.removeImage(i)}></a>
              </li>
            })
          }
        </ul>
        </div>
      </div>
    </div>
  }
}

export class IconList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: "",
    };
  }
  handleSearchChange = (e) => {
    this.setState({ searchTerm: e.target.value.toLowerCase() });
  };
  render() {
    let self = this;
    return <React.Fragment>
      <input type="text" className='form-control py-3 mb-3' placeholder={app.getLang("searchIcons")} value={ self.state.searchTerm} onChange={this.handleSearchChange}/>
      <div className="icon-list">
      {
        icons.map(function (v) {
          return <button className={`iconbtn ${v}`} onClick={() => self.props.callback(v)} style={{display:v.toLowerCase().includes(self.state.searchTerm) || self.state.searchTerm === ""? "block": "none",}}></button>

        })
      }
    </div>
    </React.Fragment>
  }
}

export class IconForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data, 
      index: props.index
    } 
    this.linkPopup = this.linkPopup.bind(this); 
  }
  componentWillReceiveProps(props) {
    this.setState({
      data: props.data 
    })
  } 
  linkPopup() {
    let self = this;
    let { data } = this.state;
    let link = data.properties.link
    linkPopup(link,'', function (url) {
      data.properties.link = url;
      if(url.indexOf("javascript:opendeeplinkpage") !== -1) {
        data.properties.target = false;
      } 
      self.props.callback("link", url)
    },null, data) 
  } 
  render() {
    let self = this; 
    let { data, index } = this.state; 
    let langSettings = app.getConfig().languageSettings;
 

    return <div className='mt-3'>   
        {data.properties.iconStatic !== true || data.properties.iconStatic == undefined?
              <div className="builder-widget align-items-center">
                <label>{langSettings.link}</label>
                <div className="text-right ms-auto position-relative border-bottom d-flex">
                  <input type="text" className="form-control border-0" value={data.properties.link ? data.properties.link : ''} placeholder="https://example.com/" id="link" data-index={index} data-type="link" onInput={self.update} onClick={self.linkPopup} readOnly/>
                  <button className="target-setting input-group-text border-0 bg-white ic_ai_icon_game_setting_8" onClick={self.linkPopup}></button>
                </div>
              </div>
        :null}

        {data.properties.iconStatic !== true || data.properties.iconStatic == undefined? 
          <div className="d-flex builder-widget align-items-center pt-2 pb-2">
            <div className="form-check">
              <input className="form-check-input" type="checkbox" checked={data.properties.target} placeholder=" " id="target" data-type="target" data-index={index} onChange={(e)=>self.props.callback("target", !data.properties.target)}/>
              <label className="form-check-label" for="target">
                {langSettings.open_in_new_window}
              </label>
            </div>  
          </div>
        :null}
    </div>
  }
}
 
 
export const SwiperHeader = (props) => {
  let {slidesPerView, spaceBetween, id, className, callback, data} = props
  useEffect(() => {
    // Load Swiper script only once
    app.loadScript(`https://media.mediadirhub.com/js/swiper.min.js`, "swiper-js")
    .then(() => { 
      if (typeof Swiper !== 'undefined') {
        setTimeout(function(){
          new window.Swiper(`.${id}`, {
            slidesPerView:slidesPerView,
            spaceBetween: Number(spaceBetween),
            grabCursor: true,
            mousewheel: true,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
          });
        },2000) 
      } else {
        console.error("Swiper is not defined.");
      }
    })
    .catch((error) => {
      console.error("Failed to load Swiper script:", error);
    }); 
  }, [data]); // Empty dependency array means this effect runs once on mount

   
  let layout = [1, 2, 3];
  let identity = "header";
  if(id === "footerLayout"){
    layout = [1, 2];
    identity = "footer";
  }
  return (
    <div className={`position-relative container-row itemNavSwiper ${className}`}> 
        <div className={`position-relative swiper ${id}`}>
          <ul className='swiper-wrapper p-0 m-0'>
            
              {layout.map((v) => {
                // Calculate `active` class before returning JSX
                const active = data == v ? "active" : ""; 
                return (
                <li className={`swiper-slide ${active}`} key={v} data-type={v} onClick={(e)=>callback(v)}>
                  <img className='w-100' src={`https://media.mediadirhub.com/layouts/${identity}/layout-${v}.png`} alt={`Layout ${v}`} />
                </li>
                );
              })}
          </ul>
        </div>
        <div className="swiper-button-next"></div>
        <div className="swiper-button-prev"></div>
    </div>
  );
};


export class NavForm extends React.Component {
  constructor(props) {
    super(props); 
    this.state = {
      data: props.data,
      index: props.index
    }  
    this.updateNav = this.updateNav.bind(this);  
  }
  componentWillReceiveProps(props) {
    this.setState({
      data: props.data,
      index: props.index
    })
  } 
 
  componentDidMount(){
    app.loadScript(`https://media.mediadirhub.com/js/swiper.min.js`, "swiper-js")
    .then(() => {
      // console.log("window.Swiper", window.Swiper)
      // Ensure Swiper is defined
      if (typeof Swiper !== 'undefined') {
        new window.Swiper(".itemNavSwiper .swiper", {
          slidesPerView: "3",
          spaceBetween: 4,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });
      } else {
        console.error("Swiper is not defined.");
      }
    })
    .catch((error) => {
      console.error("Failed to load Swiper script:", error);
    }); 
  } 

  updateNav(e) { 
    let self = this;
    let { data } = this.state;
    let event =  e.currentTarget; 
    document.querySelectorAll('.menuItem li').forEach(function(v,i){
      v.classList.remove('active')
    }) 
    e.currentTarget.classList.add('active')
    let type = event.getAttribute('data-type');  
    let holdKeys = {};
    if(data.properties["customMenu"] !== undefined) {
      submenuColors.forEach(function(v){
        holdKeys[v.key] = data.properties[v.key];
      })
    }

    data.layoutType = type; 
    data.properties = data[type].properties;

    Object.keys(holdKeys).forEach(function(v){
      data.properties[v] = holdKeys[v];
    });
    
    self.props.layoutUpdate(data) 
  } 
  
  render() {
    let self = this; 
    let { data, index } = this.state; 
    // console.log("asdasdasdsa", data, index) 
    let langSettings = app.getConfig().languageSettings; 
     return <div className="col-12 px-3 my-2 mt-3"> 
                  {/* <label className="form-check-label mb-2 w-100 d-flex">{langSettings.menuThemes}</label> */}
                  <div className='position-relative itemNavSwiper'>
                  <div className='position-relative swiper mx-3'>
                      <ul className='menuItem swiper-wrapper'> 
                      {
                        [7,6,5,4,3,2,1].map(function(v){
                          let activeClass = "";
                          let activeLayout = ""
                          if(data.layoutType){
                            activeLayout = data.layoutType.replaceAll("layout_", "");
                          } 
                         
                         if(v == activeLayout){
                          activeClass = "active";
                         } 
                          if(v === 2){
                            return <li className={`swiper-slide ${activeClass}`} data-type={'layout_'+(v)} onClick={self.updateNav}><div className='d-flex align-items-center justify-content-center'><span>Aa</span><span>Bb</span></div></li>
                          }
                          return <li className={`swiper-slide ${activeClass}`} data-type={'layout_'+(v)} onClick={self.updateNav}><span>Aa</span><span>Bb</span></li>
                          
                        })
                      } 
                      </ul> 
                  
              </div>
              <div class="swiper-button-next"></div>
              <div class="swiper-button-prev"></div>
              </div> 
            </div>  
  }
}

export class HeaderIconsForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data, 
      index: props.index
    }
    this.clickIcon = this.clickIcon.bind(this); 
    this.linkPopup = this.linkPopup.bind(this);
    this.updateCorners = this.updateCorners.bind(this);
    this.update = this.update.bind(this);
  }
  componentWillReceiveProps(props) {
    this.setState({
      data: props.data 
    })
  }
  clickIcon() { 
    let self = this; 
    let { data } = this.state; 
    const div = document.createElement("div");
    document.body.appendChild(div);
    ReactDOM.render(<Modal title={app.getLang("selectIcon")}> 
      <IconList callback={function(v){ 
        self.props.callback('iconCode', v) 
        document.querySelector("#icon").click();
        document.querySelector(".modal .modal-close").click();
      }} />
    </Modal>, div);
  }
 
  updateCorners(value){  
    let self = this;  
    if(app.getDevice()){
      self.props.callback('cornersWeb', value.toString()) 
    }else{
      self.props.callback('corners', value.toString()) 
    }
  }
  linkPopup() {
    let self = this;
    let { data } = this.state;
    let link = data.properties.link
    linkPopup(link,'', function (url) {
      data.properties.link = url;
      if(url.indexOf("javascript:opendeeplinkpage") !== -1) {
        data.properties.target = false;
      }
      // else {
      //   data.properties.target = true;
      // }
      self.props.callback("link", url)
    },null, data) 
  }
  update(e) { 
    let self = this; 
    let event =  e.currentTarget;  
    let type = event.getAttribute('data-type');    
    self.props.callback(type, event.value)  
  } 
  render() {
    const self = this; 
    let { data, index } = this.state;  
    let icons = data.icons; 
    const iconElements = [];

    for (const key in icons) {
      const icon = icons[key];
      // console.log("icon", icon)
      let actionType = <button iconid={key} id={key} className={`iconbtn ${icon.iconCode}`} value={icon.iconCode} onClick={function(e){
        let ids = e.target.getAttribute("iconid");
        app.imagePopup(icon.iconCode, function(type, src){ 
          self.props.callback(ids, type, src);
        }, 'iconCode')
      }}></button>;

     if(icon.iconCode.indexOf('https://') !== -1){  
        actionType = <button iconid={key} id={key} className={`iconbtn btn-outline-secondary btn-image-select img-style`} style={{background: `url(${icon.iconCode}) no-repeat 0 0 / cover`}} onClick={function(e){
          let ids = e.target.getAttribute("iconid");
          app.imagePopup(icon.iconCode, function(type, src){
            self.props.callback(ids, type, src);
          }, 'iconCode')
        }}></button>;
    }

    let listItem = <li className={`input-group mw-100 d-flex justify-content-between ${app.iconsFilter(key)}`} key={key}  > 
    <input type="button" id={icon.iconCode} value={icon.iconCode} style={{ display: "none" }} />
    {actionType}
    
    <div className={`textInput border-0 position-relative d-flex align-items-center w-100 ${app.iconsFilter(key)}`}>
        {self.props.langSettings[key]}
    </div>  
    <div className={`form-check form-switch d-none`}>
  <input className="form-check-input p-0 border" iconid={key} type="checkbox" defaultChecked={icon.showWeb} onClick={function(event){
    let ids = event.target.getAttribute("iconid");
    self.props.callback(ids, "showWeb", event.currentTarget.checked);
  }} />
</div>

  </li>

    if(app.getDevice()){
      if(icon.iconName == "Location" || icon.iconName == "Notification" || icon.iconName == "Cart"){
        if(icon.showWeb !== false) {
          iconElements.push(
            listItem
          );
        }
      }
    }else{
      iconElements.push(
        listItem
      );
    }
      
    }

    return <div className="builder-widget align-items-center upload-assest mb-3"> 
          <ul className="social-widget p-0 m-0">{iconElements}</ul>
        </div>  
  }
}

export class ListForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data, 
      index: props.index
    }
    this.clickIcon = this.clickIcon.bind(this); 
    this.addMore = this.addMore.bind(this);
    this.remove = this.remove.bind(this);
    this.updateData = this.updateData.bind(this);
  }
  componentWillReceiveProps(props) {
    this.setState({
      data: props.data 
    })
  }

  updateData(value, index) { 
    let self = this;  
    const data  = self.state.data;
    data.data[index].text = value;
    self.props.callback(data);
  }

  clickIcon(index) {
    let self = this;
    let { data } = this.state;
    // app.imagePopup already gives Icons / Library / Custom Upload tabs whenever
    // it is handed a type, so it replaces the bare IconList modal that used to
    // open here — same call HeaderIconsForm makes. It also closes itself, so
    // there is no .modal-close click to fire.
    app.imagePopup(data.data[index].icon, function (key, value) {
      // Images.update has no else, so it fires the callback twice: once with the
      // type we passed and once with "src". Acting only on ours keeps this to a
      // single state write instead of two saves and two undo entries.
      if (key !== "icon") return;
      const current = self.state.data;
      const newData = { ...current };
      newData.data[index].icon = value;
      self.setState({ data: newData });
      self.props.callback(newData);
    }, "icon");
  }

  addMore() {
    console.log("add more");
    this.setState((prevState) => {
      const newData = { ...prevState.data };
      newData.data.push({
        icon: prevState.data.data[0].icon,
        text: prevState.data.data[0].text,
      });
      this.props.callback(newData);
      return { data: newData };
    });
  }

  remove(index) {
    const data  = this.state.data;
    const newData = { ...data };
    newData.data.splice(index, 1);
    this.setState({ data: newData });
    this.props.callback(newData);
  }


  render() {
    const self = this; 
    let { data, index } = this.state;  

    let rowDisable = false
    if(data.data.length === 1){
      rowDisable = "pointer-none"
    } 


    const listItems = data.data.map((v, i) => {
      return <li className="input-group mw-100 d-flex justify-content-between" key={`list${i}`} > 
        {/* A Library or Custom Upload pick is a URL, which cannot go in
            className — same branch HeaderIconsForm uses for iconCode. */}
        {String(v.icon || "").indexOf("https://") !== -1
          ? <button className="iconbtn btn-outline-secondary btn-image-select img-style"
                    value={v.icon}
                    style={{background: `url(${v.icon}) no-repeat 0 0 / cover`}}
                    onClick={() => self.clickIcon(i)}></button>
          : <button className={`iconbtn ${v.icon}`} value={v.icon} onClick={() => self.clickIcon(i)}></button>}
        <div className="position-relative d-flex align-items-center w-100">
              <input type="text" className="form-control border-0" value={v.text} onChange={(e) => self.updateData(e.target.value , i)}/>
              <button type="button" disabled={rowDisable} className={`input-group-text ic_ai_icon_delete_9 text-danger ${rowDisable}`} onClick={() => self.remove(i)}></button>
        </div>
        
      </li>
    })

    return <div className="builder-widget"> 
        <ul className="social-widget p-0 m-0">
          {listItems}
          <li className='input-group mw-100 border-0 d-flex justify-content-between my-3'>
            <a className='btn btn-sm btn-link text-uppercase ms-auto' onClick={self.addMore}>Add more</a>
          </li>
        </ul>
    </div>  
  }
}


export function TagsForm({ data: initialData, index, callback }) {
  const [data, setData] = useState(initialData);

  useEffect(() => {
    setData(initialData);
  }, [initialData]);

  const updateData = (value, i) => {
    const updatedData = { ...data };
    updatedData.data[i].text = value;
    setData(updatedData);
    callback(updatedData);
  };

  

  const addMore = () => {
    const newData = { ...data };
    const template = data.data[0] || { icon: '', text: '' };
    newData.data.push({
      icon: template.icon,
      text: template.text,
    });
    setData(newData);
    callback(newData);
  };

  const remove = (i) => {
    const newData = { ...data };
    newData.data.splice(i, 1);
    setData(newData);
    callback(newData);
  };

  const rowDisable = data.data.length === 1 ? 'pointer-none' : '';

  return (
    <div className="builder-widget">
      <ul className="social-widget p-0 m-0">
        {data.data.map((v, i) => (
          <li className="input-group mw-100 d-flex justify-content-between" key={`list${i}`}>
            <div className="position-relative d-flex align-items-center w-100">
              <input
                type="text"
                className="form-control border-0 p-2"
                value={v.text}
                onChange={(e) => updateData(e.target.value, i)}
              />
              <button
                type="button"
                disabled={data.data.length === 1}
                className={`input-group-text ic_ai_icon_delete_9 text-danger ${rowDisable}`}
                onClick={() => remove(i)}
              ></button>
            </div>

            
          </li>
        ))}
        <li className="input-group mw-100 border-0 d-flex justify-content-between my-3">
          <a className="btn btn-sm btn-link text-uppercase ms-auto" onClick={addMore}>
            Add more
          </a>
        </li>
      </ul>
    </div>
  );
}
export function SkillsForm({ data: initialData, index, callback }) {
  const [data, setData] = useState(initialData);

  useEffect(() => {
    setData(initialData);
  }, [initialData]);

  const updateData = (value, i) => {
    const updatedData = { ...data };
    updatedData.data[i].text = value;
    setData(updatedData);
    callback(updatedData);
  };

  const updateLevel = (value, i) => {
    const updatedData = { ...data };
    updatedData.data[i].level = value;
    setData(updatedData);
    callback(updatedData);
  };

  const addMore = () => {
    const newData = { ...data };
    const template = data.data[0] || { icon: '', text: '' };
    newData.data.push({
      icon: template.icon,
      text: template.text,
    });
    setData(newData);
    callback(newData);
  };

  const remove = (i) => {
    const newData = { ...data };
    newData.data.splice(i, 1);
    setData(newData);
    callback(newData);
  };

  const rowDisable = data.data.length === 1 ? 'pointer-none' : '';

  return (
    <div className="builder-widget">
      <ul className="social-widget p-0 m-0">
        {data.data.map((v, i) => (
          <li className="input-group mw-100 d-flex justify-content-between" key={`list${i}`}>
            <div className="position-relative d-flex align-items-center w-100">
              <input
                type="text"
                className="form-control border-0 p-2"
                value={v.text}
                onChange={(e) => updateData(e.target.value, i)}
              />
              <button
                type="button"
                disabled={data.data.length === 1}
                className={`input-group-text ic_ai_icon_delete_9 text-danger ${rowDisable}`}
                onClick={() => remove(i)}
              ></button>
            </div>

            <div className="position-relative d-flex align-items-center w-100">
              <input
                type="range"
                className="form-range p-0"
                value={v.level}
                onChange={(e) => updateLevel(e.currentTarget.value, i)}
              />
            </div>
          </li>
        ))}
        <li className="input-group mw-100 border-0 d-flex justify-content-between my-3">
          <a className="btn btn-sm btn-link text-uppercase ms-auto" onClick={addMore}>
            Add more
          </a>
        </li>
      </ul>
    </div>
  );
}


const ContactFormSetting = function({data, rootUpdate, langUpdates}) {
  const langItems = [];
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
  if(data.lang){
    for(var key in data.lang){ 

      let label = "";
      const labelsMap = {
        mail_subject: "Email Subject",
        required_fields: "Required Fields (Error Message)",
        valid_email: "Valid Email Address (Error Message)",
        valid_phone: "Valid Phone Number (Error Message)",
        thanks_msg: "Email Thanks Message",
      }
      label = labelsMap[key];
      langItems.push(
        <li className="list-group-item px-0 d-flex align-items-center pt-0 flex-wrap pt-0">
          <label className="mb-0 mt-3">{label}</label>
          <input className='form-control border-0 form-control-sm px-0' defaultValue={data.lang[key]} data-key={key} data-type="shortform" onInput={langUpdates}/>
         </li>
      );
    }
  }
  return <> 
    <div className="flex-wrap form-check form-switch hide-list">
      <label>Email for Inquiries</label>
      <div className="w-100">
          <input type="text" defaultValue={data.properties.email} className="form-control mt-0" placeholder="Email for Inquiries" onBlur={function(event){
            if(emailRegex.test(event.target.value)) {
              rootUpdate("email", event.target.value);
              event.target.removeAttribute("style");
            }
            else {
              rootUpdate("email", "");
              event.target.style.border = "solid  1px red";
            }
          }}/>
      </div>
    </div>

    <div className="flex-wrap form-check form-switch hide-list pt-0">
      <ul className="list-group list-group-flush w-100">
        {/* <label>Email Subject and Success Message</label> */}
        {langItems}
      </ul>
    </div>
    </>
}

export class MenuForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data, 
      index: props.index
    }
    this.clickIcon = this.clickIcon.bind(this); 
    this.linkPopup = this.linkPopup.bind(this);
    this.updateCorners = this.updateCorners.bind(this);
    this.update = this.update.bind(this);
  }
  componentDidMount() {
    const nestedSortables = document.querySelectorAll(".menu-list .list-group")
    for (var i = 0; i < nestedSortables.length; i++) {
      new window.Sortable(nestedSortables[i], {
        handle: '.handle',
        group: 'nested',
        animation: 150,
        fallbackOnBody: true,
        swapThreshold: 0.65
      });
    }
  }
  componentWillReceiveProps(props) {
    this.setState({
      data: props.data 
    })
  }
  clickIcon() { 
    let self = this; 
    let { data } = this.state; 
    const div = document.createElement("div");
    document.body.appendChild(div);
    ReactDOM.render(<Modal title={app.getLang("selectIcon")}> 
      <IconList callback={function(v){ 
        self.props.callback('iconCode', v) 
        document.querySelector("#icon").click();
        document.querySelector(".modal .modal-close").click();
      }} />
    </Modal>, div);
  }
 
  updateCorners(value){  
    let self = this;  
    if(app.getDevice()){
      self.props.callback('cornersWeb', value.toString()) 
    }else{
      self.props.callback('corners', value.toString()) 
    }
  }
  linkPopup() {
    let self = this;
    let { data } = this.state;
    let link = data.properties.link
    linkPopup(link,'', function (url) {
      data.properties.link = url;
      if(url.indexOf("javascript:opendeeplinkpage") !== -1) {
        data.properties.target = false;
      }
      // else {
      //   data.properties.target = true;
      // }
      self.props.callback("link", url)
    },null, data) 
  }
  update(e) { 
    let self = this; 
    let event =  e.currentTarget;  
    let type = event.getAttribute('data-type');    
    self.props.callback(type, event.value);
  } 
  render() {
    let self = this; 
    let { data, index } = this.state;  
    return <div className="menu-list">
      <ul className="list-group">
        {
          data.data.map(function(v){
            const items = v.data.map(function(val){
              const subItems = v.data.map(function(value){
                return  <li className="list-group-item d-flex">
                <span className="handle">{svgIcon["drag"]}</span>
                <div>{value.text}</div>
                </li>
              })
              return  <li className="list-group-item d-flex flex-wrap">
              <span className="handle">{svgIcon["drag"]}</span>
              <div>{val.text}</div>
              <ul className="list-group flex-grow-1">{subItems}</ul>
              </li>
            })
            return  <li className="list-group-item d-flex flex-wrap">
            <span className="handle">{svgIcon["drag"]}</span>
            <div>{v.text}</div>
            <ul className="list-group flex-grow-1">{items}</ul>
            
            </li>
          })
        }
        </ul>
    </div>

    const listItems = data.data.map(function(v, i){
      return <li className="input-group mw-100 d-flex justify-content-between" key={`list${i}`} > 
        <button className={`iconbtn ${v.icon}`} value={v.icon}></button>
        <div className="position-relative d-flex align-items-center w-100">
              <input type="text" className="form-control border-0" defaultValue={v.text} />
        </div>
      </li>
    })

    return <div className="builder-widget align-items-center upload-assest mb-3"> 
        <ul className="social-widget p-0 m-0">{listItems}</ul>
    </div>  
  }
}

export class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.remove = this.remove.bind(this);
  }
  remove() {
    ReactDOM.findDOMNode(this).parentElement.remove();
  }
  render() {
    return <div className="modal" style={{ display: "block" }}>
      <div className="modal-dialog modal-dialog-scrollable modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{this.props.title}</h5>
            <button type="button" className="btn-close modal-close close-popup position-relative fa-sharp icon-cancel" onClick={this.remove}></button>
          </div>
          <div className="modal-body">
            {this.props.children}
          </div>
        </div>
      </div>
    </div>
  }
}

export class ModalAlert extends React.Component {
  constructor(props) { 
    super(props);
    this.remove = this.remove.bind(this);
  }
  remove() {
    ReactDOM.findDOMNode(this).parentElement.remove();
  }
  render() {
    return <div className="modal alert-modal" style={{ display: "block" }}>
      <div className="modal-dialog">
          <div className="modal-content">
          <div className="modal-header">
              <h5 className="modal-title">{app.getLang("alert")}</h5>
              <button type="button" className="btn-close" onClick={this.remove}></button>
          </div>
          <div className="modal-body">
              <p>{app.getLang("notSupportedInSimulation")}</p>
          </div>
          <div className="modal-footer justify-content-center">
              <button type="button" className="btn btn-dark" onClick={this.remove}>Ok</button>
          </div>
          </div>
      </div>
  </div>

  }
}

export class Modal2 extends React.Component {
  constructor(props) {
    super(props);
    this.remove = this.remove.bind(this);
    this.save = this.save.bind(this);
  }
  remove() {
    ReactDOM.findDOMNode(this).parentElement.remove();
  }
  save() {
    this.props.callback();
  }
  render() {
    let self = this;
    return <div className="modal" style={{ display: "block" }}>
      <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{this.props.title}</h5>
            <button type="button" className="btn-close modal-close close-popup position-relative fa-sharp icon-cancel" onClick={this.remove}></button>
          </div>
          <div className="modal-body">
            {this.props.children}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-primary" onClick={self.save}>{app.getLang("save")}</button>
          </div>
        </div>
      </div>
    </div>
  }
}


export class AiModal extends React.Component {
  constructor(props) {
    super(props);
    this.remove = this.remove.bind(this);
    this.createText = this.createText.bind(this);
    this.setText = this.setText.bind(this);
    this.userText = this.userText.bind(this);
    this.setPayment = this.setPayment.bind(this);
    this.state = {
      data:[],
      paymentMode:false,
      totalCredit:app.getTotalCredit(),
      isReseller:app.isReseller(),
      notfiyObj: {
        notifyQuanity:'',
        pricePerNotfiy:0.0050,
        reqFunds:100,
        avalFund:10,
        taxAmt:5,
        totalAmt:'',
        currency:'$',
        totalCredit:"",
        aiText:""
      }
      
    }
    
  }

  componentDidMount(){
    const self = this;
    app.getPrice("getExtraUsages", {
      userId:localStorage.getItem("userId")
    }).then(function(response){ 
      console.log(response);
      if(response.data){
        const {data, purchasedItemBalance} = response;
        let credit = (data.giftedItem + purchasedItemBalance.balance) - data.totalusage;
        //const credit = (data.giftedItem) - data.totalusage;
        if(purchasedItemBalance.isReseller === "true") {
          credit = purchasedItemBalance.balance;
        }
        localStorage.setItem("textTotalCredit", credit);
        localStorage.setItem("isReseller", purchasedItemBalance.isReseller);
        //localStorage.setItem("textTotalCredit", 0);
        self.setState({
          totalCredit:app.getTotalCredit(),
          isReseller:app.isReseller()
        });
      }
    })
  }
 
  remove() {
    ReactDOM.findDOMNode(this).parentElement.remove();
  }
  setPayment() {
    this.setState({
      paymentMode:true
    })
    //ReactDOM.findDOMNode(this).parentElement.remove();
  }
  createText(text) {
    const self = this;
    app.textGeneration(text).then(function(response){
      console.log(response);
      if(response.status === "failure") {
        //alert(response.message);
        if(response.message === "no available balance") {
          if(response.isReseller) {
            self.setState({
              paymentMode:false,
              isReseller:true
            })
          }
          else {
            self.setState({
              paymentMode:true
            })
          }
        }
      }
      else {
        self.setState({
          totalCredit:app.getTotalCredit(-1),
          data:[response.text]
        });
      }
     
    });
    // fetch("https://api.mediadirhub.com/fetch-gpt", {
    //   method:"POST",
    //   body:JSON.stringify({
    //     "method": "getText",
    //     "text":text
    //   })
    // }).then(function(response){
    //   response.text().then(function(response){
    //     //data.push(response);
    //     self.setState({
    //       data:[response]
    //     })
    //   })
    // })
  }

  setText(type, text) {
    if(type === "paragraph") {
      const value = document.querySelector("#describeTextarea").value.trim();
      if(value === "") {
        app.showAlert("danger", app.getLang("writeTopic"));
        return false;
      }else{
         this.createText("Generate paragraph for " +value)
      } 
    }
    else {
      this.createText(`"${text}" makeThis ${type}`);
    }
  }
  userText(text) {
    const self = this;
    if(window.aiElementInfo.grid) {
      app.getDom().querySelector(`#${window.aiElementInfo.id}[data-index="${window.aiElementInfo.index}"][data-id="${window.aiElementInfo.gridId}"][data-grid="${window.aiElementInfo.grid}"]`).innerHTML = text;
    }
    else {
      app.getDom().querySelector(`#${window.aiElementInfo.id}[data-index="${window.aiElementInfo.index}"]`).innerHTML = text;
    }
    ReactDOM.findDOMNode(self).parentElement.remove();
    setTimeout(function(){
      self.props.update();
    }, 100);
  }

  handlePrice = (value) => {
    const {notfiyObj} = this.state;
    const getReqFund = value * notfiyObj.pricePerNotfiy;
    console.log(getReqFund,notfiyObj.avalFund);
    const getTotal = getReqFund + notfiyObj.taxAmt;

    this.setState(prevState=>({
      notfiyObj:{
        ...prevState.notfiyObj,
        notifyQuanity:Math.floor(value),
        reqFunds:getReqFund,
        totalAmt:getTotal
      }
    }))
  };

  closeTextGenModal = (credit)=>{
    console.log(credit);
    this.setState({
      paymentMode:false,
      totalCredit:app.getTotalCredit(credit),
    });
  }
  handleChange = (e)=>{
    const {value} = e.target;
    this.setState({aiText:value.trim()})
  }
  
  render() {
    const self = this;
    const {data,notfiyObj,paymentMode,totalCredit,aiText, isReseller} = self.state;


    let placeholderText = app.getLang("writeTopic");

    let generateButton =  <a className={`btn btn-primary gen-btn rounded-pill ${aiText ? "":"disabled"}`} onClick={() => self.setText("paragraph")}>
    <svg xmlns="http://www.w3.org/2000/svg" width="26.909" height="26.375" viewBox="0 0 26.909 26.375">
<path id="Union_28" data-name="Union 28" d="M6.12,15.931a11.008,11.008,0,0,0,7.463-3.56A12.72,12.72,0,0,0,16.53,5.909l.054-.574c.967,10.329,10.326,10.6,10.326,10.6-9.982,1.028-10.338,10.444-10.338,10.444C15.877,16.582,6.12,15.931,6.12,15.931ZM0,9.568A4.684,4.684,0,0,0,3.179,8.051,5.412,5.412,0,0,0,4.432,5.3l.024-.245a4.671,4.671,0,0,0,4.4,4.512,4.733,4.733,0,0,0-4.4,4.448A4.794,4.794,0,0,0,0,9.568ZM7.577,3.514a3.646,3.646,0,0,0,2.475-1.182A4.228,4.228,0,0,0,11.029.191L11.047,0A3.638,3.638,0,0,0,14.47,3.514a3.685,3.685,0,0,0-3.428,3.463A3.733,3.733,0,0,0,7.577,3.514Z" fill="#fff"/>
</svg>
{app.getLang("generate")}</a>;

let hideBtns = "";

if(totalCredit === 0) {

  generateButton =  <a className={`btn btn-primary gen-btn rounded-pill`} onClick={self.setPayment}>
    <svg xmlns="http://www.w3.org/2000/svg" width="26.909" height="26.375" viewBox="0 0 26.909 26.375">
<path id="Union_28" data-name="Union 28" d="M6.12,15.931a11.008,11.008,0,0,0,7.463-3.56A12.72,12.72,0,0,0,16.53,5.909l.054-.574c.967,10.329,10.326,10.6,10.326,10.6-9.982,1.028-10.338,10.444-10.338,10.444C15.877,16.582,6.12,15.931,6.12,15.931ZM0,9.568A4.684,4.684,0,0,0,3.179,8.051,5.412,5.412,0,0,0,4.432,5.3l.024-.245a4.671,4.671,0,0,0,4.4,4.512,4.733,4.733,0,0,0-4.4,4.448A4.794,4.794,0,0,0,0,9.568ZM7.577,3.514a3.646,3.646,0,0,0,2.475-1.182A4.228,4.228,0,0,0,11.029.191L11.047,0A3.638,3.638,0,0,0,14.47,3.514a3.685,3.685,0,0,0-3.428,3.463A3.733,3.733,0,0,0,7.577,3.514Z" fill="#fff"/>
</svg> {app.getLang("addFunds")}</a>;
if(isReseller) {
  generateButton = <p className="text-left" style={{color:"red"}}><b>Insufficient Credits</b>. Please contact your admin to add funds. </p>;
  hideBtns = "d-none"
}

}


   

    return <div className="modal modal-payment" style={{ display: "block" }}>

      {paymentMode ?  
      <TextGenModal handlePrice={self.handlePrice} notfiyObj={notfiyObj} closeTextGenModal={this.closeTextGenModal}/>
      :
      <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered ai-text-modal modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title"> {app.getLang("aiTextCreator")} <small className='ms-1 fw-normal'>({totalCredit} {app.getLang("credits")} )</small></h5>
            <button type="button" className="btn-close modal-close close-popup position-relative fa-sharp icon-cancel" onClick={this.remove}></button>
          </div>
          <div className="modal-body">
          <div className="ai_modal_wrapper h-100">
              
                   
                     <div className='row h-100'>
                      <div className='col-lg-6 pe-lg-4 mb-3 mb-lg-0'>
                        <p>{app.getLang("describeDescription")}</p>
                        <textarea id="describeTextarea" className="form-control my-4" placeholder={placeholderText} onChange={this.handleChange} style={{height:'120px'}}></textarea>
                       {generateButton}
                      </div>
                      <div className={`col-lg-6 border-start ps-lg-4 d-flex align-items-center ${data.length ? '':""}`}>
                      {data.length?<div> 
                      <div className="generator-list"> 
                      {
                        data.map(function(v){
                          return  <div className="">
                          <p className="ai-result m-0">{v}</p>
                           <button className="btn btn btn-outline-primary rounded-pill  mt-2" onClick={() => self.userText(v)}>  {app.getLang("useText")}</button>
                           <hr className='my-3'/>
                           <div className={`buttons-list ${hideBtns}`}>
                            <button className={`btn btn-outline-secondary btn-sm me-1 p-2 ${aiText ? "":"disabled"}`} onClick={() => self.setText("paragraph")}>{app.getLang("regenerate")}</button>
                             {
                               [{key:"simple",value:app.getLang("simplifyLanguage")},{key:"shorter",value:app.getLang("makeShorter")},{key:"heading",value:app.getLang("convertToHeading")}].map(function(val){
                                return <button className="btn btn-outline-secondary btn-sm me-1 p-2" onClick={() => self.setText(val.key, v)}>{val.value}</button>
                               })
                             }  
                           </div>
                          </div>
                        })
                      }
                     
                      </div> 
                        <ul className="item-list library d-none" id="business" style={{columnCount: "2"}}> 
                            <li>
                                <input type="image" src="https://mediadirhub.com/inlineeditor/custom/business/6-thum.png" id="background" alt="" value="https://mediadirhub.com/inlineeditor/custom/business/6.png"/>
                            </li>
                            <li>
                                <input type="image" src="https://mediadirhub.com/inlineeditor/custom/business/7-thum.png" id="background" alt="" value="https://mediadirhub.com/inlineeditor/custom/business/7.png"/>
                            </li>
                            
                            </ul>

                    </div>:
                      <div className='text-100 px-lg-2'>
                        <div className='content-wrap'>
                        <div className='pic-wrap'>
                        <img src={`${window.aiHost}/images/ai-text-icon.svg`}/>
                        </div>
                        
                        <h6 className='my-3 mb-2'>{app.getLang("meetAi")}</h6>
                        <p>{app.getLang("meetAiDes")}</p>
                        </div>
                      </div>
                    }
                      </div>
                     </div>
                   
                   
                
            </div> 
          </div>
        </div>
      </div>
        }
     
    </div>
  }
}

export const TextGenModal = ({notfiyObj,handlePrice,closeTextGenModal})=>{

  const [data, setData] = useState(null);

  useEffect(()=>{
    app.getPrice("getPrice").then(function(response){
      console.log(response);
      if(response.meteredBillingArr) {
        if(response.meteredBillingArr.length) {
          setData({
            currencySymbol:response.meteredBillingArr[0].currencySymbol,
            currency:response.meteredBillingArr[0].currency,
            perUnitPrice:response.meteredBillingArr[0].extraUsageCharges.AIAppTextGenerations,
            //minUnit:response.meteredBillingArr[0].giftedItems.AIAppTextGenerations,
            minUnit:200,
            userBalance:response.userBalance.userBalance,
            tax:response.userBalance.tax
          });
        }
      }
      
    });
  },[]);

  useEffect(()=>{
    app.getPrice("getPrice").then(function(response){
      // console.log(response);
      if(response.meteredBillingArr) {
        if(response.meteredBillingArr.length) {
          setData({
            currencySymbol:response.meteredBillingArr[0].currencySymbol,
            currency:response.meteredBillingArr[0].currency,
            perUnitPrice:response.meteredBillingArr[0].extraUsageCharges.AIAppTextGenerations,
            //minUnit:response.meteredBillingArr[0].giftedItems.AIAppTextGenerations,
            minUnit:200,
            userBalance:response.userBalance.userBalance,
            tax:response.userBalance.tax
          });
        }
      }
      
    });
  },[]);

  const addFunds = function(){
    app.getPrice("addFunds", {
      amount:(data.perUnitPrice*notfiyObj.notifyQuanity),
      quantity:notfiyObj.notifyQuanity
    }).then(function(response){
      // console.log(response);
      if(response.status) {
        closeTextGenModal(notfiyObj.notifyQuanity);
        app.showAlert("success", app.getLang("purchaseSuccessful"));
      }
      if(response.message === "success") {
        closeTextGenModal(notfiyObj.notifyQuanity);
        app.showAlert("success", app.getLang("purchaseSuccessful"));
      }
      if(response.code === "error") {
        if(response.message === "Currency is not supported") {
          app.showAlert("danger", app.getLang("currencyNotSupported"));
        }
        else {
          app.showAlert("danger", app.getLang("failedAddCredits"));
        }
      }
    })
  }
  const deductFunds = function(){
    app.getPrice("deductFunds", {
      amount:(data.perUnitPrice*notfiyObj.notifyQuanity),
      quantity:notfiyObj.notifyQuanity,
      userId:localStorage.getItem("userId")
    }).then(function(response){
      // console.log(response);
      if(response.status) {
        closeTextGenModal();
      }
    })
  }
  if(!data) {
    return <div>loading</div>;
  }
  const currency = data.currencySymbol;
  const TotalFundReq = (data.perUnitPrice*notfiyObj.notifyQuanity).toFixed(2);
  const userBal = data.userBalance.toFixed(2);
  const showAddFund = TotalFundReq <= userBal;
  return <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl">
  <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title"> {app.getLang("addCredits")}</h5>
        <button type="button" className="btn-close modal-close close-popup position-relative fa-sharp icon-cancel" onClick={() => closeTextGenModal()}></button>
      </div>
      <div className='modal-body'>
      <div className="ai_modal_wrapper h-100">
        <div className='payment-wrap'>
          <div className='row'>
            <div className='col-md-7 mb-5 pb-3 mb-lg-0 pb-lg-0'>
              <h2 className='fs-4 fw-bold mt-3'>{app.getLang("textgenDes")}</h2>
              <hr/>
              <div className='no-ui-wrapper'>
                {/* <p>Starts from {data.minUnit} text generation. Select your text generation limit to calculate price</p> */}
                {app.getLang("calculatePrice").replace("###",data.minUnit)}
                <div className='px-3'>
                <CustomRange min={data.minUnit} max={2000} start={data.minUnit} handlePrice={handlePrice} data={data} notfiyObj={notfiyObj}/>
                </div>
              </div>

            </div>
            <div className='col-md-5'>
              <div className="card card-wrap">
                <div className="card-header">
                {app.getLang("fundsRequired")}
                </div>
                <div className="card-body">
                <ul className="list-group list-group-flush">
                  <li className="list-group-item d-flex justify-content-between px-0 border-0 ">
                   <p className='mb-0'>{app.getLang("TextQuantity")}</p>
                   <p className='mb-0'>{notfiyObj.notifyQuanity}</p>
                  </li>

              
                  <li className="list-group-item d-flex justify-content-between px-0 border-0">
                   <p className='mb-0'>{app.getLang("TextPrice")}</p>
                   <p className='mb-0'>{currency}{data.perUnitPrice}</p>
                  </li>

                  

                  <li className="list-group-item d-flex justify-content-between px-0 border-0">
                   <p className='mb-0'>{app.getLang("reqFunds")}</p>
                   <p className='mb-0'>{currency}{notfiyObj.reqFunds}</p>
                  </li>
                  

                  <li className="list-group-item d-flex justify-content-between px-0 border-0 d-none">
                  <p className='mb-0'>{app.getLang("avFunds")}</p>
                   <p className='mb-0'>{currency}{userBal}</p>
                  </li>

                  <li className={`list-group-item d-flex justify-content-between px-0 border-0 ${data.tax?"":"d-none"}`}>
                   <p className='mb-0'>{app.getLang("taxAmount")}</p>
                   <p className='mb-0'>{currency}{data.tax}</p>
                  </li>
                  <li className='list-group-item p-0 border-0'>
                    <hr/>
                  </li>

                  <li className={`list-group-item d-flex justify-content-between px-0 border-0 fw-bold`}>
                   <p className='mb-0'>{app.getLang("totalReqFunds")}</p>
                   <p className='mb-0'>{currency}{TotalFundReq}</p>
                  </li>

                  <li  className="list-group-item p-0 mt-3">
                  {
                    showAddFund 
                    ? 
                   
                    <button className="btn btn-primary w-100" onClick={addFunds}> {app.getLang("addCurrButton")}</button>
                    
                   
                    :
                    <button className="btn btn-primary w-100" onClick={addFunds}> {app.getLang("addCurrButton")}</button>
                  }
                  
                 
                  </li>
                </ul>
                
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
  </div>
  </div>
}

export const CustomRange = ({min,max,start,handlePrice})=>{
  const divRef = useRef();

  useEffect(()=>{
    createFoodTip();
   
  },[]);

  const createFoodTip =()=>{

  
    var slider = divRef.current;
    if (slider && slider.noUiSlider) {
      slider.noUiSlider.destroy();
    }
    // Same guard as the Nouislider component below — window.noUiSlider comes
    // from a <script> the page loads and is undefined if that request failed.
    if(slider && window.noUiSlider){
      window.noUiSlider.create(slider, {
        start: start,
        connect: true,
        range: {
          min,
          max,
        },
        step: 200,
        tooltips: true,
        pips: {
          mode: 'steps',
          stepped: true,
          density: 2
      }
        
      });

      slider.noUiSlider.on("update", function (values, handle) {
        let [value] = values;
        handlePrice(value);
      });

    }
  }
   return <div ref={divRef} id={`tipAmountSlider`} className='tipAmountSlider'></div>;
}

export class DeleteModal extends React.Component {
  constructor(props) {
    super(props);
    this.remove = this.remove.bind(this);
  }
  remove() {
    ReactDOM.findDOMNode(this).parentElement.remove();
  }
  callback(props){ 
    props.callback();
    ReactDOM.findDOMNode(this).parentElement.remove();
  }
  render() {
    let self = this;
    return <div className="modal" style={{ display: "block" }}>
      <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-md deleteModal">
        <div className="modal-content h-auto" style={{minHeight:"auto"}}> 
          <div className="modal-body p-4 pb-0" style={{minHeight:'inherit'}}>
            <h6 className='fw-bold'>{self.props.title}</h6>
            <small>{self.props.summary}</small>
          </div>
          <div className="modal-footer border-0">
            <button type="button" className="btn del-btn" data-bs-dismiss="modal" onClick={this.remove}>{app.getLang("cancel")}</button>
            <button type="button" className="btn del-btn remove-btn" onClick={()=>self.callback(self.props)}>{app.getLang("remove")}</button>
          </div>
        </div>
      </div>
    </div>
  }
}

export const ConfirmModal = ({title,summary,onConfirm,onCancel}) => {

  const modalRef = useRef(null);

  const removeModal = () => {
    ReactDOM.findDOMNode(modalRef.current).parentElement.remove();
  }

  const handleCancel = () => {
    onCancel();
    removeModal();
  }

  const handleConfirm = () => {
    onConfirm();
    removeModal();
  }
  
  return (
    <>
      <div className="modal" style={{ display: "block" }} ref={modalRef}>
        <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-md deleteModal">
          <div className="modal-content h-auto" style={{minHeight:"auto"}}> 
            <div className="modal-body p-4 pb-0" style={{minHeight:'inherit'}}>
              <h6 className='fw-bold'>{title}</h6>
              <small>{summary}</small>
            </div>
            <div className="modal-footer border-0">
              <button type="button" className="btn del-btn" data-bs-dismiss="modal" onClick={handleCancel}>{app.getLang("cancel")}</button>
              <button type="button" className="btn del-btn confirm-btn" onClick={handleConfirm}>{app.getLang("confirm")}</button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
 

let dragElement, dropElement;

export const DisplayForms = function(props) {
  const [searchFont, setSearchFont] = useState('');
   

  const langSettings = app.getConfig().languageSettings;
  const update = function(event) {

    const e = event.currentTarget;
     if(props.edit.id) {
      if(props.edit.grid && props.edit.gridId) {
        if(props.data[props.edit.index].elements[props.edit.gridId].items[props.edit.grid][props.edit.id]["properties"][e.getAttribute("id")] !== undefined) {
          props.data[props.edit.index].elements[props.edit.gridId].items[props.edit.grid][props.edit.id]["properties"][e.getAttribute("id")] = e.value;
        }
        
      }
      else {
        if(props.data[props.edit.index].elements[props.edit.id]["properties"][e.getAttribute("id")] !== undefined) {
          props.data[props.edit.index].elements[props.edit.id]["properties"][e.getAttribute("id")] = e.value;
        }
        
      }
    }
    else {
      if(props.edit.grid && props.edit.gridId) {
        for(var k in props.data[props.edit.index].elements[props.edit.gridId].items[props.edit.grid]) {
          if(k !== "viewType" && k !== "properties" && k !== "gridId") {
            if(props.data[props.edit.index].elements[props.edit.gridId].items[props.edit.grid][k]["properties"][e.getAttribute("id")] !== undefined) {
              props.data[props.edit.index].elements[props.edit.gridId].items[props.edit.grid][k]["properties"][e.getAttribute("id")] = e.value;
            }
            
          }
        }
      }
      else {
        for(var k in props.data[props.edit.index].elements) {
          if(props.data[props.edit.index]["properties"][e.getAttribute("id")] !== undefined) {
            props.data[props.edit.index]["properties"][e.getAttribute("id")] = e.value;
          }
          if(props.data[props.edit.index].elements[k]["properties"][e.getAttribute("id")] !== undefined) {
            props.data[props.edit.index].elements[k]["properties"][e.getAttribute("id")] = e.value;
          }
          
          if(props.data[props.edit.index].elements[k].viewType === "grid") {
            props.data[props.edit.index].elements[k].items.forEach(function(v, i){
              for(var key in v) {
                
                if(key !== "gridItem" && key !== "properties" && key !== "gridId" && key !== "viewId" && key !== "viewType") {
                
                  if(v[key]["properties"][e.getAttribute("id")] !== undefined) {
                    v[key]["properties"][e.getAttribute("id")] = e.value;
                  }
                  
                } 
              }
            })
          }
        }
      
        
      }
      
    } 
    props.update(props.data);
  }
  const rootUpdate = function(elId, elValue) {
    // console.log("rootUpdate", elId, elValue)
    const {id, index, grid, gridId} = props.edit; 
   
    if(id) {
      if(grid && gridId) {
        if(props.data[index].elements[gridId].items[grid][id]["properties"][elId] !== undefined) {
          props.data[index].elements[gridId].items[grid][id]["properties"][elId] = elValue;
        }
      }
      else {
        if(props.data[index].elements[id]["properties"][elId] !== undefined) {
          props.data[index].elements[id]["properties"][elId] = elValue;
        }
      }
    }
    else {
      if(gridId) {
        // console.log("asdasdasdasdasdasd nnn", props.edit)
        for(var k in props.data[index].elements[gridId].items[grid]) {
          if(k !== "viewType" && k !== "properties" && k !== "gridId" && k !== "viewId") {
            if(props.data[index].elements[gridId].items[grid][k]["properties"][elId] !== undefined) {
              props.data[index].elements[gridId].items[grid][k]["properties"][elId] = elValue;
            }
          }else{
            //new added by nit
            if(k === "properties"){
              if(props.data[index].elements[gridId].items[grid][k][elId] !== undefined) {
                props.data[index].elements[gridId].items[grid][k][elId] = elValue;
              }
            } 
          }
        }
      }
      else {
         if(props.data[index]["properties"][elId] !== undefined) {
          props.data[index]["properties"][elId] = elValue;
        }
        for(var k in props.data[index].elements) { 
           if(props.data[index].elements[k]["properties"][elId] !== undefined) {
            props.data[index].elements[k]["properties"][elId] = elValue;
          }
          if(props.data[index].elements[k].viewType === "grid") {
            props.data[index].elements[k].items.forEach(function(v, i){
              for(var key in v) {
                if(key !== "gridItem" && key !== "properties" && key !== "gridId" && key !== "viewId" && key !== "viewType") {
                  if(v[key]["properties"][elId] !== undefined) {
                    v[key]["properties"][elId] = elValue;
                  }
                } 
              }
            })
          }
        }
      }
    }
    props.update(props.data);
  }

  const manageUpdate = function(type, key, value) {
    const {id, index, grid, gridId} = props.edit;
    if(type === "collapse") {
      if(props.data[index].widgetType === "faq_one") {
        // props.data[index].elements.faqList.items.forEach(function(v){
        //   v["properties"]["collapse"] = false;
        // });
        props.data[index].elements.faqList.items[0]["properties"]["collapse"] = value;
      }
    }
    if(type === "placeholder") {
      // console.log("type ==",type,"key ==", key,"value ==", value);
      // console.log("id ==",id,"index ==", index,"grid ==", grid,"gridId ==", gridId);
      props.data[index].elements[gridId].items[grid]["input"].text = value;
    }
    if(type === "inputType"){
      // console.log("type ==",type,"key ==", key,"value ==", value);
      // console.log("id ==",id,"index ==", index,"grid ==", grid,"gridId ==", gridId);
      props.data[index].elements[gridId].items[grid]["input"].properties.type = value;
    }
    if(type === "layout"){

      if(key === "layout"){
        props.data[index].properties.layout = value;
        console.log(value,props.data[index].properties.layout,"layout type value===");
        if(value === "1"){
          props.data[index].elements.banner.properties.ratio = "3x1";
          props.data[index].elements.banner.properties.ratioWeb = "3x1";
        }
        if(value === "2"){
          props.data[index].elements.banner.properties.ratio = "2x1";
          props.data[index].elements.banner.properties.ratioWeb = "2x1";

        }
        if(value === "3"){
          props.data[index].elements.banner.properties.ratio = "3x4";
          props.data[index].elements.banner.properties.ratioWeb = "3x4";
        }
      }

      if(key === "layoutPricing"){
        console.log(value,props.data[index].properties.layout,"layout type value===");
        props.data[index].properties.layout = value;
        if(value === "Horizontal"){
          props.data[index].elements.plansList.properties.spanWeb = "1";
        }
        else{
          props.data[index].elements.plansList.properties.spanWeb = "3";
        }
      }
      if(key === "layout_timeline"){
        // console.log(value,props.data[index].properties.layout,"layout type value===");
        props.data[index].properties.layout = value;
      }

    }
    if(type === "apply"){
      const ignorKeys = ["link", "target", "src"];
      

      if(key) {
        let style = {...props.data[index].elements[gridId].items[grid][key].properties}
        ignorKeys.forEach(function(val){
          delete style[val]; 
        })
        props.data[index].elements[gridId].items.forEach(function(v){
          //v[key].properties = JSON.parse(JSON.stringify(style));
          v[key].properties = {...v[key].properties, ...style}
        });
      }
      else {
        let style = {...props.data[index].elements[gridId].items[grid].properties}
        ignorKeys.forEach(function(val){
          delete style[val]; 
        });
        props.data[index].elements[gridId].items.forEach(function(v){
          //v.properties = JSON.parse(JSON.stringify(style));
          v.properties = {...v.properties, ...style}
        });
      }
    }
    if(type === "customMenu") {
    }
    if(type === "forceUpdate") {
      //console.log(id, index, grid, gridId);
      if(gridId) {
        props.data[index].elements[gridId].items[grid][id].properties[key] = value;
      }
      else {
        props.data[index].elements[id].properties[key] = value;
      }
    }
    props.update(props.data);
  }
 
  const updateProps = function(data, key, val) {
    // console.log("props", props)
    if(props.edit.id) {
      if(props.edit.grid && props.edit.gridId) {
        if(data[props.edit.index].elements[props.edit.gridId].items[props.edit.grid][props.edit.id]["properties"][key] !== undefined) {
          data[props.edit.index].elements[props.edit.gridId].items[props.edit.grid][props.edit.id]["properties"][key] = val;
        }
      } 
      else {
        if(data[props.edit.index].elements[props.edit.id]["properties"][key]  !== undefined) {
          data[props.edit.index].elements[props.edit.id]["properties"][key] = val;
        }
      }
    }
    else {
      if(props.edit.grid && props.edit.gridId) {
         if(data[props.edit.index].elements[props.edit.gridId].items[props.edit.grid]["properties"][key] !== undefined) {
          data[props.edit.index].elements[props.edit.gridId].items[props.edit.grid]["properties"][key] = val;
        }
      }
      else {
        if(data[props.edit.index]["properties"][key] !== undefined) {
          data[props.edit.index]["properties"][key] = val;
        }
        else if(data[props.edit.index]["settings"][key] !== undefined) {
          data[props.edit.index]["settings"][key] = val;
        }
      }
    }
    return data;
  }
 

  const mobileTextUpdate = function(ele) {
    const {id, index, grid, gridId} = props.edit;
    const text = document.getElementById("mobileText").innerHTML; 
      if(grid) {
        props.data[index].elements[gridId].items[grid][id]["text"] = text;
      }
      else {
        props.data[index].elements[id]["text"] = text;
      }
      props.update(props.data);
      props.unselect()
  }
 
const updateBackground2 = function(id, value, type) {
  //console.log("type---updateBackground",id, value, type);
  if(id === "headerBgColor") {
    const data = updateProps(props.data, id, value);
    props.update(updateProps(data, "headerBgType", type)); 
  }
  else {
    let backgroundType = id+'Type'
    const data = updateProps(props.data, id, value);
    props.update(updateProps(data, backgroundType, type)); 
  }
  

  if(document.querySelector(".modal .modal-close")) {
    document.querySelector(".modal .modal-close").click();
  }
}
  

  const openTabs = function(index) { 
    let domEle = document.querySelector("#ai-editor");
    let tabLinks = domEle.querySelectorAll(".pannel-tab a");
    let tabContent = domEle.querySelectorAll(".tab-content .tab-pane");
    tabLinks.forEach(function (v, i) {
      v.classList.remove("active");
      //tabContent[i].classList.remove("active");
    });
    tabContent.forEach(function (v, i) {
      v.classList.remove("active");
    });
    tabLinks[index].classList.add("active");
    tabContent[index].classList.add("active");
  }

  const socialLinks = function(options) {  
    if(props.edit.id) {
      if(props.edit.grid && props.edit.gridId) {
        props.data[props.edit.index].elements[props.edit.gridId].items[props.edit.grid][props.edit.id]["options"] = options;
      }
      else {
        props.data[props.edit.index].elements[props.edit.id]["options"] = options;
      }
    }
    props.update(props.data);
  }

  const contactLinks = function(data) {   
    if(props.edit.id) {
      if(props.edit.grid && props.edit.gridId) {
        props.data[props.edit.index].elements[props.edit.gridId].items[props.edit.grid][props.edit.id] = data;
      }
      else {
        props.data[props.edit.index].elements[props.edit.id] = data;
      }
    }
    props.update(props.data); 
  }

  const listUpdate = function(data) {   
    if(props.edit.id) {
      if(props.edit.grid && props.edit.gridId) {
        props.data[props.edit.index].elements[props.edit.gridId].items[props.edit.grid][props.edit.id] = data;
      }
      else {
        props.data[props.edit.index].elements[props.edit.id] = data;
      }
    }
    props.update(props.data); 
  }

  const HoursUpdate = function(data) { 
    if(props.edit.id) {
      props.data[props.edit.index].elements[props.edit.id]["workingHours"] = data.workingHours;
    }
    props.update(props.data);
  }

 
 
  const MediaUpdate = function(media, key, value) {
    media[key] = value;
    props.update(updateProps(props.data, "media", media));
  }
  
  let timerText;
  const textUpdate = function(key, value) {  
    clearTimeout(timerText);  
    const {id, index, grid, gridId} = props.edit; 
    if(grid) {
      props.data[index].elements[gridId].items[grid][id][key] = value;
    }
    else {
      props.data[index].elements[id][key] = value;
    } 
    timerText = setTimeout(() => { 
      props.update(props.data); 
    }, 1000); 
  }
 
  const updateHeaderIcon = function(event) { 
    props.data[props.edit.index].elements.headerIcons.icons[event.currentTarget.getAttribute("data-id")].showWeb = event.currentTarget.checked;
    props.update(props.data);
  }

  const updateDisplay = function(event) { 
    if(event.currentTarget.getAttribute("data-grid")) {
      if(props.edit.grid && props.edit.gridId) {
        if(app.getDevice()){
          props.data[props.edit.index].elements[props.edit.gridId].items[props.edit.grid][event.currentTarget.getAttribute("data-id")]["properties"]["showWeb"] = event.currentTarget.checked;
        }else{
          props.data[props.edit.index].elements[props.edit.gridId].items[props.edit.grid][event.currentTarget.getAttribute("data-id")]["properties"]["show"] = event.currentTarget.checked;
        }
        
       }
      else {
        if(app.getDevice()){
          props.data[props.edit.index].elements[event.currentTarget.getAttribute("data-grid")].items.forEach(function(v){
            v[event.currentTarget.getAttribute("data-id")]["properties"]["showWeb"] = event.currentTarget.checked;
          })
        }else{
          props.data[props.edit.index].elements[event.currentTarget.getAttribute("data-grid")].items.forEach(function(v){
            v[event.currentTarget.getAttribute("data-id")]["properties"]["show"] = event.currentTarget.checked;
          })
        }
        
      } 
    }
    else {
      if(app.getDevice()){
        props.data[props.edit.index].elements[event.currentTarget.getAttribute("data-id")]["properties"]["showWeb"] = event.currentTarget.checked;
      }else{
        props.data[props.edit.index].elements[event.currentTarget.getAttribute("data-id")]["properties"]["show"] = event.currentTarget.checked;
      }
      
    } 
    props.update(props.data);
  }
 
  const commonUpdate = function(key, value) {  
    if(key === "alt") {
      console.log("commonUpdate key, value", key, value);
    }
    //console.log("commonUpdate key, value", key, value);

    props.update(updateProps(props.data, key, value));
    if(document.querySelector(".modal .modal-close")) {
      document.querySelector(".modal .modal-close").click();
    }   
  }
  const headerIconUpdate = function(ids, type, src) {   
    if(type === "showWeb") {
      if(props.data[props.edit.index].elements[props.edit.id].icons[ids].showWeb  !== undefined) {
        props.data[props.edit.index].elements[props.edit.id].icons[ids].showWeb = src;
      }
    }
    else {
      if(props.data[props.edit.index].elements[props.edit.id].icons[ids].iconCode  !== undefined) {
        props.data[props.edit.index].elements[props.edit.id].icons[ids].iconCode = src;
      }
    }
    props.update(props.data);
    if(document.querySelector(".modal .modal-close")) {
      document.querySelector(".modal .modal-close").click();
    }   
  }
   
  const layoutUpdate = function(data) {  
    props.data[props.edit.index].elements["navigation"] = data
    props.update(props.data);  
  }

  const gridUpdate = function(key, value) {   
    for(var k in props.data[props.edit.index].elements) {  
        if(key === "isFlipped"){
            if(props.edit.grid !== "" && props.edit.gridId) {
              // console.log("props.data[props.edit.index].elements[k].items[props.edit.grid].viewType", props.data[props.edit.index].elements[k].items[props.edit.grid].viewType)
              if(props.data[props.edit.index].elements[k].items){
                if(props.data[props.edit.index].elements[k].items[props.edit.grid].viewType == "gridItem"){
                  props.data[props.edit.index].elements[k].items[props.edit.grid].properties[key] = value
                } 
              }
              
            }else{ 
              if(props.data[props.edit.index]["properties"][key]  !== undefined) {
                props.data[props.edit.index]["properties"][key] = value;
              }
              if(props.data[props.edit.index].elements[k].items){
                props.data[props.edit.index].elements[k].items.forEach(function(val){
                  if(val.properties[key] !== undefined){
                    val.properties[key] = value
                  } 
                })
              } 
            }
        } 

        if(props.data[props.edit.index].elements[k].viewType === "grid") { 
          props.data[props.edit.index].elements[k].properties[key] = value; 
        } 
      
    }
    props.update(props.data); 
  }
  
  const isFamilyFn = function(event){ 
    if(event.target.parentElement.classList.contains("on")){
      event.target.parentElement.classList.remove("on")
    }else{
      event.target.parentElement.classList.add("on")
    } 
  }

  const fontSearchChange = function(e){ 
    setSearchFont(e.target.value.toLowerCase()) 
  } 
 


  let timer;
  const langUpdates = function(e) { 
    clearTimeout(timer);
    let event =  e.currentTarget; 
    let value = event.value;
    let key = event.getAttribute('data-key');  
    let type = event.getAttribute('data-type');  
    if(type) {
      //console.log(props.data[props.edit.index].elements[type])
      props.data[props.edit.index].lang[key] = value;
    }
    else {
      if(props.edit.id) {
        props.data[props.edit.index].lang[key] = value;
      }
      if(document.querySelector(`.HoursWidget`) && document.querySelector(`.HoursWidget #span-${key}`)){
        document.querySelector(`.HoursWidget #span-${key}`).innerHTML = value
      }
    }
    
    
    timer = setTimeout(() => { 
      props.update(props.data);
    }, 500); 
   
  }
// console.log("props.edit", )
  if(props.edit.index) {
    const {id, index, grid, gridId} = props.edit;
    let tabs = [ 
      {key:"blocks", text:langSettings.blocks},
      {key:"elements", text:langSettings.elements},
      {key:"style", text:langSettings.style}
    ];
    let contentItems = [];
    const gridItems = [];
    let gridItemsId = "";
    let gridFirst = {};
    // console.log("props.data", props.data)
    let data = props.data[index];  
    // console.log("props.data", data, props.edit)
    if(id) {
      if(grid && gridId) {
        data = props.data[index].elements[gridId]["items"][grid][id]; 
        tabs = [ 
          {key:"style", text:langSettings.style}
        ];
        if(app.isMobile() === "is-mobile"){
          if(data.viewType === "video"){
            tabs = [ 
              {key:"style", text:langSettings.style}
            ];
          }else{
            tabs = [
              {key:"text", text:"Text"},
              {key:"style", text:langSettings.style}
            ];
          }
          
        } 
      }
      else {
        data = props.data[index].elements[id];
        tabs = [ 
          {key:"style", text:langSettings.style}
        ];
        if(app.isMobile() === "is-mobile"){
          tabs = [
            {key:"text", text:"Text"},
            {key:"style", text:langSettings.style}
          ];
        }
      }
    }
    else {
      if(grid && gridId) { 
        data = props.data[index].elements[gridId]["items"][grid];
        tabs = [
          {key:"elements", text:langSettings.elements},
          {key:"style", text:langSettings.style}
        ];
        gridFirst = data;
        gridItemsId = gridId;
        for(var key in data) {
          if(key !== "viewType" && key !== "properties" && key !== "viewId" && key !== "gridId") {
           gridItems.push(key);
          }
        }
      }
      else { 
        tabs = [
          {key:"elements", text:langSettings.elements},
         {key:"style", text:langSettings.style}
       ];
         
        for(var k in data.elements) { 
          if(data.elements[k].viewType === "grid") {
            gridItemsId = k; 
            if(data.elements[k].items.length) {
              gridFirst = data.elements[k].items[0];
              for(var key in gridFirst) {
                if(key !== "viewType" && key !== "properties" && key !== "viewId" && key !== "gridId") {
                  gridItems.push(key);
                }
              }
            }
          }else{ 
            tabs = [
              {key:"blocks", text:langSettings.blocks},
              {key:"elements", text:langSettings.elements},
              {key:"style", text:langSettings.style}
            ];
            contentItems.push(k); 
          }
        }
        
        if(gridItems.length === 0) {
          tabs = [
            {key:"blocks", text:langSettings.blocks},
            {key:"style", text:langSettings.style}
          ];
          let widgetType = props.data[index].widgetType; 
          if(widgetType === "headerAi"){
            if(app.getDevice()){ 
              tabs = [ 
                {key:"blocks", text:langSettings.blocks},
                {key:"style", text:langSettings.style}
              ];
            }else{
              tabs = [  
                {key:"style", text:langSettings.style}
              ];
            } 
          }
        }
      }
    }

    
    let builderWidget = "";
    let languageWidget = "";
    if(data){
     
    if(data.viewType  === "socialLinks") {
        tabs = [
          {key:"content", text:langSettings.content},
          {key:"style", text:langSettings.style}
        ];
        builderWidget = <div className="builder-widget">
           <SocialWidget data={data} edit={props.edit} callback={socialLinks}/>  
        </div> 
    } 
   
    if(data.viewType === "pricingPlanPrice") { 
      tabs = [
        {key:"content", text:langSettings.content},
        {key:"style", text:langSettings.style}
      ];
      builderWidget =  <PricingPrice data={data} edit={props.edit} callback={listUpdate}/>
    }
    
    if(data.viewType  === "hours") {
      tabs = [
        {key:"content", text:langSettings.content},
        {key:"style", text:langSettings.style},
        {key:"language", text:langSettings.language}
      ];
      builderWidget = <div className="builder-widget HoursWidget">
         <HoursWidget data={data} edit={props.edit} root={props.data[index]} callback={HoursUpdate}/>  
      </div> 
     
    const langItems = [];
    
      if(props.data[index].lang){
        for(key in props.data[index].lang){ 
          langItems.push(
            <li className="list-group-item px-0 d-flex align-items-center">
              <input className='form-control border-0 form-control-sm' defaultValue={props.data[index].lang[key]} data-key={key} onInput={langUpdates}/>
             </li>
          );
        }
      }
      languageWidget = <div className="builder-widget">
        <ul className="list-group list-group-flush">{langItems}</ul>
      </div> 
    }
    
    if(data.viewType  === "image") { 
      tabs = [
         {key:"style", text:langSettings.style}
      ];
    }

    if(data.viewType  === "icon") {
      tabs = [ 
        {key:"style", text:langSettings.style}
      ];
      builderWidget =  <IconForm data={data} edit={props.edit} callback={commonUpdate}/>
    }

    if(data.viewType  === "button") {
      tabs = [  
        {key:"style", text:langSettings.style}
      ];
      if(app.isMobile() === "is-mobile"){
        tabs = [
          {key:"text", text:"Text"}, 
          {key:"style", text:langSettings.style}
        ];
      }
    }

    if(data.viewType  === "contactLinks") {
      tabs = [
        {key:"content", text:langSettings.content},
        {key:"style", text:langSettings.style}
      ];
      builderWidget = <div className="builder-widget">
         <ContactWidget data={data} edit={props.edit} callback={contactLinks}/>  
      </div> 
  } 

  if(data.viewType  === "logo") {
    tabs = [ 
      {key:"style", text:langSettings.logo_settings}
    ];
  }

  if(data.viewType  === "navigation") {
    tabs = [  
      {key:"style", text:langSettings.menu_design},
      {key:"content", text:langSettings.menu_settings}
    ];
    builderWidget = <div className="builder-widget">
    <MasterMenu data={data} edit={props.edit} callback={manageUpdate}/>  
    </div> 
  }

  if(data.viewType  === "footerNavigation") {
    tabs = [  
      {key:"style", text:langSettings.menu_design},
      //{key:"language", text:langSettings.language}
    ];

    const langItems = [];
    
      if(props.data[index].lang){
        tabs = [  
          {key:"style", text:langSettings.menu_design},
          {key:"language", text:langSettings.language}
        ];
    
        for(key in props.data[index].lang){ 
          langItems.push(
            <li className="list-group-item px-0 d-flex align-items-center">
              <input className='form-control border-0 form-control-sm' defaultValue={props.data[index].lang[key]} data-key={key} onInput={langUpdates}/>
             </li>
          );
        }
      }
      languageWidget = <div className="builder-widget">
        <ul className="list-group list-group-flush">{langItems}</ul>
      </div> 
    
    // if(data.lang){
    //   tabs = [  
    //     {key:"style", text:langSettings.menu_design},
    //     {key:"language", text:langSettings.language}
    //   ];
    //   for(key in data.lang){ 
    //     langItems.push(
    //       <li className="list-group-item px-0 d-flex align-items-center">
    //         <input className='form-control border-0 form-control-sm' data-type={"footerNavigation"} defaultValue={data.lang[key]} data-key={key} onInput={langUpdates}/>
    //        </li>
    //     );
    //   }
    // }
    // languageWidget = <div className="builder-widget">
    //   <ul className="list-group list-group-flush">{langItems}</ul>
    // </div> 
  }
  
  if(data.viewType  === "advanceSocialLinks") {
    tabs = [
      {key:"content", text:langSettings.content},
      {key:"style", text:langSettings.style}
    ];
    builderWidget = <div className="builder-widget">
       <SocialWidget data={data} edit={props.edit} callback={socialLinks}/>  
    </div> 
} 
 
if(data.viewType === "headerIcons") { 
  tabs = [
    {key:"content", text:langSettings.header_icons},
    {key:"style", text:langSettings.style}
  ];
  builderWidget =  <HeaderIconsForm langSettings={langSettings} data={data} edit={props.edit} callback={headerIconUpdate} />
}

if(data.viewType === "list") { 
  tabs = [
    {key:"content", text:langSettings.content},
    {key:"style", text:langSettings.style}
  ];
  builderWidget =  <ListForm data={data} edit={props.edit} callback={listUpdate}/>
}

if(data.viewType === "menu") { 
  tabs = [
    {key:"content", text:langSettings.content},
    {key:"style", text:langSettings.style}
  ];
  builderWidget =  <MenuForm data={data} edit={props.edit} callback={headerIconUpdate}/>
}

if(data.viewType === "skills") { 
  tabs = [
    {key:"content", text:langSettings.content},
    {key:"style", text:langSettings.style}
  ];
  builderWidget =  <SkillsForm data={data} edit={props.edit} callback={listUpdate}/>
}

if(data.viewType === "tags") { 
  tabs = [
    {key:"content", text:langSettings.content},
    {key:"style", text:langSettings.style}
  ];
  builderWidget =  <TagsForm data={data} edit={props.edit} callback={listUpdate}/>
}

 
    let properties = elementsProps[data.viewType];
    let form = <TabComponent langSettings={langSettings} properties={properties} rootData={props.data} data={data} edit={props.edit} index={index} layoutUpdate={layoutUpdate} commonUpdate={commonUpdate} rootUpdate={rootUpdate} updateBackground2={updateBackground2} update={update} isFamilyFn={isFamilyFn} MediaUpdate={MediaUpdate} fontSearchChange={fontSearchChange} setSearchFont={setSearchFont} searchFont={searchFont} textUpdate={textUpdate} gridUpdate={gridUpdate} manageUpdate={manageUpdate} />
 
   
    if(form){  
      let widgetType = '';
      let layoutType = '';
      let layout = "";
      if(props.data){
        if(props.edit.index){
          if(props.data[props.edit.index].widgetType){
            widgetType = props.data[props.edit.index].widgetType;
            if(widgetType === "headerAi"){
              layoutType = props.data[props.edit.index].properties.headerLayout
            }
            if(widgetType === "footerAi"){
              layoutType = props.data[props.edit.index].properties.footerLayout
            }
            if(widgetType === "contact_form_one"){
              if(data.viewType === "view") {
                let option = [1,2,3]
                layout = <>
                  <div className="col-12 my-3">
                    <label>Select Layout</label>
                    <select className="form-select" onChange={(e) => manageUpdate("layout","layout", e.currentTarget.value)} defaultValue={props.data[props.edit.index].properties.layout}>
                      {option.map((v,i) => {
                        return <option value={v}>Layout {v}</option>
                      })}
                    </select>
                  </div>
                 
                </>
              }
            }

            if(widgetType === "pricing_plan"){
              if(data.viewType === "view"){
                let option =  ["Vertical","Horizontal"];
                layout = <>
                <div className="col-12 my-3">
                    <label>Select Layout</label>
                    <select className="form-select" onChange={(e) => manageUpdate("layout","layoutPricing", e.currentTarget.value)} defaultValue={props.data[props.edit.index].properties.layout}>
                      {option.map((v,i) => {
                        return <option value={v}>{v}</option>
                      })}
                    </select>
                  </div>
                </>
              }
            }

            if(widgetType === "timeline_one"){
              layoutType = props.data[props.edit.index].properties.layout;
              if(data.viewType === "view") {
                let option = [1,2,3,4]
                layout = <>
                  <div className="col-12 my-3">
                    <label>Select Layout</label>
                    <select className="form-select" onChange={(e) => manageUpdate("layout","layout_timeline", e.currentTarget.value)} defaultValue={props.data[props.edit.index].properties.layout}>
                      {option.map((v,i) => {
                        return <option value={v}>Layout {v}</option>
                      })}
                    </select>
                  </div>
                 
                </>
              }
            }

          } 
        } 
      }

      // ── New Menu popup (flag-gated) ──────────────────────────────
      // When USE_NEW_MENU is true, replace the whole legacy navigation
      // popup with the standalone ManageMenu component.
      if (data.viewType === "navigation" && USE_NEW_MENU) {
        // Convert popup tree ({label, url, children}) → legacy nav shape
        // ({title, value, type, data}) that the live header renders. Live
        // header at src/preview/helpers.js:765+ reads v.title / v.data and
        // won't display anything if we save with the popup's own field names.
        var toLegacyMenu = function(tree){
          return (tree || []).map(function(n){
            var url = n.url || "";
            var type = "internal";
            if (url && url.indexOf("http") === 0) type = "external";
            else if (url.indexOf("mailto:") === 0) type = "email";
            else if (url.indexOf("tel:") === 0) type = "phone";
            else if (url.indexOf("#") !== -1) type = "anchor";
            else if (!url) type = "none";
            return {
              title: n.label || "",
              value: url,
              type: type,
              // 8 random base-36 chars, never derived from the page — see
              // app.menuItemId. Existing ids are kept so re-saving a menu does
              // not churn every id on every edit.
              id: n.id || app.menuItemId(),
              data: n.children && n.children.length ? toLegacyMenu(n.children) : []
            };
          });
        };
        return <ManageMenu
          open={true}
          onClose={props.unselect}
          // The real MENU DESIGN tab — the builder's generic style panel, already
          // built above with its ~18 props wired to this scope's update handlers.
          // Passed as an element rather than re-plumbing those props inside the
          // popup, so colours/typography/spacing behave exactly as elsewhere.
          designPanel={form}
          // Menus written before this picker store page paths ("/store") and the
          // raw /PAGE_IDENTIFIER_HOME placeholder where the picker now stores a
          // pageId, and type names the popup does not know ("anchorLinks",
          // "link"). Migrating on read means the popup shows the repaired values
          // immediately; they persist on the next save via onChange below.
          //
          // Self-terminating rather than idempotent: the migration mints a fresh
          // 8-character app.menuItemId() for every item, and the gate skips any
          // list whose first id is already 8 characters, so this runs once per
          // menu and is a single property read on every load after that.
          initialItems={migrateLegacyMenu(data.navigationMenu || [])}
          initialCustomMenu={data.properties ? data.properties.customMenu : undefined}
          onChange={function(next){
            data.navigationMenu = toLegacyMenu(next.tree);
            if (!data.properties) data.properties = {};
            data.properties.customMenu = next.customMenu;
            manageUpdate(data);
          }}
        />;
      }

      return <div className={`box-pop-wrapper sticky-on ${widgetType} layoutType-${layoutType} ${props.edit.grid} ${props.edit.gridId} ${props.edit.id}`} style={{zIndex:1001}}>
        <nav className="nav pannel-tab">
           <div className="drag-pointer"></div>
          {
            tabs.map(function(v, i){
              let active = ''
              if(i === 0){
                active = 'active'
              }
              return <a className={`nav-link ${active}`} onClick={() => openTabs(i)} data-id={v.text}>{v.text}</a>
            })
          }
          <button type="button" className="close-popup modal-close position-relative fa-sharp icon-cancel icon-cancel" onClick={props.unselect}></button>
           {app.isMobile() === "is-mobile" && tabs[0].key === "text" ?<button type="button" className="close-popup modal-close position-relative icon-ok-4 mb-success" onClick={mobileTextUpdate}></button>:null}
        </nav>
        
          

          <div className="box-pop-body">
            <div className="tab-content h-100">
              {
                tabs.map(function(v){
                  if(app.isMobile() === "is-mobile"){
                    if(v.key === "text") {
                      let widgetTypeLink = "";
                      if(props.data){
                        if(props.data[index]){
                          widgetTypeLink = props.data[index].widgetType
                        }
                      }
                      return <div className="tab-pane active h-100 link-editor">  
                      <div className="builder-widget content-area">   
                           {data.text?
                            <>
                            {data.viewType === "text" || data.viewType === "textHtml" || data.viewType === "button"?<div className={`textStyleContainer textStyleMobile ${data.viewType} ${widgetTypeLink}`}>
                              {/* <div className="bdr"><a data-type="ai_generator" className="ai_generator">{svgIcon.ai}</a> </div> */}
                              <button data-type="bold" onClick={window.rootEditor}>{svgIcon.bold}</button>
                              <button data-type="italic" onClick={window.rootEditor}>{svgIcon.italic}</button>
                              <button data-type="underline" onClick={window.rootEditor}>{svgIcon.underline}</button>
                              <button data-type="strikethrough" onClick={window.rootEditor}>{svgIcon.strike}</button>
                              <button onClick={window.editorLink2} data-type="createlink" className="b-icon disabled" >{svgIcon.link}</button>
                              <button onClick={window.editorLink2} data-type="unlink" className="b-icon disabled" >{svgIcon.unlink}</button>
                          </div>:null}
                            <div id='mobileText' className='h-100 py-2 border-0' onMouseDown={function(e){
                              window.isRootCommand(e);
                            }} contentEditable={true} style={{outline:"0",minHeight:"200px"}} dangerouslySetInnerHTML={{__html:data.text}}/>
                            </>
                          :null} 
                        </div>
                      </div>
                    }
                  } 
                  if(v.key === "blocks") {
                    let widgetType = "";
                    if(props.data){
                      if(props.data[index]){
                        widgetType = props.data[index].widgetType
                      }
                    }
                    let htmlFormView = "";
                    if(widgetType === "contact_form_one") {
                      htmlFormView = <ContactFormSetting rootUpdate={rootUpdate} data={props.data[index]} langUpdates={langUpdates}  />
                    }
                    return <div className="tab-pane active" id="blocks">  
                    <div className="builder-widget"> 

                    {
                      ["cart", "notification", "location"].map(function(v){
                        if(data.widgetType !== "headerAi") {
                          return null;
                        }
                        if(!app.getDevice()) {
                          return false;
                        }
                        let showWeb = (data.elements["headerIcons"]["icons"][v].showWeb === false?false:true)
                        return <div className={`form-check hide-list form-switch ${app.iconsFilter(v)}`} data-id={v}>
                          <label className="form-check-label m-0">{app.getLang("show")} {langSettings[v]}</label>
                          <input type="checkbox" className="form-check-input ms-auto mt-0" data-id={v} checked={showWeb} onChange={updateHeaderIcon} />
                        </div>
                      })
                    }

                        {
                          contentItems.map(function(v){
                            if(v === "mobileHeader"){
                              if(app.getDevice()){ 
                                return false
                              }
                            }
                            return <div className="form-check hide-list form-switch" data-id={v}>
                                  <label className="form-check-label m-0">{app.getLang("show")} {data.elements[v]["editorTitle"]}</label>
                                  <input type="checkbox" className="form-check-input ms-auto mt-0" data-id={v} checked={app.getDevice()?data.elements[v].properties.showWeb:data.elements[v].properties.show} onChange={updateDisplay} />
                              </div>
                          })
                        }
                        {htmlFormView}
                      </div>
                    </div>
                  }
                 
                  if(v.key === "themes") {
                    return <div className="tab-pane" id="themes-style">  
                      {builderWidget}
                    </div>  
                  }
                  if(v.key === "content") {
                    return <div className="tab-pane" id="content-style">  
                      {builderWidget}
                    </div>  
                  }
                  if(v.key === "elements") {
                    let spanGrid = ""; 
                    let listGridItem = gridItems;
                    let gridSettings = "";
                    if(props.data[index].widgetType === "table_list"){
                      if(app.getDevice()){
                        spanGrid = props.data[index].elements.gallery.properties.spanWeb;
                      }else{
                        spanGrid = props.data[index].elements.gallery.properties.span;
                      } 
                      listGridItem = gridItems.slice(0, spanGrid);
                    }
                   
                    if(props.data[index].widgetType === "contact_form_one" && data.viewType === "gridItem"){
                      console.log(data,"checking data....")
                      gridSettings = <div>
                          <div className="mb-0" > 
                              <div className='form-check hide-list form-switch'>
                                <label className="label m-0">Mandatory</label>
                                <div className="form-check form-switch ms-auto">
                                  <input data-value={data.properties.mandatory} className="form-check-input ms-auto" type="checkbox" id="mandatory" checked={data.properties.mandatory} onChange={function(a){
                                    rootUpdate("mandatory", !data.properties.mandatory)
                                  }}/> 
                                </div>   
                            </div> 
                          </div>

                          <div className="mb-0" > 
                              <div className='form-check hide-list form-switch flex-wrap'>
                                  <label className="label m-0">Placeholder</label>
                                  <div className="form-check form-switch ms-auto">
                                    <input data-value={data.properties.placeholder} className="form-check-input ms-auto" type="checkbox" id="placeholder" checked={data.properties.placeholder} onChange={function(a){
                                      rootUpdate("placeholder", !data.properties.placeholder)
                                    }}/> 
                                  </div>  
                                  {data.properties.placeholder ? <div className="mt-2 w-100">
                                      <input type="text" value={data.input.text} className="form-control" placeholder="Enter Placeholder Text" onChange={(event) => manageUpdate("placeholder","text",event.target.value)}/>
                                        </div>
                                  : ''} 

                              </div> 

                              
                          </div>

                          <div className="mt-3 pb-3" >
                            <div className="itemContainer mb-3" >
                              <label className="label">Field Type</label>
                              <div className="d-flex">
                                  <select className="form-select" value={data.input.properties.type} id="inputType" onChange={(event) => manageUpdate("inputType","type",event.target.value)}>
                                    {[{key : "text", text : "Text"},{key : "email", text : "Email"},{key : "tel", text : "Phone"},{key : "textarea", text : "Description"}].map((function(v){
                                      return <option value={v.key}>{v.text}</option>
                                    }))}
                                  </select>
                              </div>
                            </div>
                          </div>
                        </div>
                    }
                    return <div className="tab-pane" id="elements-style">  
                    <div className="builder-widget">
                      {
                        listGridItem.map(function(v){
                          let show = true;  
                          if(gridFirst) {
                            if(gridFirst[v].properties) {
                              if(app.getDevice()){
                                if(gridFirst[v].properties.showWeb === false) {
                                  show = false;
                                }
                              }else{
                                if(gridFirst[v].properties.show === false) {
                                  show = false;
                                }
                              }
                              
                            }
                          }
                          
                          return <div className="form-check hide-list form-switch" data-id={v}>
                            <label className="form-check-label m-0">{app.getLang("show")} {gridFirst[v]["editorTitle"]}</label>
                            <input type="checkbox" className="form-check-input ms-auto mt-0" data-grid={gridItemsId} data-id={v} checked={show} onChange={updateDisplay} />
                          </div>
                        })
                      }
                      {gridSettings}
                    </div> 
                  </div>  
                  }

                  if(v.key === "style") {
                    let active = "";
                    if(tabs.length === 1) {
                      active = "active";
                    }

                    let widgetTypeLink = "";
                    if(props.data){
                      if(props.data[index]){
                        widgetTypeLink = props.data[index].widgetType
                      }
                    }
                    return <div className={`tab-pane ${active}`} id="style">
                      {layout}
                      {form} 
                  </div>  
                  }

                  if(v.key === "language") {
                    let active = "";
                    if(tabs.length === 1) {
                      active = "active";
                    }
                   return <div className={`tab-pane ${active}`} id="language"> 
                      {languageWidget}
                  </div>  
                  }
                })
              } 
              
          </div>
        </div>
        
      </div>
    }
  }
  } 
  return null;
  
}

export const GridWidget = function({data, commonUpdate}) {
  let gridData = null;
  let isFlipped = null;
  const langSettings = app.getConfig().languageSettings;
   
  if(data.viewType === "view") {
    for(var k in data.elements) {
      if(data.elements[k].viewType === "grid") {
        gridData = data.elements[k];
      }
    }
    
    if(data.properties["isFlipped"] !== undefined) {
      isFlipped = <div className='col-12' data-type={"flip-all"}>
        <div className="form-check hide-list form-switch">
          <label className="form-check-label label m-0" for="isFlipped">{langSettings.flip}</label>
          <input type="checkbox" id="isFlipped" className="form-check-input ms-auto mt-0" checked={data.properties["isFlipped"]} onChange={(e)=>commonUpdate("isFlipped", !gridData.properties["isFlipped"])}/>
        </div>
      </div>
    }
 
  } 
  if(data.viewType === "gridItem") {  
     if(data.properties["isFlipped"] !== undefined) {
      isFlipped = <div className='col-12' data-type={"flip-single"}>
        <div className="form-check hide-list form-switch">
          <label className="form-check-label label m-0" for="isFlipped2">{langSettings.flip}</label>
          <input type="checkbox" id="isFlipped2" className="form-check-input ms-auto mt-0" checked={data.properties["isFlipped"]} onChange={(e)=>commonUpdate("isFlipped", !data.properties["isFlipped"])}/>
        </div>
      </div>
    }
   }
   

  if(gridData) {
    let spanWeb = ""; 
    if(gridData.properties["span"] !== undefined) {
      let mbdisabled = gridData.properties["isSwiper"]; 

      let option = [1,2];
      if(data.widgetType === "table_list"){
        option = [1,2,3,4,5];
      } 
    
      spanWeb = <div className="col-12 mb-3 select-grid-input">
      <label>{langSettings.grid_size}</label>
        <div className="text-start">
            <select className="form-select" disabled={mbdisabled} id="span" value={gridData.properties["span"]} onChange={(e)=>commonUpdate("span", e.currentTarget.value)}>
              {
                option.map(function(v,i){
                  return <option value={v}>{v}</option>
                })
              } 
            </select>
          </div>
        </div>; 

      if(app.getDevice()) { 
        let option = [1,2,3,4];
        if(data.widgetType === "sponsors_list"){
          option = [1,2,3,4,5,6];
        } 
        if(data.widgetType === "table_list"){
          option = [1,2,3,4,5];
        }
        if(data.widgetType === "pricing_plan"){
          if(data.properties.layout === "Horizontal"){
            option = [1,2];
          }
        }
        spanWeb = <div className="col-12 mb-3 select-grid-input">
        <label>{langSettings.grid_size}</label>
        <div className="text-start">
            <select className="form-select" id="spanWeb" value={gridData.properties["spanWeb"]} onChange={(e)=>commonUpdate("spanWeb", e.currentTarget.value)}>
              {
                option.map(function(v,i){
                  return <option value={v}>{v}</option>
                })
              } 
            </select>
          </div>
        </div>
      }
    }
    gridData.items.forEach(function(v, i){
      if(v.properties["isFlipped"] !== undefined) {
        isFlipped = <div className='col-12'>
          <div className="form-check hide-list form-switch">
            <label className="form-check-label  label m-0" for={`isFlipped-${i}`}>{langSettings.flip}</label>
            <input type="checkbox" id={`isFlipped-${i}`} className="form-check-input ms-auto mt-0" checked={gridData.properties["isFlipped"]} onChange={(e)=>commonUpdate("isFlipped", !gridData.properties["isFlipped"])}/>
          </div>
        </div>
      }
    })
    
    let isSwiper = "";
    if(gridData.properties["isSwiper"] !== undefined) {
      isSwiper= <div className='col-12 mb-3'>
        <div className="form-check hide-list form-switch">
          <label className="form-check-label  label m-0" for="isSwiper">{langSettings.swiper}</label>
          <input type="checkbox" id="isSwiper" className="form-check-input ms-auto mt-0" checked={gridData.properties["isSwiper"]} onChange={function(){
            if(app.getDevice()){
              commonUpdate("isSwiper", !gridData.properties["isSwiper"])
            }else{
              if(gridData.properties["span"] && gridData.properties["isSwiper"]){
                commonUpdate("span", 1)
              }
              commonUpdate("isSwiper", !gridData.properties["isSwiper"])
            } 
          }}/>
        </div>
      </div>
    }
    
    let indicatorType = "";
    if(gridData.properties["isSwiper"]){ 
      indicatorType = <React.Fragment>
        

      <ColorWidget type={app.getLang("indicatorColor")} id="indicatorInActiveColor" index="1" value={gridData.properties["indicatorInActiveColor"]} callback={function(a){
        commonUpdate("indicatorInActiveColor", a);
      }}/> 

      <div className='itemContainer'>
          <label className="d-block fw-bold mb-2">{app.getLang("indicatorType")}</label>
          <div className='d-flex'>
            <select id="indicatorType" className="form-select" defaultValue={data.properties["indicatorType"]} value={gridData.properties.indicatorType} onChange={(e)=>commonUpdate("indicatorType", e.currentTarget.value)}>
              <option value="circular">{app.getLang("circle")}</option>
              <option value="line">{app.getLang("line")}</option>
            </select> 
          </div>   
      </div>

      <ColorWidget type={app.getLang("activeColor")} id="indicatorActiveColor" index="2" value={gridData.properties["indicatorActiveColor"]} callback={function(a){
        commonUpdate("indicatorActiveColor", a);
      }}/>  

      </React.Fragment>
    }
    
    let isRatio = "";
    if(gridData.properties["ratio"] !== undefined && !app.getDevice() && gridData.properties["isSwiper"]) {
      isRatio= <div className='col-12 mb-3'> 
            <label className='display-tool-tip tip-left'>{langSettings.ratio} <span class="icon-info-circled" style={{fontSize:"13px"}}></span><span className="tooltip-text">{langSettings.infoMessage}</span></label>
              <div className="text-right ms-auto">
                <select className="form-select" defaultValue={gridData.properties.ratio} value={gridData.properties.ratio} id="isRatio" onChange={function(event){
                    commonUpdate("ratio", event.target.value)
                }}>
                   {
                    ["1x1","2x1","3x2","4x3","7x3","16x9","20x9","1x2","2x3","3x4","7x10","8x10","9x10"].map(function (v) {
                      return <option>{v}</option>
                    })
                  }
                </select>
              </div> 
      </div>
    }
     
    return <div>
      {spanWeb}
      {isFlipped}
      {isRatio}
      {isSwiper}
      {indicatorType}
    </div>
  }
  else {
    if(isFlipped) {
      return <div className='row'>
        {isFlipped}
      </div>
    }
  }
  return null;
}

const MobileWidget = function({data, callback}) {
  const langSettings = app.getConfig().languageSettings;
  const updateRow = function(e) { 
    let event =  e.currentTarget;  
    let index = event.getAttribute('data-index');
    let value = event.getAttribute('data-value');
    let type = event.getAttribute('data-type'); 

    if(type === 'icon'){
      const div = document.createElement("div");
      document.body.appendChild(div);
      ReactDOM.render(<Modal title={app.getLang("selectIcon")}>
      <IconList callback={function(v){ 
        data.options[index].iconCss = v; 
        document.querySelector(".modal .modal-close").click(); 
        document.querySelector("#iconList").click();
         callback(data.options);
      }} />
    </Modal>, div);  
    }
    else{  
      linkPopup(value, index, function(row){
        data.options[index].link = row; 
        callback(data.options); 
      }, null, data) 
    } 
  }

  const remove = function(index) {   
    data.options.splice(index, 1);
    callback(data.options);
  }

  let list = data.options.map(function (v, i) {  
    let rowDisable = false
    if(data.options.length === 1){
      rowDisable = "pointer-none"
    } 
    return <li className="input-group mw-100 d-flex justify-content-between"> 
      <input type="button" id="iconList" value={v.iconCss} style={{ display: "none" }} />
      <button className={`iconbtn ${v.iconCss}`} value={v.iconCss} data-type="icon" data-value={v.iconCss} data-index={i} onClick={(e)=>updateRow(e)}></button> 
      <div className="position-relative d-flex align-items-center w-75">
            <input type="text" className="form-control border-0" value={v.link} placeholder="https://example.com/" id="link" data-type="link" data-value={v.link} data-index={i} readOnly onClick={(e)=>updateRow(e)}/>
      </div> 
      
      {/* <input className="form-control" type="text" value={v.link} data-type="link" data-index={i} onInput={(e)=>updateRow(e)}/> */}
      <div className="input-group-append d-flex w-25 align-items-center justify-content-end">
        <button className="target-setting input-group-text ic_ai_icon_game_setting_8" data-type="link" data-value={v.link} data-index={i} onClick={(e)=>updateRow(e)}></button>
        <button type="button" id="searchclear" className={`input-group-text ic_ai_icon_delete_9 text-danger ${rowDisable}`} onClick={() => remove(i)}></button>
      </div>
    </li>
     
  })

  return  <ul className="social-widget p-0 m-0">
      {list} 
      <a className='btn btn-sm btn-dark float-end mt-2' onClick={function(){
        data.options.push({
          "iconCss": "iconz-globe",
          "link": "https://example.com/"
        })
        callback(data.options);
      }}>{langSettings.add_more}</a>
    </ul>
}


const SocialWidget = function({data, callback}) {
  const langSettings = app.getConfig().languageSettings;
  const updateRow = function(e) {
    let event =  e.currentTarget;
    let index = event.getAttribute('data-index');
    let value = event.getAttribute('data-value');
    let type = event.getAttribute('data-type');

    if(type === 'icon'){
      // Same tabbed picker HeaderIconsForm opens: passing a type gives
      // Icons / Library / Custom Upload. It closes itself, so the manual
      // .modal-close click that used to follow is gone.
      app.imagePopup(data.options[index].iconCss, function(key, val){
        // Images.update fires twice (our type, then "src") — take ours only.
        if (key !== "icon") return;
        data.options[index].iconCss = val;
        callback(data.options);
      }, "icon");
    }
    else{  
      linkPopup(value, index, function(row){
        data.options[index].link = row; 
        callback(data.options); 
      }, null, data) 
    } 
  }

  const remove = function(index) {   
    data.options.splice(index, 1);
    callback(data.options);
  }

  let list = data.options.map(function (v, i) {  
    let rowDisable = false
    if(data.options.length === 1){
      rowDisable = "pointer-none"
    } 
    return <li className="input-group mw-100 d-flex justify-content-between"> 
      <input type="button" id="iconList" value={v.iconCss} style={{ display: "none" }} />
      {String(v.iconCss || "").indexOf("https://") !== -1
        ? <button className="iconbtn btn-outline-secondary btn-image-select img-style"
                  value={v.iconCss} data-type="icon" data-value={v.iconCss} data-index={i}
                  style={{background: `url(${v.iconCss}) no-repeat 0 0 / cover`}}
                  onClick={(e)=>updateRow(e)}></button>
        : <button className={`iconbtn ${v.iconCss}`} value={v.iconCss} data-type="icon" data-value={v.iconCss} data-index={i} onClick={(e)=>updateRow(e)}></button>}
      <div className="position-relative d-flex align-items-center w-75">
            <input type="text" className="form-control border-0" value={v.link} placeholder="https://example.com/" id="link" data-type="link" data-value={v.link} data-index={i} readOnly onClick={(e)=>updateRow(e)}/>
      </div>

      {/* <input className="form-control" type="text" value={v.link} data-type="link" data-index={i} onInput={(e)=>updateRow(e)}/> */}
      <div className="input-group-append d-flex w-25 align-items-center justify-content-end">
        <button className="target-setting input-group-text ic_ai_icon_game_setting_8" data-type="link" data-value={v.link} data-index={i} onClick={(e)=>updateRow(e)}></button>
        <button type="button" id="searchclear" className={`input-group-text ic_ai_icon_delete_9 text-danger ${rowDisable}`} onClick={() => remove(i)}></button>
      </div>
    </li>

  })

  return  <ul className="social-widget p-0 m-0">
      {list}
      <a className='btn btn-sm btn-link float-end mt-2' onClick={function(){
        data.options.push({
          "iconCss": "iconz-globe",
          "link": "https://example.com/"
        })
        callback(data.options);
      }}>{langSettings.add_more}</a>
    </ul>
}

const ContactWidget = function({data, callback}) { 
  const langSettings = app.getConfig().languageSettings;
  const updateData = function(value, type, index) {   
    connectionModel(value, type, index, function(val, t){
      data.contactItems[index].value = val; 
      data.contactItems[index].type = t;  
      callback(data); 
    })  
  }

  const remove = function(index) {  
    const div = document.createElement("div");
    let title = app.getLang("remove_section");
    let summary = app.getLang("are_you_sure");
    document.body.appendChild(div);
    ReactDOM.render(<DeleteModal title={title} summary={summary} callback={function(){
      data.contactItems.splice(index, 1);
      callback(data);
    }}/>, div);  
   
  }
 
  let self = this;
  let list = data.contactItems.map(function (v, i) {  
    let rowDisable = false
    if(data.contactItems.length === 1){
      rowDisable = "pointer-none"
    } 
   // return i;
    return <li className="input-group mw-100 d-flex justify-content-between"> 
     <div className="position-relative d-flex align-items-center w-75">
          <input type="text" className="form-control border-0 ps-0" value={v.value} placeholder="https://example.com/" id="link" data-type={v.type} data-value={v.value} data-index={i} readOnly onClick={()=>updateData(v.value, v.type, i)}/>
      </div> 
      
      {/* <input className="form-control" type="text" value={v.link} data-type="link" data-index={i} onInput={(e)=>updateRow(e)}/> */}
      <div className="input-group-append d-flex w-25 align-items-center justify-content-end"> 
        <button className="target-setting input-group-text ic_ai_icon_game_setting_8" data-type="link" data-value={v.value} data-index={i} onClick={()=>updateData(v.value, v.type, i)}></button>
        <button type="button" disabled={rowDisable} id="searchclear" className={`input-group-text ic_ai_icon_delete_9 text-danger ${rowDisable}`} onClick={() => remove(i)}></button>
      </div>
    </li>
     
  })

  return  <ul className="social-widget p-0 m-0">
      {list} 
      <li className='input-group mw-100 border-0 d-flex justify-content-between my-3'><a className='btn btn-sm btn-link text-uppercase ms-auto' onClick={function(){
         data.contactItems.push({
          "value": data.contactItems[0].value,
          "type": data.contactItems[0].type
      })
        callback(data);
      }}>{langSettings.add_more}</a></li>
    </ul>
}

const PricingPrice = (props) => {
  const {data,edit,callback} = props;
  console.log(data,edit,callback, "PricingPrice....");

  const updateData = (key,value) => {
    if(key === "price"){
      data.text = value;
    } 
    else{
      data.properties[key] = value;
    }
    callback(data); 
  }

  const currencies = [
    { code: "USD", symbol: "$"},
    { code: "INR", symbol: "₹"},
    { code: "EUR", symbol: "€"},
    { code: "GBP", symbol: "£"},
    { code: "JPY", symbol: "¥"},
    { code: "AUD", symbol: "$" },
    { code: "CAD", symbol: "$"},
    { code: "SGD", symbol: "$"}
  ];

  return <div class="builder-widget">


    <div className="form-check hide-list form-switch"> 
        <div className="row gx-0 align-items-center w-100">
          <div className='col-9 mb-0'>
            <label className="label m-0">Select Pricing Currency</label>
          </div>  
          <div className='col-3 mb-0'>
            <div className="form-group">
              <select className="form-select" value={data.properties.currency} onChange={(e) => updateData("currency",e.target.value)}>
                  {currencies.map((v) => {
                    return <option value={v.symbol}>{v.code}</option>
                  })}
              </select>
            </div>
          </div> 
        </div>
    </div>

    <div className="form-check hide-list form-switch">
      <div className="col-12">
        <div className="form-group">
            <label>Enter Plan Price</label>
            <input type="text" value={data.text} className="form-control" placeholder="Enter Price" onChange={(e) => updateData("price",e.target.value)}/>
        </div>
      </div>
    </div>



    <div className="form-check hide-list form-switch flex-wrap"> 
        <label className="label m-0">Select Plan Type</label>
        <div className="btn-group mt-3 w-100 gap-0" role="group" aria-label="Basic radio toggle button group">
          {[
            { key: "monthly", text: "Monthly" },
            { key: "yearly", text: "Yearly" },
            { key: "other", text: "Other" },
          ].map((v) => (
            <React.Fragment key={v.key}>
              <input
                type="radio"
                className="btn-check"
                name="btnradio"
                id={`pricing${v.key}`}
                autoComplete="off"
                value={v.key}
                checked={data.properties.planType === v.key}
                onChange={(e) => updateData("planType",e.currentTarget.value)}
              />
              <label className={`btn btn-outline-primary`} htmlFor={`pricing${v.key}`} >
                {v.text}
              </label>
            </React.Fragment>
          ))}
        </div>


        {data.properties.planType === "other" ? <div className="form-group w-100">
            <input type="text" className="form-control" value={data.properties.planText === "" ? "" :  data.properties.planText} placeholder="Enter Plan" onChange={(e) => updateData("planText",e.currentTarget.value)}/>
              </div>
        : ''}

    </div>
  </div>
}


const HoursWidget = function({data, root, callback}) { 

  const updateDays = function(e) { 
    let event =  e.currentTarget; 
    let value = event.value;
    let index = event.getAttribute('data-index');  
    data.workingHours[index].day_level = value; 
    callback(data); 
  }

  const updateTimes = function(e) { 
    let event =  e.currentTarget; 
    let value = event.value;
    let parentIndex = event.getAttribute('parent-index');  
    let index = event.getAttribute('data-index'); 
    let from = event.getAttribute('data-from');  
    if(from){
      data.workingHours[parentIndex].duration[index][from] = value; 
      callback(data); 
    } 
  }

  const addTimes = function(e) { 
    let event =  e.currentTarget;  
    let index = event.getAttribute('data-index')
    let parentIndex = event.getAttribute('parent-index'); 
     
    data.workingHours[parentIndex].duration.splice(index+1, 0, {
      "alwaysTo": "18:00",
      "alwaysFrom": "08:00"
    }) 
    callback(data);  
  }
  const removeTimes = function(e){
    let event =  e.currentTarget;  
    let index = event.getAttribute('data-index')
    let parentIndex = event.getAttribute('parent-index');  
    const div = document.createElement("div");
    document.body.appendChild(div);
    ReactDOM.render(<DeleteModal title="Remove" summary="Are you sure you want to remove this hours?" callback={function(){
      data.workingHours[parentIndex].duration.splice(index, 1);
      callback(data);
    }}/>, div);
  }

  const updateFlipTime = function(e) {  
    let event =  e.currentTarget;  
    let type = event.getAttribute('data-type');  

    if(type === "alwaysOpen"){
      let val = 0;
      if(event.checked === true){
        val = 1
      }
      data.alwaysOpen = val;
      callback(data);
    }else{ 
      let val = 0;
      if(event.checked === true){
        val = 1
      }
      data.applyTwentyFourFormat = val;
      callback(data);
    }  
  } 

  const showHideTime = function(e) {  
    let event =  e.currentTarget;  
    let index = event.getAttribute('data-index'); 
    let parentIndex = event.getAttribute('parent-index');  
    let isChecked = event.checked === true; 
    if (isChecked) { 
      event.setAttribute("checked", "true");  
      data.workingHours[parentIndex].duration.push({
        "alwaysTo": "18:00",
        "alwaysFrom": "08:00"
      })
      callback(data); 
    } else { 
      event.removeAttribute("checked"); 
      data.workingHours[parentIndex].duration = [];
      callback(data);
    }
  }   
  
  const lang = root.lang;   
  let list = [
    "mon",
    "tue",
    "wed",
    "thu",
    "fri",
    "sat",
    "sun"  
  ].map(function (key, ind) { 
    var a = data.workingHours[ind]
    let showCheck = false
    if(a.duration.length>0){
      showCheck = true
    }  

    var timeArray = [
      "00:00", "00:15", "00:30", "00:45", "01:00", "01:15", "01:30", "01:45",
      "02:00", "02:15", "02:30", "02:45", "03:00", "03:15", "03:30", "03:45",
      "04:00", "04:15", "04:30", "04:45", "05:00", "05:15", "05:30", "05:45",
      "06:00", "06:15", "06:30", "06:45", "07:00", "07:15", "07:30", "07:45",
      "08:00", "08:15", "08:30", "08:45", "09:00", "09:15", "09:30", "09:45",
      "10:00", "10:15", "10:30", "10:45", "11:00", "11:15", "11:30", "11:45",
      "12:00", "12:15", "12:30", "12:45", "13:00", "13:15", "13:30", "13:45",
      "14:00", "14:15", "14:30", "14:45", "15:00", "15:15", "15:30", "15:45",
      "16:00", "16:15", "16:30", "16:45", "17:00", "17:15", "17:30", "17:45",
      "18:00", "18:15", "18:30", "18:45", "19:00", "19:15", "19:30", "19:45",
      "20:00", "20:15", "20:30", "20:45", "21:00", "21:15", "21:30", "21:45",
      "22:00", "22:15", "22:30", "22:45", "23:00", "23:15", "23:30", "23:45"
    ];
      return <div className={`row`} key={'key-'+ind}>  
          <div className="col-12 form-check hide-list form-switch m-0 px-0 py-2 border-bottom ">
            <div className='d-flex text-capitalize align-items-center'>
            {/* onInput={(e)=>updateDays(e)} */}
              {/* <input type="text" className="form-control border-0" readOnly defaultValue={lang[key]} data-index={ind}/> */}
              <span className='form-control border-0' id={`span-${key}`} data-key={key}>{lang?lang[a.day]:null}</span>
              <input type="checkbox" className="form-check-input ms-auto mt-0" data-type="showCheck" checked={showCheck} parent-index={ind} data-index={ind} onChange={(e)=>showHideTime(e)}/>
            </div>
            
            {
              a.duration.map(function (k, j) { 
                return <div className="row time-list" key={j}>
                  <div className='col-4'>
                    <select key={'s-'+j} defaultValue={k.alwaysFrom} className="form-control bg-light px-2" data-from='alwaysFrom' parent-index={ind} data-index={j} onChange={(e)=>updateTimes(e)}> 
                      <option>{app.getLang("startTime")}</option>
                      {
                        timeArray.map(function(x,y){
                          return <option key={'s-'+y} value={x}>{x}</option>
                        })
                      }
                    </select>
                  </div>
                  <div className='col-4'>
                    <select key={'sb-'+j} defaultValue={k.alwaysTo} className="form-control bg-light px-2" data-from='alwaysTo' parent-index={ind} data-index={j} onChange={(e)=>updateTimes(e)}> 
                    <option>{app.getLang("endTime")}</option>
                      {
                        timeArray.map(function(x,y){
                          return <option key={'e-'+y} value={x}>{x}</option>
                        })
                      }
                    </select> 
                  </div>
                  <div className='col-4'>

                    {j !== 0?<a key={'btn-'+j} className='btn btn-sm btn-dark float-end rounded-circle font-18 btn-circle icon-cancel  ms-2' parent-index={ind} data-index={j} onClick={(e)=>removeTimes(e)}></a>:''}
                    <a key={'btn-'+j} className='btn btn-sm btn-dark float-end rounded-circle font-18 btn-circle' parent-index={ind} data-index={j} onClick={(e)=>addTimes(e)}>+</a>
                  </div>
                </div>
              })
            } 
          </div>  
    </div>  
  })

  return  <div className="hours-widget px-3"> 
  <div className='row'>
    <div className='col-12 my-0 p-0'>
      <div className='form-check hide-list form-switch'>
        <label className="form-check-label me-2" data-type={data.alwaysOpen}>{app.getLang("alwaysOpen")}</label>
        {/*  <input type="checkbox" className="form-check-input ms-auto mt-0" id={`type${i}`} name={`type${i}`} data-index={i} data-id="visible" checked={visible} onChange={self.updateElement} /> */}
        <input type="checkbox" className="form-check-input ms-auto mt-0" checked={data.alwaysOpen == 1?true:false} defaultChecked={data.alwaysOpen == 1?true:false} data-type="alwaysOpen" onChange={(e)=>updateFlipTime(e)}/>
      </div>
    </div>
  </div>

  {data.alwaysOpen !== 1?<div className='row'>
    <div className='col-12 my-0 p-0'>
        <div className='form-check hide-list form-switch'>
          <label className="form-check-label m-0">{app.getLang("applyTwentyFourFormat")}</label>
          <input type="checkbox" className="form-check-input ms-auto mt-0" checked={data.applyTwentyFourFormat} data-key={data.applyTwentyFourFormat} data-type="timeFormat" onChange={(e)=>updateFlipTime(e)}/>
        </div> 
    </div>
  </div>:null}
      {data.alwaysOpen !== 1?list:null} 
      
    </div>
}
 
// export class ColorWidget extends React.Component {
//   constructor(props) {
//     super(props);
//     let index = ""; 
//     if (props.index !== "") {
//       index = Number(1000) - props.index;
//     } 
//     this.state = {
//       value: props.value || "#00000000",
//       show: 'none',
//       index: index,
//       className: props.className,
//       opacity: app.getOpacity(props.value || "#00000000"), // Extract opacity from initial value
//     };
//     this.setValue = this.setValue.bind(this);
//     this.handleOpacityChange = this.handleOpacityChange.bind(this);
//     this.debouncedCallback = debounce((newColor) => {
//       this.props.callback(newColor);
//     }, 300);
//   }
//   componentWillReceiveProps(nextProps){ 
//     const self = this;   
//     if(nextProps.value !== undefined){
//       self.setState({
//         value:nextProps.value || "#00000000",
//         opacity: app.getOpacity(nextProps.value || "#00000000")
//       })
//     }  
//   }

//   setValue(event) {
//     const value = event.target.value; 
//     if (app.isValidColor(value)) {
//       this.setState({
//         value
//       }, () => { 
//         this.debouncedCallback(this.state.value);
//       });
//     } else {
//       console.error("Invalid color value:", value);
//     }
//   }

//   handleOpacityChange(key, value) {
//     const opacity = parseFloat(value);
//     if (!isNaN(opacity)) {
//       this.setState({
//         opacity
//       }, () => {
//         const newColor = app.combineColor(this.state.value, this.state.opacity);
//         this.debouncedCallback(newColor); // Use the debounced callback
//       });
//     } else {
//       console.error("Invalid opacity value:", opacity);
//     }
//   }

//   render() {
//     const { type } = this.props;
//     const { value, index, className, opacity } = this.state;
//     console.log("opacity ",opacity, value)
//     return (
//       <div className='itemContainer' id={this.props.id} data-type={type} data-index={this.props.index}>
//         {type ? <label className="d-block">{type}</label> : ''}
//         <div className='d-flex'>
//           <Nouislider 
//             range={{ min: 0, max: 100 }} 
//             step="1" 
//             start={opacity} 
//             connect={"lower"} 
//             id={this.props.id} 
//             connectColor="transparent" 
//             handleColor={`linear-gradient(90deg, transparent 10%, ${app.getPlanColor(value)} 100%)`} 
//             callback={this.handleOpacityChange}
//           />
//           <input 
//             type="color" 
//             value={app.getPlanColor(value)} 
//             onChange={(e) => this.setValue(e)} 
//           />
//         </div>
//       </div>
//     );
//   }
// }

 
export class ColorWidget extends React.Component {
  constructor(props) {
    super(props);
    let index = ""; 
    if (props.index !== "") {
      index = Number(1000) - props.index;
    } 
    this.state = {
      value: props.value || "#00000000",
      show: 'none',
      index: index,
      className: props.className,
      opacity: app.getOpacity(props.value || "#00000000"), // Extract opacity from initial value
    };
    this.setValue = this.setValue.bind(this);
    this.handleOpacityChange = this.handleOpacityChange.bind(this);
    this.debouncedCallback = debounce((newColor) => {
      this.props.callback(newColor);
    }, 300);
  }
  componentWillReceiveProps(nextProps){ 
    const self = this;   
    if(nextProps.value !== undefined){
      self.setState({
        value:nextProps.value || "#00000000",
        opacity: app.getOpacity(nextProps.value || "#00000000")
      })
    }  
  }
  componentDidMount() {
    const self = this; 
    window.AColorPicker.from(`#${self.props.id} .divColor`).on("change", function(a) {
      const value = `#${a.all.hexcss4.substr(7)}${a.all.hex.replace("#", "")}`;
      self.setValue(value);  
    })
  }
  // setValue(event) {
  //   const value = event.target.value; 
  //   if (app.isValidColor(value)) {
  //     this.setState({
  //       value
  //     }, () => { 
  //       this.debouncedCallback(this.state.value);
  //     });
  //   } else {
  //     console.error("Invalid color value:", value);
  //   }
  // }
  setValue(value) { 
    this.setState({
      value
    }) 
  }
  updateColor(show) {
    let self = this;
    self.props.callback(self.state.value);
    self.setState({
      show
    })
  }
  handleOpacityChange(key, value) {
    const opacity = parseFloat(value);
    if (!isNaN(opacity)) {
      this.setState({
        opacity
      }, () => {
        const newColor = app.combineColor(this.state.value, this.state.opacity);
        this.debouncedCallback(newColor); // Use the debounced callback
      });
    } else {
      console.error("Invalid opacity value:", opacity);
    }
  }
  setShow(show) { 
    this.setState({
      show
    })
  }
  render() {
    const { type } = this.props;
    const { value, index, className, opacity, show } = this.state;
    const self = this; 
    let clearColor = (
      <button className="icon-cancel clearColor" id={type} value="" onClick={() => self.removeValue("")}></button>
    );
  
    // if (value === "") {
    //   clearColor = "";
    // }
   
    if(self.props.id == "textColor"){
      clearColor = "";
    }
    console.log("opacity ",opacity, value)
    return (
      <div className='itemContainer' id={this.props.id} data-type={type} data-index={this.props.index}>
        {type ? <label className="d-block">{type}</label> : ''}
        <div className='d-flex'>
            <Nouislider 
              range={{ min: 0, max: 100 }} 
              step="1" 
              start={opacity} 
              connect={"lower"} 
              id={this.props.id} 
              connectColor="transparent" 
              handleColor={`linear-gradient(90deg, transparent 10%, ${app.getPlanColor(value)} 100%)`} 
              callback={this.handleOpacityChange}
            />
        
            <div className={`acolorpickerNew ${show}`} id={self.props.id} data-type={type}  style={{ backgroundColor: app.getPlanColor(value), backgroundImage: 'none' }}>
              <span onClick={() => self.setShow("active")} className="click-area"></span>
              <div className="picker">
              <div className='close_picker' onClick={() => self.updateColor("none")}></div>
              <div className="divColor" acp-show-hex="yes" acp-show-alpha="no"  acp-show-rgb="no" acp-show-hsl="no" acp-color={app.getPlanColor(value)}></div> 
              </div>
            </div>
  
        </div>
      </div>
    );
  }
}

export class ColorWidget3 extends React.Component {
  constructor(props) {
    super(props);
    let index = ""; 
    if(props.index !== ""){
      index = Number(1000) - props.index 
    }
    this.state = {
      value:props.value,
      show:'none',
      index:index,
      className:props.className,
    }
    this.setShow = this.setShow.bind(this);
    this.setValue = this.setValue.bind(this);
    this.removeValue = this.removeValue.bind(this);
    
  }
 
  componentWillReceiveProps(nextProps){ 
    const self = this;  
    if(nextProps.value !== undefined){
      self.setState({
        value:nextProps.value
      })
    } 
  }

  setShow(show) { 
    this.setState({
      show
    })
  }
  updateColor(show) {
    let self = this;
    self.props.callback(self.state.value);
    self.setState({
      show
    })
  }
  componentDidMount() {
    const self = this; 
    window.AColorPicker.from(`#${self.props.id} .divColor`).on("change", function(a) {
      const value = `#${a.all.hexcss4.substr(7)}${a.all.hex.replace("#", "")}`;
      self.setValue(value);  
    })
  }
  setValue(value) { 
    this.setState({
      value
    }) 
  }
  removeValue(value) {
    this.props.callback(value); 
     this.setState({
       value
     }) 
   }
  render() {
    const self = this;
    const {type} = self.props;
    const {show, value, index, className} = self.state;
    let clearColor = (
      <button className="icon-cancel clearColor" id={type} value="" onClick={() => self.removeValue("")}></button>
    );
  
    // if (value === "") {
    //   clearColor = "";
    // }
   
    if(self.props.id == "textColor"){
      clearColor = "";
    }
     
    return <div id={this.props.id} className={type?`col-6 ${className}`:""} data-type={type} style={{zIndex:index}} data-index={self.props.index}>
    {type?<label className="d-block fw-bold col-12 mb-2">{type}</label>:''}
    <div className="swatch shadow-none" id={self.props.id} data-type={type} style={{ boxShadow: '0px 0px 6px rgb(0 0 0 / 20%)' }}>
    {clearColor}
    <div className={`acolorpicker ${show}`}>
      <span onClick={() => self.setShow("active")} className="click-area"></span>
      <div className="picker">
      <div className='close_picker' onClick={() => self.updateColor("none")}></div>
      <div className="divColor" acp-show-hex="yes" acp-show-alpha="yes"  acp-show-rgb="no" acp-show-hsl="no" acp-color={app.getColor(value)}></div> 
      </div>
    </div>

    {value ? (
      <div data-value={value} className="color-transparent">
        <div className='w-100 h-100' style={{ backgroundColor: app.getColor(value), backgroundImage: 'none' }}></div>
      </div>
    ) : (
      <div data-value={value} data-id={'nit2'} className="color-transparent"></div>
    )}
  </div> 
  </div>
  }
}

export class ColorWidget2 extends React.Component {
  constructor(props) {
    super(props);
    let index = ""; 
    if(props.index !== ""){
      index = Number(1000) - props.index 
    }
    this.state = {
      value:props.value,
      show:'none',
      index:index,
      className:props.className,
    }
    this.setShow = this.setShow.bind(this);
    this.setValue = this.setValue.bind(this);
    this.removeValue = this.removeValue.bind(this);
    
  }
 
  componentWillReceiveProps(nextProps){ 
    const self = this;  
    if(nextProps.value !== undefined){
      self.setState({
        value:nextProps.value
      })
    } 
  }

  setShow(show) { 
    this.setState({
      show
    })
  }
  updateColor(show) {
    let self = this;
    self.props.callback(self.state.value);
    self.setState({
      show
    })
  }
  componentDidMount() {
    const self = this; 
    window.AColorPicker.from(`#${self.props.id} .divColor`).on("change", function(a) {
      const value = `#${a.all.hexcss4.substr(7)}${a.all.hex.replace("#", "")}`;
      self.setValue(value);  
    })
  }
  setValue(value) {
   // this.props.callback(value); hide due to multiple services hit
    this.setState({
      value
    }) 
  }
  removeValue(value) {
    this.props.callback(value); 
     this.setState({
       value
     }) 
   }
  render() {
    const self = this;
    const {type} = self.props;
    const {show, value, index, className} = self.state;
    let clearColor = (
      <button className="icon-cancel clearColor" id={type} value="" onClick={() => self.removeValue("")}></button>
    );
  
    // if (value === "") {
    //   clearColor = "";
    // }
   
    if(self.props.id == "textColor"){
      clearColor = "";
    }
     
    return <div id={this.props.id} className={type?`col-6 ${className}`:""} data-type={type} style={{zIndex:index}} data-index={self.props.index}>
    {type?<label className="d-block fw-bold col-12 mb-2">{type}</label>:''}
    <div className="swatch shadow-none" id={self.props.id} data-type={type} style={{ boxShadow: '0px 0px 6px rgb(0 0 0 / 20%)' }}>
    {clearColor}
    <div className={`acolorpicker ${show}`}>
      <span onClick={() => self.setShow("active")} className="click-area"></span>
      <div className="picker">
      <div className='close_picker' onClick={() => self.updateColor("none")}></div>
      <div className="divColor" acp-show-hex="yes" acp-show-alpha="yes"  acp-show-rgb="no" acp-show-hsl="no" acp-color={app.getColor(value)}></div> 
      </div>
    </div>

    {value ? (
      <div data-value={value} className="color-transparent">
        <div className='w-100 h-100' style={{ backgroundColor: app.getColor(value), backgroundImage: 'none' }}></div>
      </div>
    ) : (
      <div data-value={value} data-id={'nit2'} className="color-transparent"></div>
    )}
  </div> 
  </div>
  }
}


export class ColorPickerWidget extends React.Component {
  constructor(props) {
    super(props); 
    let val = `#${props.value.substring(3)}`; 
    this.state = {
      value: val,
      show: 'none', 
      className: props.className,  // Extract opacity from initial value
    };
    this.setValue = this.setValue.bind(this); 
    this.debouncedCallback = debounce((newColor) => {
      this.props.callback(newColor);
    }, 300);
  }
 

  setValue(event) {
    const value = event.target.value; 
    if (app.isValidColor(value)) {
      this.setState({
        value
      }, () => {  
        this.debouncedCallback(this.state.value);
      });
    } else {
      console.error("Invalid color value:", value);
    }
  } 

  render() { 
    const { value} = this.state;
    return (
      <input 
            type="color" 
            value={value} 
            onChange={(e) => this.setValue(e)} 
          />
    );
  }
}


const SearchContainer = function({page, folder, mode, v, callback, linkValue}) {
  const rootRef = useRef();

  let abortItem = null;
  const [data, setData] = useState([]);
  const [value, setValue] = useState({});

  useEffect(() => {
    //console.log(mode, linkValue);
    if(mode) {
      rootRef.current.querySelector("a").click();
      if(linkValue.indexOf("title__") !== -1) {
        rootRef.current.querySelector("#radioText").click();
        rootRef.current.querySelector("#inputSearch").value = linkValue.split("title__")[1].replace("')", "");
        
      }
    }

    document.addEventListener("click", (event) => {
      if (event.target.id !== "inputSearch") {
        hideSearchDropdown(true);
      }
    });
   
  }, []);

  const searchDeeplink = function(event) {
    const obj = event.currentTarget;
    rootRef.current.querySelector(".loading").classList.add("d-block");
    rootRef.current.querySelector(".search-icon").classList.add("d-none");
    if(obj.value.trim().length > 1) {
      if(abortItem !== null) {
        abortItem.abort();
      }
      abortItem = new AbortController();
      app.textSearch(obj.getAttribute("data-id"), obj.value.trim(), abortItem).then(function(response){
        abortItem = null;
        console.log(response);
        
        if(response) {
          setData(response.data);
          rootRef.current.querySelector(".search-scrolling").classList.remove("d-none");
          rootRef.current.querySelector(".loading").classList.remove("d-block");
          rootRef.current.querySelector(".search-icon").classList.remove("d-none");
          hideSearchDropdown(false);
          setSearchDropdownPosition(event);
        }
        else {

        }
        
      })
    }
    else {
      if(abortItem !== null) {
        abortItem.abort();
      }
      setData([]);
      rootRef.current.querySelector(".search-scrolling").classList.add("d-none");
      rootRef.current.querySelector(".loading").classList.remove("d-block");
      rootRef.current.querySelector(".search-icon").classList.remove("d-none");
    }
  }
  const onChange = function(event) {
    //console.log("hello me")
    if(document.querySelector("#radioHome").checked) {
      showContainer(true);
      //alert("done")
      // rootRef.current.querySelector(".search-box").classList.remove("d-block");
      // setData([]);
      // saveCallback();
    }
    else {
      rootRef.current.querySelector("#inputSearch").value = "";
      rootRef.current.querySelector(".search-box").classList.add("d-block");
      hideSearchDropdown(false);
    }
  }

  const setSearchDropdownPosition = function (event) {
    console.log("event", event);
    let searchDropdown = document.querySelector(".searching-list-wrap");
    let element = event.target;
    let elementRect = element.getBoundingClientRect();
    let elementTop = elementRect.top + window.scrollY;
    let elementHeight = element.offsetHeight;

    let setElementPosition = elementTop + elementHeight;
    searchDropdown.style.top = `${setElementPosition}px`;
  };

  const treeListParent = document.querySelector(".listParent");
  if(treeListParent){
    treeListParent.addEventListener("scroll", () => {
      hideSearchDropdown(true);
    });
  }


  const hideSearchDropdown = function(value) {
    const searchScrolling = document.querySelector(".searching-list-wrap");
    if(searchScrolling){
      if (value == true) {
        searchScrolling.classList.add("d-none");
      } else {
        searchScrolling.classList.remove("d-none");
      }
    }
  };

  const saveCallback = function(category, subcategory, title) {
    let pageId = page.replace("_", "").replace("_", "");
    let folderId = null;
    if(folder) {
      folderId = folder.replace("_", "").replace("_", "")
    }
    callback(pageId, folderId, category, subcategory, title);
  }
  const getLink = function(v) {
    let nextJson = {};
    let name = `title__${v.name}`;
    if(v.type === "Product") {
      nextJson = {
        category:`category__${v.catId[0]}`,
        product:`product__${v.id}`
      }
      saveCallback(nextJson.category, nextJson.product, name);
    }
    else if(v.type === "Category") {
      nextJson = {
        category:`category__${v.id}`,
      }
      saveCallback(nextJson.category, null, name);
    }
    else if(v.type === "Sub Category") {
      console.log(v);
      nextJson = {
        category:`category__${v.parentId}`,
        subcategory:`subcategory__${v.id}`
      }
      saveCallback(nextJson.category, nextJson.subcategory, name);
    }
    rootRef.current.querySelector("#inputSearch").value = v.name;
    setValue(nextJson);
    setData([])
  }
  const showContainer = function(mode) {
    if(mode === true) {
      saveCallback();
    }
    else {
      if(linkValue.split("$$")) {
        let restURL = linkValue.replace("')", "").split("$$").filter(function(v, i){
          if(i === 0) {
            return false;
          }
          return true;
        })
        if(folder) {
          restURL = linkValue.replace("')", "").split("$$").filter(function(v, i){
            if(i === 0 || i === 1) {
              return false;
            }
            return true;
          })
        }
        if(restURL.length) {
          if(restURL.length > 2) {
            saveCallback(restURL[0], restURL[1], restURL[2]);
          }
          else {
            saveCallback(restURL[0], null, restURL[1]);
          }
        }
        else {
          saveCallback();
        }
      }
      else {
        saveCallback();
      }
    }
    
    
    rootRef.current.querySelector("#radioHome").checked = true;
    rootRef.current.querySelector(".search-box").classList.remove("d-block");
    rootRef.current.querySelector(".search-container").classList.add("d-block");
    document.querySelectorAll(".listParent a").forEach(function(v){
      v.classList.remove("on")
    });
    if(document.querySelector(`.listParent a[data-id="${page.replace("_", "").replace("_", "")}"]`)) {
      document.querySelector(`.listParent a[data-id="${page.replace("_", "").replace("_", "")}"]`).classList.add("on");
    }
  }
  return <li className="linkModel-search-container" ref={rootRef}>
  <a className={`${v.pageIcon}`} data-id={page.replace("_", "").replace("_", "")} onClick={showContainer}>{v.pageName}</a>
  <div className="search-container">
    <div className="form-check">
  <input className="form-check-input" type="radio" name="radioSearch" onClick={onChange} id="radioHome" />
  <label className="form-check-label" htmlFor="radioHome">
  {app.getLang("link_to_homepage")}
  </label>
</div>
<div className="form-check">
  <input className="form-check-input" type="radio" name="radioSearch" onClick={onChange} id="radioText" />
  <label className="form-check-label" htmlFor="radioText">
  {app.getLang("link_to_homepage_category")}
  </label>
</div>

<div className="search-box">
  <div className="form-group">
    <input type="text" className="form-control" placeholder={app.getLang("search")} id="inputSearch" data-id={page} onInput={searchDeeplink} autocomplete="off"/>
    <div style={{ display: "none" }} className="loading spinner-border spinner-border-sm" ></div>
    <span className="appyslim-ui-search search-icon"></span>
  </div>
  <div className="searching-list-wrap">
    <div className="search-scrolling d-none">
      {data.length > 0 ? (
        data.map(function(v){
          return <li onClick={() => getLink(v)}>{v.name} ({v.type})</li>
        })
      ) : (
      <li className="disabled">{app.getLang("no_data_found")}</li>
      )}
    </div>
  </div>
   
</div>

    


 
  </div>
  </li>
  
  
}

// The LINK EDITOR's anchor picker (MenuModel and LinkModel below). ManageMenu
// has its own copy — see AnchorBlocks in ManageMenu.js — so this one has no
// importers outside this file.
const LinkBlocks = function({update, value}){
  // const self = this;
  // console.log(value,"value---");
  const [pages, setPages] = useState([]);
  const [isPreview, setIsPreview] = useState(false);
  const [pageUrl, setPageUrl] = useState(value?value.split("#")[0]:null);
  const [page, setPage] = useState(null);

  // console.log(pages,"Anchor Pages");
  
  // fetching pages
  useEffect(() => {
    app.fetchPost({
      "method":"getAllFeaturePages",
      // "appId":"7eb9550f5fca"    
      "appId":localStorage.getItem("aiAppId")  
    }).then(function(response){
      console.log(response);
      if(response.data) {
        setPages(response.data);
        // setPages(response.data.filter(function(v) {
        //   if(v.pageIdentifier === "folder") {
        //     v.folderPages = v.folderPages.filter(function(val) {
        //       if(v.isAIPage) {
        //         return true;
        //       }
        //       // if(["about", "contact", "faq", "pricingplan"].indexOf(val.pageIdentifier) !== -1) {
        //       //   return true;
        //       // }
        //       return false;
        //     });
        //     return true;
        //   }
        //   else {
        //     if(v.isAIPage) {
        //       return true;
        //     }
        //     return false;
        //   }
        //   //return true;
          
        // }));
      }
    })
  }, []);


  // handle recieved message
  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [pageUrl]);

  const handleMessage = (event) => {
    console.log("event" , event);
    const selectedBlockId = event.data.data;
    if(selectedBlockId){
      update(`${pageUrl}#${selectedBlockId}`);
    }
    setIsPreview(false);
    //handleActivePage(pageUrl);
  }

  const updateBlock = function(pageId,pageUrl) {
    setIsPreview(true);
    // console.log('page id == ', pageId);
    // console.log('page url == ', pageUrl);
    setPage(pageId);
    setPageUrl(pageUrl);
  }

  const getFolder = function(data) {
    if(data.folderPages) {
     return <ul>
       {
          data.folderPages.map(function(v){
            const pageURL = `/${data.pageUrl}/${v.pageUrl}`;
            let active = ''; 
            if(pageUrl === pageURL) {
              active = "on"
            }

            let isFolder = {};
            if(v.folderPages) {
              if(v.folderPages.length) {
                isFolder = {
                  pointerEvents: "none",
                  cursor: "not-allowed",
                  opacity: "0.8"
                };
              }
            }
            let isAiPage = "";
            if(v.pageIdentifier !== "folder") {
              if(v.isAIPage === 0) {
                isAiPage = "d-none";
              }
            }

            return <li className={isAiPage}>
               <a className={`${v.pageIcon} ${active}`} style={isFolder} data-url={pageURL} onClick={() => updateBlock(v.pageId, pageURL)}>{v.pageName}</a>
              <button>{app.getLang("select")}</button>
              {getFolder(v)}
            </li>
          })
       }
     </ul>
    }
    else {
      return <ul></ul>
    }
  }

  // const handleActivePage = (page) => {
  //   if(document.querySelector(`.listParent a[data-id="${page}"]`)) {
  //     if(document.querySelector(`.listParent a[data-id="${page}"]`).classList.contains("on")) {
  //     }
  //     else {
  //       document.querySelectorAll(".listParent a").forEach(function(v){
  //         v.classList.remove("on")
  //       });
  //       document.querySelector(`.listParent a[data-id="${page}"]`).classList.add("on");
  //       if(document.querySelector(".listParent .search-container")) {
  //         document.querySelector(".listParent .search-container").classList.remove("d-block")
  //       }
  //     }
  //   }
  // }

  let previewHost = 'https://preview.mediadirhub.com';
  if(window.location.host.indexOf("pbodev.info") !== -1 || window.location.hostname.indexOf("localhost") !== -1 ) {
      previewHost = "https://ai-builder-preview.pages.dev";
  }

  return (
    <>


    <div className="listParent">
        {
          !isPreview ? 
          (
            <ul className="tree">
            {
              pages.map(function(v){

                let pageURL = `/${v.pageUrl}`;
                if(v.pageIdentifier === "home") {
                  pageURL = "/";
                }
               
                let active = ''; 
                if(pageUrl === pageURL) {
                  active = "on"
                }
                let isFolder = {};
                if(v.folderPages) {
                  if(v.folderPages.length) {
                    isFolder = {
                      pointerEvents: "none",
                      cursor: "not-allowed",
                      opacity: "0.8"
                    };
                  }
                }
                let isAiPage = "";
                if(v.pageIdentifier !== "folder") {
                  if(v.isAIPage === 0) {
                    isAiPage = "d-none";
                  }
                }
                  
                
                
              
                return <li className={isAiPage}>
                  <a className={`${v.pageIcon} ${active}`} style={isFolder} data-url={pageURL} onClick={() => updateBlock(v.pageId, pageURL)}>{v.pageName}</a>
                  <button>{app.getLang("select")}</button>
                  {
                    getFolder(v)
                  }
                </li>
              })
            }
          </ul>
            // <ul className="tree">
            //   {
            //     pages.map((v) => {
                  
            //       let pageURL = `/${v.pageUrl}`;
            //       if(v.pageIdentifier === "home") {
            //         pageURL = "/";
            //       }
                 
            //       let active = ''; 
            //       if(page.split("#")[0] === pageURL) {
            //         active = "on"
            //       }

            //       // let pageUrl = "/"+v.pageUrl;
            //       // if(v.pageIdentifier === 'home'){
            //       //   pageUrl = "/"
            //       // }
            //       return  <li key={v.pageId}><a className={`${v.pageIcon} ${active}`} data-id={pageUrl} onClick={() => updateBlock(v.pageId,pageUrl)}>{v.pageName}</a></li>
            //     })
            //   }
              
            // </ul>
          )
          : (
            <div className="pwa-iframe-container"> 
              <span className="close-pwa-iframe" onClick={() => setIsPreview(false)}>
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#666666"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"></path></svg>
              </span>
              <div className="pwa-iframe-wrapper">
                <iframe src={`${previewHost}/${app.getDevice()?"desktop":"mobile"}-anchor/${localStorage.getItem("aiAppId")}/${page}?lang=${app.appLang()}`} className="pwa-iframe"></iframe>
              </div>
            </div>
          )
        }
        
    </div>
    </>
  )

}

const ManagePages = function({update, value}) {
  const self = this;
  const [pages, setPages] = useState([]);
  const [page, setPage] = useState(value?value:"");
  const [customDeepValidation, setCustomDeepValidation] = useState({
    message: "",
    isValid: false
  });
  
  useEffect(() => {
    app.fetchPost({
      "method":"getAllFeaturePages",
      // "appId":"7eb9550f5fca"    
      "appId":localStorage.getItem("aiAppId")  
    }).then(function(response){
      if(response.data) {
        setPages(response.data);
      }
      
      if(value) {
        if(value !== "") {

        }
      }
    })
   
  }, []);

  useEffect(() => {
    if (value) {
     setPage(value);
    } else {
      setPage("");
    }
    validateInternalLink(value);
  }, [value]);

  const updatePage = function(page, folder, category, subcategory, title) {
    
    if(document.querySelector(`.listParent a[data-id="${page}"]`)) {
      if(document.querySelector(`.listParent a[data-id="${page}"]`).classList.contains("on")) {
      }
      else {
        document.querySelectorAll(".listParent a").forEach(function(v){
          v.classList.remove("on")
        });
        document.querySelector(`.listParent a[data-id="${page}"]`).classList.add("on");
        if(document.querySelector(".listParent .search-container")) {
          document.querySelector(".listParent .search-container").classList.remove("d-block")
        }
      }
      
    }
    
    
    let nextValue = "";
    if(category) {
      if(subcategory) {
        nextValue = `$$${category}$$${subcategory}$$${title}`;
      }
      else {
        nextValue = `$$${category}$$${title}`;
      }
    }
    //console.log(nextValue);
    if(folder) {
      setPage(`javascript:opendeeplinkpage('${folder}://$$${page}://${nextValue}')`);
      update(`javascript:opendeeplinkpage('${folder}://$$${page}://${nextValue}')`)
    }
    else {
      setPage(`javascript:opendeeplinkpage('${page}://${nextValue}')`);
      update(`javascript:opendeeplinkpage('${page}://${nextValue}')`)
    }
  }
  const extractDeepLink = function(data){  

    // added check for if clear input 
    if (!data || data.indexOf("opendeeplinkpage('") === -1) return "";

    var functionCall = data;
    // var regex = /opendeeplinkpage\('([^']+)'\)/;
    var regex = /opendeeplinkpage\('([^']*)/;
    var match = functionCall.match(regex);
    var deepLink = match ? match[1] : null;

    if (deepLink && deepLink.includes('://')) {
        deepLink = deepLink.replace('://', '');
    }
    return deepLink 
  }

  const getFolder = function(data) {
    if(data.folderPages) {
     return <ul>
       {
          data.folderPages.map(function(v){
            const folder = data.pageId.replace("_", "").replace("_", "");
            const page = v.pageId.replace("_", "").replace("_", "");
            const pageId = `${data.pageId.replace("_", "").replace("_", "")}://$$${v.pageId.replace("_", "").replace("_", "")}://`;
            
            if(v.pageIdentifier === "hyperstore") {
              let mode = false;
              if(value && value.includes('opendeeplinkpage(')) { 
                let extract = extractDeepLink(value); 
                let fol = extract.split('$$').join('://$$') 
                if(fol.indexOf(pageId) !== -1){
                  //active = "on";
                  mode = true;
                }
              }
              return <SearchContainer key={v.pageId} folder={data.pageId} v={v} page={v.pageId} callback={updatePage} mode={mode} linkValue={value} />
            }
            let active = ''; 
            if(value && value.includes('opendeeplinkpage(')) { 
              let extract = extractDeepLink(value); 
              let fol = extract.split('$$').join('://$$') 
              if(pageId == fol){
                active = "on"
              }
            }
            
            
            return <li>
               <a className={`${v.pageIcon} ${active}`} data-folder={folder} data-id={page} onClick={() => updatePage(page, folder)}>{v.pageName}</a>
              <button>{app.getLang("select")}</button>
              {getFolder(v)}
            </li>
            //  return <li>
            //  <a className={`${v.pageIcon} ${active}`} data-id={pageId} onClick={() => update(`javascript:opendeeplinkpage('${pageId}')`)}>{v.pageName}</a>
            // <button>{app.getLang("select")}</button>
            // {getFolder(v)}
            // </li>
          })
       }
     </ul>
    }
    else {
      return <ul></ul>
    }
  }

  const validateInternalLink = (val) => {
    if (!val) {
      setCustomDeepValidation({ message: "", isValid: false });
      return true;
    }
  
    // Case 1: javascript internal link
    if (val.indexOf("javascript:opendeeplinkpage") !== -1) {
      setCustomDeepValidation({
        message: "Valid Internal Link",
        isValid: true
      });
      return true;
    }
    
    if (val.indexOf("https://") === 0 || val.indexOf("http://") === 0) {
      setCustomDeepValidation({
        message: "External links are not allowed",
        isValid: false
      });
      return false;
    }
  
    // Case 2: deep link structure
    if (val.indexOf("://") !== -1) {
      setCustomDeepValidation({
        message: "Valid Deep Link Structure",
        isValid: true
      });
      return true;
    }
  
    // Case 3: invalid
    setCustomDeepValidation({
      message: "Invalid format. Missing scheme (e.g. page://)",
      isValid: false
    });
    return false;
  };

  const handleCustomDeeplink = (e) => {
    let inputValue = e.target.value;
    // let udpateValue = e.target.value;
    // if (udpateValue.indexOf("javascript:opendeeplinkpage") === -1) {
    //   udpateValue = `javascript:opendeeplinkpage('${udpateValue}')`;
    // }
    // console.log(udpateValue,"udpateValue",inputValue);

    validateInternalLink(inputValue);
    setPage(inputValue);
    update(inputValue);
  }

  return <div className="builder-widget">
  {/* <label className="d-block m-0">{app.getLang("internalPage")}</label>
  <input type="text" id="appPage" className="form-control d-none" value={page} placeholder="https://example.com" data-type="page"/> */}


  <div className="bg-light border mb-4 p-3 rounded-3">
    <label className="d-block m-0">{app.getLang("internalPage")}</label>
    <h6 className="mt-2" style={{fontSize : "14px"}}>Select a feature below or paste a custom link.</h6>
    <input type="text" id="appPage" className="form-control border mt-3 px-3 rounded-3 bg-white" value={page} placeholder="Select a page or paste link (e.g. services://$$cat_1)" data-type="page" onInput={(e) => handleCustomDeeplink(e)}/>
    
    {customDeepValidation.message && (
      <h6
        className={`small mt-3 ${
          customDeepValidation.isValid ? "text-success" : "text-danger"
        }`}
      >
        {customDeepValidation.message}
      </h6>
    )}
    
  </div>
 
  <div className="listParent">
  <ul className="tree">
    {
      pages.map(function(v){
        const pageId = v.pageId.replace("_", "").replace("_", "");
        if(v.pageIdentifier === "hyperstore") {
          let mode = false;
          if(value && value.includes('opendeeplinkpage(')) { 
            let extract = extractDeepLink(value); 
            let fol = extract.split('$$').join('://$$') 
            //console.log(pageId, extract)
            if(fol.indexOf(pageId) !== -1){
              mode = true;
            }
          }
          return <SearchContainer key={v.pageId} v={v} page={v.pageId} callback={updatePage} mode={mode} linkValue={value} />
        }
        
       
        let active = ''; 
        if(value && value.includes('opendeeplinkpage(')) { 
          let extract = extractDeepLink(value); 
          if(pageId === extract){
            active = "on"
          }
        }
      
        return <li>
          <a className={`${v.pageIcon} ${active}`} data-id={pageId} onClick={() => updatePage(pageId)}>{v.pageName}</a>
          <button>{app.getLang("select")}</button>
          {
            getFolder(v)
          }
        </li>
      })
    }
  </ul>
  </div> 
  </div>
}

const ManagePages2 = function({update, value}) {
  const [pages, setPages] = useState([]);
  const [page, setPage] = useState(value?value:"");
  useEffect(() => {
    app.fetchPost({
      "method":"getAllFeaturePages",
      "appId":localStorage.getItem("aiAppId")  
    }).then(function(response){
      if(response.data) {
        setPages(response.data);
      }
    })
  }, []);

  const updatePage = function(page, folder, category, subcategory, title) {
    console.log(page);
    setPage(page);
    update(page);
    
    // if(document.querySelector(`.listParent a[data-id="${page}"]`)) {
    //   if(document.querySelector(`.listParent a[data-id="${page}"]`).classList.contains("on")) {
    //   }
    //   else {
    //     document.querySelectorAll(".listParent a").forEach(function(v){
    //       v.classList.remove("on")
    //     });
    //     document.querySelector(`.listParent a[data-id="${page}"]`).classList.add("on");
    //     if(document.querySelector(".listParent .search-container")) {
    //       document.querySelector(".listParent .search-container").classList.remove("d-block")
    //     }
    //   }
      
    // }
    
    
    // let nextValue = "";
    // if(category) {
    //   if(subcategory) {
    //     nextValue = `$$${category}$$${subcategory}$$${title}`;
    //   }
    //   else {
    //     nextValue = `$$${category}$$${title}`;
    //   }
    // }
    // if(folder) {
    //   setPage(`javascript:opendeeplinkpage('${folder}://$$${page}://${nextValue}')`);
    //   update(`javascript:opendeeplinkpage('${folder}://$$${page}://${nextValue}')`)
    // }
    // else {
    //   setPage(`javascript:opendeeplinkpage('${page}://${nextValue}')`);
    //   update(`javascript:opendeeplinkpage('${page}://${nextValue}')`)
    // }
  }


  const getFolder = function(data) {
    if(data.folderPages) {
     return <ul>
       {
          data.folderPages.map(function(v){
            const pageURL = `/${data.pageUrl}/${v.pageUrl}`;

            // const folder = data.pageId.replace("_", "").replace("_", "");
            // const page = v.pageId.replace("_", "").replace("_", "");
            // const pageId = `${data.pageId.replace("_", "").replace("_", "")}://$$${v.pageId.replace("_", "").replace("_", "")}://`;
            
            // if(v.pageIdentifier === "hyperstore") {
            //   let mode = false;
            //   if(value && value.includes('opendeeplinkpage(')) { 
            //     let extract = extractDeepLink(value); 
            //     let fol = extract.split('$$').join('://$$') 
            //     if(fol.indexOf(pageId) !== -1){
            //       //active = "on";
            //       mode = true;
            //     }
            //   }
            //   return <SearchContainer key={v.pageId} folder={data.pageId} v={v} page={v.pageId} callback={updatePage} mode={mode} linkValue={value} />
            // }
            let active = ''; 
            if(page === pageURL) {
              active = "on"
            }
            
            
            return <li>
               <a className={`${v.pageIcon} ${active}`} data-url={pageURL} onClick={() => updatePage(pageURL)}>{v.pageName}</a>
              <button>{app.getLang("select")}</button>
              {getFolder(v)}
            </li>
          })
       }
     </ul>
    }
    else {
      return <ul></ul>
    }
  }
  console.log(pages);
  return <div className="builder-widget">
  <label className="d-block m-0">{app.getLang("internalPage")}</label>
  <input type="text" id="appPage" className="form-control d-none" value={page} placeholder="https://example.com" data-type="page"/>
 
  <div className="listParent">
  <ul className="tree">
    {
      pages.map(function(v){
        const pageId = v.pageId.replace("_", "").replace("_", "");
        // if(v.pageIdentifier === "hyperstore") {
        //   let mode = false;
        //   if(value && value.includes('opendeeplinkpage(')) { 
        //     let extract = extractDeepLink(value); 
        //     let fol = extract.split('$$').join('://$$') 
        //     //console.log(pageId, extract)
        //     if(fol.indexOf(pageId) !== -1){
        //       mode = true;
        //     }
        //   }
        //   return <SearchContainer key={v.pageId} v={v} page={v.pageId} callback={updatePage} mode={mode} linkValue={value} />
        // }
        
        let pageURL = `/${v.pageUrl}`;
        if(v.pageIdentifier === "home") {
          pageURL = "/";
        }
       
        let active = ''; 
        if(page === pageURL) {
          active = "on"
        }
        
      
        return <li>
          <a className={`${v.pageIcon} ${active}`} data-url={pageURL} onClick={() => updatePage(pageURL)}>{v.pageName}</a>
          <button>{app.getLang("select")}</button>
          {
            getFolder(v)
          }
        </li>
      })
    }
  </ul>
  </div> 
  </div>
}


export class BackgroundWidget extends React.Component {
  constructor(props) {
    super(props); 
    // console.log("BackgroundWidget-props", props)
    let opacity = "";
    if(props.backgroundType === "color"){
      opacity = app.getOpacity(props.value);
    } 
    if(props.backgroundType === "l_gradient"){
      opacity = app.getOpacity(props.value.split('$$')[0]);
    } 

    this.state = {
      value:props.value,
      data:props.data,
      show:'none',
      index:props.index,
      updateBackground:props.updateBackground,
      callback:props.callback,
      backgroundType:props.backgroundType,
      identity:props.id,
      id:props.id,
      widgetType:props.widgetType,
      opacity:opacity
    } 
    this.handleOpacityChange = this.handleOpacityChange.bind(this);
    this.debouncedCallback = debounce((newColor) => {
      this.state.callback(this.state.id, newColor, this.state.backgroundType);
    }, 300);

  }
  
  componentWillReceiveProps(nextProps){ 
    const self = this;  
    let opacity = "";
    if(nextProps.backgroundType === "color"){
      opacity = app.getOpacity(nextProps.value);
    } 
    if(nextProps.backgroundType === "l_gradient"){
      opacity = app.getOpacity(nextProps.value.split('$$')[0]);
    } 

    if(nextProps.value !== undefined){
      self.setState({
        value:nextProps.value || '#00000000',
        data:nextProps.data,
        index:nextProps.index,
        updateBackground:nextProps.updateBackground,
        callback:nextProps.callback,
        backgroundType:nextProps.backgroundType,
        identity:nextProps.id,
        id:nextProps.id,
        widgetType:nextProps.widgetType,
        opacity:opacity, 
      })
    } 
  }
//value, self.state.backgroundType, self.state.callback, self.state.id, self.state.widgetType
  clickBackground(value, type, callback, id, widgetType) {
    if(widgetType && widgetType === "headerAi"){
      let div = document.createElement("div");
      // See app.imagePopup: marks an editor-created popup container so CSS can
      // raise it above the Manage Menu popup without touching host .modal markup.
      div.className = "ai-popup-layer";
      document.body.appendChild(div);
      ReactDOM.render(<BackgroundHeader id={id} callback={callback} value={value} type={type}/>, div);
    }
    else{
      let div = document.createElement("div");
      div.className = "ai-popup-layer";
      document.body.appendChild(div);
      ReactDOM.render(<Background id={id} callback={callback} value={value} type={type}/>, div);
    }
  }

  handleOpacityChange(key, value) { 
    const opacity = parseFloat(value);
    if (!isNaN(opacity)) {
      this.setState({
        opacity
      }, () => {
        let newColor = app.combineColor(this.state.value, this.state.opacity);
        if(this.state.backgroundType === "l_gradient"){
          newColor = `${app.combineColor(this.state.value.split('$$')[0], this.state.opacity)}$$${app.combineColor(this.state.value.split('$$')[1], this.state.opacity)}`;
        } 
        this.debouncedCallback(newColor); // Use the debounced callback
      });
    } else {
      console.error("Invalid opacity value:", opacity);
    }
  }

  removeBg(){
    const self = this;
    self.state.updateBackground("#00000000", "color", self.state.identity);
    self.setState({
      value:""
    })
  }
  render() {
    const self = this;
   
    const { value, index, className, opacity, backgroundType } = this.state; 
    
    let sliderColor = "";
    let backgroundStyle = {};
    if(value) {
      if(backgroundType === "l_gradient"){
        backgroundStyle = {"background":elementBackground(app.getPlanColor(value), backgroundType)};
        sliderColor =  `linear-gradient(90deg, rgba(0, 255, 255, 0), ${app.getPlanColor(value.split("$$")[0])}, ${app.getPlanColor(value.split("$$")[1])})` 
      }
      else if(backgroundType === "color"){ 
        backgroundStyle = {"background":elementBackground(app.getPlanColor(value), backgroundType)};
        sliderColor = `linear-gradient(90deg, rgba(0, 255, 255, 0) 0%, ${app.getPlanColor(value)} 100%)`;
        
      }
      else{
        backgroundStyle = {"background":elementBackground(value, backgroundType)}
      }
    }
 
    let noUi = ""
    if(backgroundType === "color" || backgroundType === "l_gradient"){
      noUi = <Nouislider range={{ min: 0, max: 100 }} step="1" start={opacity} connect={"lower"} id={this.props.id} connectColor="transparent" handleColor={sliderColor} callback={this.handleOpacityChange}/>
    }    

      return   <div className="itemContainer"> 
      <label className="d-block">{self.props.type}</label>
      <div className='d-flex' data-backgroundtype={backgroundType}>
        {noUi} 
          <div className="colorBox" data-type={backgroundType}>
            {value ?
              <div className='w-100 h-100' style={backgroundStyle} onClick={() => self.clickBackground(value, self.state.backgroundType, self.state.callback, self.state.id, self.state.widgetType)}></div>
              :
              <div className="color-transparent" onClick={() => self.clickBackground(value, self.state.backgroundType, self.state.callback, self.state.id, self.state.widgetType)}></div>
            }
          </div> 
        </div>
 
  </div>
  }
}
 
export function debounce(func, delay) {
  let timeoutId; 
  return function() {
    const context = this;
    const args = arguments;
    
    clearTimeout(timeoutId);
    
    timeoutId = setTimeout(function() {
      func.apply(context, args);
    }, delay);
  };
}

export function PaddingComponent(props) {
  const domEle = useRef();
  let scope = '0,0,0,0'.split(',').map(Number);
  if (props.value || props.value !== undefined) {
    scope = props.value.split(',').map(Number);
  }
  let title = '';
  if (props.title) {
    title = props.title;
  }
  
  const [values, setValues] = useState(scope);
  const [optionsVal, setOptionsVal] = useState(true);
  const maxSize = props.id === 'rounded' || props.id === 'borderCorners' ? '50' : '100';
 
  // const handleInputChange = (index, event) => { 
  //   let inputValue = parseInt(event.target.value);
  //   inputValue = Math.max(0, Math.min(inputValue, maxSize)); 
  //   let updatedValues = values.map((value, idx) => (idx === index ? inputValue : value));
  //   if(!optionsVal) { 
  //     for (let i = 1; i < updatedValues.length; i++) {
  //       updatedValues[i] = inputValue;
  //     } 
  //      // updatedValues = Array(values.length).fill(inputValue); 
  //   }
  //   setValues(updatedValues);
  //   props.callback(props.id, updatedValues.join(','));
  // };

  const handleInputChange = (index, event) => { 
    let inputValue = parseInt(event.target.value);
    inputValue = Math.max(0, Math.min(inputValue, maxSize)); 
    let updatedValues = values.map((value, idx) => (idx === index ? inputValue : value));

    if (!optionsVal) { 
      // When optionsVal is false, set all inputs to the same value as the current input
      updatedValues = Array(values.length).fill(inputValue);
    }

    setValues(updatedValues);
    props.callback(props.id, updatedValues.join(','));
};

  const handleEmptyInput = (index) => {
    if (values[index] === '' || isNaN(values[index])) {
      const updatedValues = [...values];
      updatedValues[index] = 0; 
      setValues(updatedValues);
      props.callback(props.id, updatedValues.join(','));
    }
  }; 

  const moreOptions = (event) => {
    if (domEle.current) {
      const dataType = event.currentTarget.getAttribute('data-type');
      
      // Check if dataType is 'true' or 'false'
      const isOptionsValTrue = dataType === 'true';
  
      if (isOptionsValTrue) {
        // If optionsVal is true, toggle to false
        setOptionsVal(false);
        let updatedValues = Array(values.length).fill(values[0]);  
        setValues(updatedValues);
        props.callback(props.id, updatedValues.join(','));
      } else {
        // If optionsVal is false, toggle to true
        setOptionsVal(true); 
      }
    }
  };
  
  useEffect(() => {
    if (domEle.current) {
      setValues(scope);
      if (props.value || props.value !== undefined) {
        setValues(props.value.split(',').map(Number));
      }
    }
  }, [props]);

  let listArray = values.map(function(value, index){
    // listArray = values.map((value, index) => (
      let spaceTitle = "";
      if(index === 0){
        spaceTitle = app.getLang("top")
      }
      if(index === 1){
        spaceTitle = app.getLang("right")
      }
      if(index === 2){
        spaceTitle = app.getLang("bottom")
      }
      if(index === 3){
        spaceTitle = app.getLang("left")
      }
     return <div className="m-0" key={index}>
        <small className='space-title'>{spaceTitle}</small>
        <input
          type="number" inputMode="numeric" pattern="[0-9]*" 
          className="numberBox ms-0 me-3"
          min="0"
          max={maxSize}
          data-id={`${index}`}
          value={value}
          data-type={`${optionsVal}`}
          onChange={(e) => handleInputChange(index, e)}
          onBlur={() => handleEmptyInput(index)}
        />
      </div>
    }); 

  return (
    <div className={`align-items-center spacing-widget ${props.className}`} id={props.id} data-dom={domEle} ref={domEle}>
      {title?<label className="label">{title}</label>:null}
      <div className="d-flex"> 
        <div className="d-flex" style={{ flex: '2' }}>
          {listArray}
        </div>
        <div className="btn-group update-spacing">
          <button className='btn ic_ai_icon_link_1' id={props.id} onClick={moreOptions} data-type={optionsVal}></button>
        </div>
      </div>
    </div>
  );
}
 


export function RangeSlider(props) {
  const inputRef = useRef(null); // Creating a ref
  const [values, setValues] = useState(props.value);
  const maxSize = props.max;

  let timerRang;
  const handleInputChange = (event) => {
    clearTimeout(timerRang);
    const inputValue = event.target.value;
    const clampedValue = Math.max(0, Math.min(inputValue, maxSize));
    setValues(clampedValue);
  };

  const handleInputEnd = () => {
    timerRang = setTimeout(() => {
      props.callback(values);
    }, 100);
  };

  useEffect(() => {
    // Focus the input element when the component mounts
    inputRef.current.focus();
  }, []); // Run only once when the component mounts

  let unit = 'vw'
  let step = "0.1"
  if(props.id === "logoDimension" || props.id === "dropShadowBlur" || props.id === "dropShadowSpread" || props.id === "dropShadowDistance"){
    unit = 'px';
    step = ''
  }
  return (
    <div className='col-12'>
      <div className="form-check p-0">
        <label className="form-check-label mb-1 w-100 d-flex" htmlFor={props.id}>
          {props.title}
          <span className="ms-auto text-lowercase">{values}{unit}</span>
        </label>
        <input
          type="range"
          step={step}
          className="w-100 form-range"
          min="0"
          max={maxSize}
          id={props.id}
          defaultValue={values}
          onChange={handleInputChange}
          onMouseUp={handleInputEnd}
          ref={inputRef} // Assigning the ref here
        />
      </div>
    </div>
  );
}
 
 
 
export function Nouislider(props) {
  const sliderRef = useRef(null);
  const [value, setValue] = useState(props.start || 0);
  const [inputValue, setInputValue] = useState(props.start || 0);

  const { range, connect, id, connectColor, handleColor, callback } = props;
  
  const step = parseFloat(props.step);
  const isStepInteger = Number.isInteger(step);
  


  useEffect(() => {
    const slider = sliderRef.current; 
    console.log("sliderRef", sliderRef, value)
    // noUiSlider is a global from the nouislider.min.js <script> the page
    // loads. When that request fails the global is undefined and .create()
    // threw. Degrade to the plain number input instead.
    if (slider && !slider.noUiSlider && window.noUiSlider) {
        window.noUiSlider.create(slider, {
          start:value,
          connect: connect,
          range: range,
          step: step,
          format: {
            to: (value) => { 
              if (isStepInteger) {
                return Math.round(parseFloat(value));
              } else {
                // Ensure consistent decimal places if not an integer step
                return parseFloat(value).toFixed(2);
              }
            },
            from: (value) => {
              if (isStepInteger) { 
                return Math.round(parseFloat(value));
              } else {
                return parseFloat(value).toFixed(2);
              }
            }
          }
        }); 

        const debouncedCallback = (id, value) => {
          if (callback) {
            clearTimeout(debouncedCallback.timeout);
            debouncedCallback.timeout = setTimeout(() => { 
              callback(id, value);
            }, 300);
          }
        };

        slider.noUiSlider.on('change', (values) => {
          const newValue = isStepInteger ? Math.round(parseFloat(values[0])) : parseFloat(values[0]);
          setValue(newValue);
          setInputValue(newValue);
          debouncedCallback(id, newValue);
        });
    }
    return () => {
      // create() above is conditional — the ref may be unset, or the global
      // may have been missing — so only tear down what actually exists.
      if (slider && slider.noUiSlider) {
        slider.noUiSlider.destroy();
      }
    };
  }, [range, connect, callback, id, step, isStepInteger]);

  useEffect(()=>{  
    if (props.start !== undefined && sliderRef.current && sliderRef.current.noUiSlider) {
      setValue(props.start);
      setInputValue(props.start);
      sliderRef.current.noUiSlider.set(props.start);
    } 
  },[props.start])
  
  // Handle input change
  const handleInputChange = (event) => {
    let newValue = parseFloat(event.target.value);
    if (isNaN(newValue)) {
      newValue = 0;
    }
    if (isStepInteger) {
      newValue = Math.round(newValue);
    }
    if (newValue < range.min) {
      newValue = range.min;
    } else if (newValue > range.max) {
      newValue = range.max;
    }
    setValue(newValue);
    setInputValue(newValue);
    sliderRef.current.noUiSlider.set(newValue);
    if (callback) callback(id, newValue);
  };

  // Handle blur event
  const handleBlur = () => {
    let currentValue = parseFloat(inputValue);
    
    if (isNaN(currentValue)) {
      currentValue = 0;
    } else if (isStepInteger) {
      currentValue = Math.round(currentValue);
    }

    if (currentValue < range.min) {
      currentValue = range.min;
    } else if (currentValue > range.max) {
      currentValue = range.max;
    }

    setValue(currentValue);
    setInputValue(currentValue);
    sliderRef.current.noUiSlider.set(currentValue);
    
    if (callback) callback(id, currentValue);
  };

  // Update CSS variables for custom styling
  const styleData = ` 
    #${id}.noUiSlider_wrapper .noUi-target { 
      background: ${handleColor || '#e74c3c'};
    }
    #${id}.noUiSlider_wrapper .noUi-connect { 
      background: ${connectColor || '#c0392b'};
    } 
  `;

  return (
    <div className='noUiSlider_wrapper d-flex align-items-center justify-content-center' id={id}>
      <style>{styleData}</style>
      <div className='w-100' ref={sliderRef} id={id}></div>
      <input
        type="number"
        value={inputValue}
        min={range.min}
        max={range.max}
        step={step}
        onChange={handleInputChange}
        onBlur={handleBlur}
        id="input-number"
        className='numberBox'
      />
    </div>
  );
}





export class Background extends React.Component {
  constructor(props) {
    super(props); 
    let  fromColor = "#000000";
    let  toColor = "#000000";
    if(props.type === "l_gradient") {
      fromColor = props.value.split("$$")[0];
      toColor = props.value.split("$$")[1]
    }
    
    this.state = {
      value: props.value,
      text:props.text,
      type:props.type,
      config:app.getConfig(),
      color:null, 
      show:"none",
      fromColor,
      toColor,
      id:props.id
    }

    this.remove = this.remove.bind(this);
    this.update = this.update.bind(this);
    this.openTabs = this.openTabs.bind(this);
    this.updateGradient = this.updateGradient.bind(this);
    this.onInput = this.onInput.bind(this);

    this.setShow = this.setShow.bind(this);
    this.setColor = this.setColor.bind(this);
  }
 
  setColor(color) {
    this.setState({
      color
    })
  }
  setShow(show) {
    let self = this 
   // self.props.update(this.state.color, "color");
    self.setState({
      show
    })
  }
  updateColor(show) {
    this.setState({
      show
    })
  } 
  componentDidMount() {
    let self = this
    // window.AColorPicker.from(".divColor").on("change", function(a) {
    //   self.setColor(`#${a.all.hexcss4.substr(7)}${a.all.hex.replace("#", "")}`);
    // })
    let {value, type} = self.state;
    let tabLinks = ReactDOM.findDOMNode(this).querySelectorAll(".sidebar-nav a");
    tabLinks.forEach(function (el) {
      el.addEventListener("click", self.openTabs);
    });

    const domLinks = ReactDOM.findDOMNode(this).querySelectorAll(".sidebar-pannel a");
    const domLibrary = ReactDOM.findDOMNode(this).querySelectorAll(".library");
    domLinks.forEach(function (v, i) {
      v.addEventListener("click", function () {
        if(document.querySelector(".listParent")){
          document.querySelector(".listParent").scroll(0,0)
        } 
        domLinks.forEach(function (v, i) {
          v.classList.remove("active");
        })
        domLibrary.forEach(function (v, i) {
          v.style.display = "none";
        })
       
        domLinks[i].classList.add("active");
        // domLibrary[i].style.display = "block";
        domLibrary[i].style.display = "flex";
      })
    })
    
    if(type) {
      if(type === "color") {
        tabLinks[0].click();
      }
      else if(type === "l_gradient") {
        tabLinks[1].click();
      }
      else if(type === "pattern") {
        tabLinks[3].click();
      }
      else if(type === "background") {
        tabLinks[4].click();
      }
      else if(type === "library") {
        tabLinks[5].click();
      }
      else if(type === "custom") {
        tabLinks[6].click();
      }
      else {
        tabLinks[0].click();
      }
    }
    else {
      tabLinks[0].click();
    }
  }
  update(e, type) {
    let self = this;
    if(type === "color"){
      let value = e.currentTarget.value
      if(value && value !== ""){  
        this.props.callback(self.state.id, e.currentTarget.value, type);
      }
    }
    else{
       this.props.callback(self.state.id, e, type);
    } 
  }
  onInput(e) {
    this.setState({
      value: e.currentTarget.value
    })
  }
  updateGradient(e) {
    let domEle = ReactDOM.findDOMNode(this);
    let id = e.currentTarget.getAttribute("id");
    let fromColor = domEle.querySelector("#fromColor").value;
    let toColor = domEle.querySelector("#toColor").value;
    if(id === "fromColor") {
      fromColor = e.currentTarget.value;
    }
    if(id === "toColor") {
      toColor = e.currentTarget.value;
    }
    this.setState({
      value: `linear-gradient(to bottom right, ${fromColor}, ${toColor})`
    })
  }

  
  openTabs(el) {
    let btnTarget = el.currentTarget;
    let currentTarget = el.currentTarget.getAttribute('data-id');
    let tabLinks = ReactDOM.findDOMNode(this).querySelectorAll(".sidebar-nav a");
    let tabContent = ReactDOM.findDOMNode(this).querySelectorAll(".tab-content .tab-pane");
    tabContent.forEach(function (el) {
      el.classList.remove("active");
      let currentContent = el.getAttribute('data-id');
      if (currentTarget === currentContent) {
        el.classList.add("active");
      }
    });
    tabLinks.forEach(function (el) {
      el.classList.remove("active");
    });
    btnTarget.classList.add("active");
  }
  remove() {
    ReactDOM.findDOMNode(this).parentElement.remove();
  }
  render() {
    let self = this; 
    const {type, callback} = self.props; 
    let { categories, value, text, config, show, fromColor, toColor } = self.state;
    
    let upload =  <div className="tab-pane" data-id="custom">
      <CustomUpload callback={function(image){
         self.update(image, 'custom')
      }} />
    </div>
    if(app.getProject() === "admin") {
      upload = <div className="tab-pane" data-id="custom">
      <AdminUpload callback={function(image){
        self.update(image, 'custom')
      }} />
      </div>
      
    }
   
    return <div className="modal" style={{ display: "block" }}>
      <div className="modal-dialog modal-dialog-scrollable modal-xl">
        <div className="modal-content">
        
          <div className="modal-header">
            <h5 className="modal-title">{app.getLang("chooseBackground")}</h5>
            <button type="button" className="close-popup modal-close position-relative fa-sharp icon-cancel icon-cancel" onClick={() => this.remove()}></button>
          </div> 

          <div className="modal-body d-block d-sm-flex d-md-flex d-lg-flex d-xl-flex p-0 row m-0">

            <div className="col-lg-3 col-md-4 col-sm-5 border-custom mh-100">
              <nav className="nav sidebar-nav w-100 h-100 p-3 pt-2 d-block overflow-auto">
                <a className="nav-link active" data-id="colors">{app.getLang("colors")}</a>
                <a className="nav-link"  data-id="gradients">{app.getLang("gradients")}</a>
                <a className="nav-link d-none"  data-id="generate">{app.getLang("generate")}</a>
                <a className="nav-link" data-id="patterns">{app.getLang("patterns")}</a>
                <a className="nav-link" data-id="backgrounds">{app.getLang("backgrounds")}</a>
                <a className="nav-link" data-id="images">{app.getLang("library")}</a>
                <a className="nav-link" data-id="custom">{app.getLang("custom_upload")}</a>  
              </nav>
            </div>


            <div className="tab-content col-lg-9 col-md-8 col-sm-7 sidebar-right p-4">
              <div className="tab-pane active" data-id="colors">
                <div className="row">
                  <div className="col-12 col-md-12 col-lg-12 "> 
                 
                      <div className="d-flex mb-3 widget-select-bgcolor">
                        <ColorWidget id="color" value={self.state.value} index="1" callback={function(value) {
                                self.setState({
                                  value
                                })
                        }} />

                        {/* <ColorPickerWidget id="color" value={self.state.value} index="1" callback={function(value) {
                                self.setState({
                                  value
                                })
                        }} /> */}
                        
                        <button className="btn btn-primary float-end ms-3" value={self.state.value} id="backgroundColor" data-index={self.props.index} onClick={(e)=>self.update(e, 'color')}>{app.getLang("select")}</button> 
                      </div> 
                      <hr className="mt-4"/>
                  </div>

                  <div className="col-md-12"> 
                  <h6 className="mb-3 mt-2 small_title">{app.getLang("colors")}</h6> 
                    <div className="color-list">
                      
                      {
                          config.colors.map(function (v,i) {
                            return <button key={'px'+i} style={{ background: v }} value={v} id="backgroundColor" data-index={self.props.index} onClick={(e)=>self.update(e, 'color')}></button>
                          })
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div className="tab-pane active" data-id="gradients">
                <div className="row">
                <div className="col d-flex">
                    <div className="builder-widget me-2">
                          <label className="d-block fw-bold col-12 mb-2">{app.getLang("from_Color")}</label>
                          <ColorWidget2 id="fromColor" value={fromColor} index="2" callback={function(fromColor) {
                                    self.setState({
                                      fromColor
                                    })
                            }} /> 
                      </div>
                      <div className="builder-widget me-2">
                          <label className="d-block fw-bold col-12 mb-2">{app.getLang("to_Color")}</label>
                          <ColorWidget2 id="toColor" value={toColor} index="3" callback={function(toColor) {
                                    self.setState({
                                      toColor
                                    })
                            }} /> 
                      </div>

                      <div>
                      <label className="d-block fw-bold col-12 mb-2 invisible" style={{fontSize: "12px"}}>{app.getLang("from_Color")}</label>
                        <button className="btn btn-primary" value={self.state.value} id="backgroundColor" data-index={self.props.index} onClick={() => self.update(`${fromColor}$$${toColor}`, "l_gradient")}>{app.getLang("select")}</button> 
                      </div>
                </div>
                  

                  <div className="col-md-12"> <hr className="mt-1"/></div>
                  <div className="col-md-12"> 
                  <h6 className="mb-3 mt-2 small_title">{app.getLang("gradients")}</h6> 
                    <div className="color-list">
                      {
                        config.gradients.map(function (v,i) {
                            const value = `linear-gradient(to bottom right, ${v.from}, ${v.to})`;
                            return <button key={'gr-'+i} style={{ backgroundImage: value,}} value={value} id="backgroundColor" data-index={self.props.index} onClick={() => self.update(`${v.from}$$${v.to}`, "l_gradient")}></button>
                          })
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div className="tab-pane" data-id="generate">
                <ImageGenerator callback={self.props.callback} text={text} src={value} />
              </div>
              <div className="tab-pane" data-id="patterns">
                <div className="row">
                  <div className="col-md-12">
                  <div className='listParent'>
                    <ul className="item-list">
                        {
                          config.patterns.map(function (v,i) {
                            return <li key={i}><input type="image" src={v.thumbnail} value={v.image} id="background" data-index={self.props.index} onClick={() => self.update(v.image,  "pattern")} alt="" /></li>
                          })
                        }
                      </ul>
                  </div>
                    
                  </div>
                </div>
              </div>
              <div className="tab-pane" data-id="backgrounds">
                <div className="row">



                  <div className="col-md-12">
                  <div className='listParent'>
                    <ul className="item-list">
                    {
                        config.backgrounds.map(function (v) {
                          return <li><input type="image" src={v.thumbnail} value={v.image} id="background" data-index={self.props.index} onClick={() => self.update(v.image,  "background")} alt="" /></li>
                        })
                      }
                     
                    </ul>
                  </div>

                  </div>
                </div>
              </div>
              
              <div className="tab-pane" data-id="images">   
                    <div className="category-items sidebar-pannel">
                      {
                        config.categories.map(function (v, i) {
                          let active = ""
                          if(i == 0){
                            active = "active"
                          }
                          return <a data-id={v.folder} className={`${active}`}>{app.getLang(v.key)}</a>
                        }) 
                      }
                    </div>
                    <div className='listParent'>
                    {
                      config.categories.map(function (val, ind) { 
                        let active = {display:"none"}
                        if(ind == 0){
                          active = {display:"flex"}
                        }
                        return <ul className="item-list library" id={val.folder} style={active}>
                          {
                            val.data.map(function (v) {
                              return <li><input type="image" src={v.thumbnail} id="background" data-index={self.props.index} onClick={() => self.update(v.image,  "library")} alt="" /></li>
                            })
                          }
                        </ul> 
                      })
                    }
                    </div>
              </div>
             {upload}
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}

export class BackgroundHeader extends React.Component {
  constructor(props) {
    super(props); 
    let  fromColor = "#000000";
    let  toColor = "#000000";
    if(props.type === "l_gradient") {
      fromColor = props.value.split("$$")[0];
      toColor = props.value.split("$$")[1]
    }
    
    this.state = {
      value: props.value,
      text:props.text,
      type:props.type,
      id:props.id,
      config:app.getConfig(),
      color:null, 
      show:"none",
      fromColor,
      toColor,
      identity:props.identity
    }

    this.remove = this.remove.bind(this);
    this.update = this.update.bind(this);
    this.openTabs = this.openTabs.bind(this);
    this.updateGradient = this.updateGradient.bind(this);
    this.onInput = this.onInput.bind(this);

    this.setShow = this.setShow.bind(this);
    this.setColor = this.setColor.bind(this);
  }
 
  setColor(color) {
    this.setState({
      color
    })
  }
  setShow(show) {
    let self = this 
   // self.props.update(this.state.color, "color");
    self.setState({
      show
    })
  }
  updateColor(show) {
    this.setState({
      show
    })
  } 
  componentDidMount() {
    let self = this
    // window.AColorPicker.from(".divColor").on("change", function(a) {
    //   self.setColor(`#${a.all.hexcss4.substr(7)}${a.all.hex.replace("#", "")}`);
    // })
    let {value, type} = self.state;
    let tabLinks = ReactDOM.findDOMNode(this).querySelectorAll(".sidebar-nav a");
    tabLinks.forEach(function (el) {
      el.addEventListener("click", self.openTabs);
    });

    const domLinks = ReactDOM.findDOMNode(this).querySelectorAll(".sidebar-pannel a");
    const domLibrary = ReactDOM.findDOMNode(this).querySelectorAll(".library");
    domLinks.forEach(function (v, i) {
      v.addEventListener("click", function () {
        if(document.querySelector(".listParent")){
          document.querySelector(".listParent").scroll(0,0)
        } 
        domLinks.forEach(function (v, i) {
          v.classList.remove("active");
        })
        domLibrary.forEach(function (v, i) {
          v.style.display = "none";
        })
       
        domLinks[i].classList.add("active");
        domLibrary[i].style.display = "block";
      })
    })
    
    if(type) {
      if(type === "color") {
        tabLinks[0].click();
      }
      else if(type === "l_gradient") {
        tabLinks[1].click();
      } 
      else if(type === "images") {
        tabLinks[2].click();
      }
      else if(type === "custom") {
        tabLinks[3].click();
      }
      else {
        tabLinks[0].click();
      }
    }
    else {
      tabLinks[0].click();
    }
  }
  update(e, type) {
    let self = this;
    if(type === "color"){
      let value = e.currentTarget.value
      if(value && value !== ""){  
        // console.log("self.state.id, e.currentTarget.value, type", self.state.id, e.currentTarget.value, type)
        this.props.callback(self.state.id, e.currentTarget.value, type);
      }
    }
    else{
       this.props.callback(self.state.id, e, type);
    } 
  }

  // update(e, type) { 
  //   let self = this;
  //   if(type === "color"){
  //     let value = e.currentTarget.value
  //     if(value && value !== ""){ 
  //       self.props.callback(e.currentTarget.value, type, self.state.identity);
  //       // if(!app.getDevice()){
  //       //   self.props.updateBackgroundHeaderAi(type)
  //       // } 
  //     }
  //   }
  //   else{
  //     self.props.callback(e, type, self.state.identity);
  //     // if(!app.getDevice()){
  //     //   self.props.updateBackgroundHeaderAi(type)
  //     // } 
  //   } 
  // }

 
  onInput(e) {
    this.setState({
      value: e.currentTarget.value
    })
  }
  updateGradient(e) {
    let domEle = ReactDOM.findDOMNode(this);
    let id = e.currentTarget.getAttribute("id");
    let fromColor = domEle.querySelector("#fromColor").value;
    let toColor = domEle.querySelector("#toColor").value;
    if(id === "fromColor") {
      fromColor = e.currentTarget.value;
    }
    if(id === "toColor") {
      toColor = e.currentTarget.value;
    }
    this.setState({
      value: `linear-gradient(to bottom right, ${fromColor}, ${toColor})`
    })
  }

  
  openTabs(el) {
    let btnTarget = el.currentTarget;
    let currentTarget = el.currentTarget.getAttribute('data-id');
    let tabLinks = ReactDOM.findDOMNode(this).querySelectorAll(".sidebar-nav a");
    let tabContent = ReactDOM.findDOMNode(this).querySelectorAll(".tab-content .tab-pane");
    tabContent.forEach(function (el) {
      el.classList.remove("active");
      let currentContent = el.getAttribute('data-id');
      if (currentTarget === currentContent) {
        el.classList.add("active");
      }
    });
    tabLinks.forEach(function (el) {
      el.classList.remove("active");
    });
    btnTarget.classList.add("active");
  }
  remove() {
    ReactDOM.findDOMNode(this).parentElement.remove();
  }
  render() {
    let self = this; 
    const {type, callback} = self.props; 
    let { categories, value, text, config, show, fromColor, toColor } = self.state;
    
    let upload =  <div className="tab-pane" data-id="custom">
      <CustomUpload callback={function(image){
        self.update(image, 'custom')
      }} />
    </div>
    if(app.getProject() === "admin") {
      upload = <div className="tab-pane" data-id="custom">
      <AdminUpload callback={function(image){
        self.update(image, 'custom')
      }} />
      </div> 
    }
   
    return <div className="modal headerModal" style={{ display: "block" }}>
      <div className="modal-dialog modal-dialog-scrollable modal-xl">
        <div className="modal-content"> 
          <div className="modal-header">
            <h5 className="modal-title">{app.getLang("chooseBackground")}</h5>
            <button type="button" className="close-popup modal-close position-relative fa-sharp icon-cancel icon-cancel" onClick={() => this.remove()}></button>
          </div> 

          <div className="modal-body d-block d-sm-flex d-md-flex d-lg-flex d-xl-flex p-0 row m-0">

            <div className="col-lg-3 col-md-4 col-sm-5 border-custom mh-100">
              <nav className="nav sidebar-nav w-100 h-100 p-3 pt-2 d-block overflow-auto">
                <a className="nav-link active" data-id="colors">{app.getLang("colors")}</a>
                <a className="nav-link"  data-id="gradients">{app.getLang("gradients")}</a>  
                <a className="nav-link" data-id="patterns">{app.getLang("patterns")}</a>
                {!app.getDevice()?<a className="nav-link" data-id="image">{app.getLang("backgrounds")}</a>:null}
                {!app.getDevice()?<a className="nav-link" data-id="custom">{app.getLang("custom_upload")}</a>:<a className="nav-link" data-id="custom">{app.getLang("custom_upload")}</a>}
              </nav>
            </div>


            <div className="tab-content col-lg-9 col-md-8 col-sm-7 sidebar-right p-4">
              <div className="tab-pane active" data-id="colors">
                <div className="row">
                  <div className="col-12 col-md-12 col-lg-12"> 
                      <div className="d-flex mb-3">
                      <ColorWidget2 id="color" value={self.state.value} index="4" callback={function(value) {
                                self.setState({
                                  value
                                })
                        }} />
                        
                        <button className="btn btn-primary float-end ms-3" value={self.state.value} id="backgroundColor" data-index={self.props.index} onClick={(e)=>self.update(e, 'color')}>{app.getLang("select")}</button> 
                      </div> 
                      <hr className="mt-4"/>
                  </div>

                  <div className="col-md-12"> 
                  <h6 className="mb-3 mt-2 small_title">{app.getLang("colors")}</h6> 
                    <div className="color-list">
                      
                      {
                          config.colors.map(function (v,i) {
                            return <button key={'mx'+i} style={{ background: v }} value={v} id="backgroundColor" data-index={self.props.index} onClick={(e)=>self.update(e, 'color')}></button>
                          })
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div className="tab-pane active" data-id="gradients">
                <div className="row">
                <div className="col d-flex">
                    <div className="builder-widget me-2">
                          <label className="d-block fw-bold col-12 mb-2">{app.getLang("from_Color")}</label>
                          <ColorWidget2 id="fromColor" value={fromColor} index="5" callback={function(fromColor) {
                                    self.setState({
                                      fromColor
                                    })
                            }} /> 
                      </div>
                      <div className="builder-widget me-2">
                          <label className="d-block fw-bold col-12 mb-2">{app.getLang("to_Color")}</label>
                          <ColorWidget2 id="toColor" value={toColor} index="6" callback={function(toColor) {
                                    self.setState({
                                      toColor
                                    })
                            }} /> 
                      </div>

                      <div>
                      <label className="d-block fw-bold col-12 mb-2 invisible" style={{fontSize: "12px"}}>{app.getLang("from_Color")}</label>
                        <button className="btn btn-primary" value={self.state.value} id="backgroundColor" data-index={self.props.index} onClick={() => self.update(`${fromColor}$$${toColor}`, "l_gradient")}>{app.getLang("select")}</button> 
                      </div>
                </div>
                  

                  <div className="col-md-12"> <hr className="mt-1"/></div>
                  <div className="col-md-12"> 
                  <h6 className="mb-3 mt-2 small_title">{app.getLang("gradients")}</h6> 
                    <div className="color-list">
                      {
                        config.gradients.map(function (v,i) {
                            const value = `linear-gradient(to bottom right, ${v.from}, ${v.to})`;
                            return <button key={'gx'+i} style={{ backgroundImage: value,}} value={value} id="backgroundColor" data-index={self.props.index} onClick={() => self.update(`${v.from}$$${v.to}`, "l_gradient")}></button>
                          })
                      }
                    </div>
                  </div>
                </div>
              </div>
             
              <div className="tab-pane" data-id="patterns">
                <div className="row">
                  <div className="col-md-12">
                  <div className='listParent'>
                    <ul className="item-list">
                        {
                          config.patterns.map(function (v,i) {
                            return <li key={i}><input type="image" src={v.thumbnail} value={v.image} id="background" data-index={self.props.index} onClick={() => self.update(v.image,  "pattern")} alt="" /></li>
                          })
                        }
                      </ul>
                  </div>
                    
                  </div>
                </div>
              </div>

            {!app.getDevice()?
              <div className="tab-pane" data-id="image">
                <div className="row"> 
                  <div className="col-md-12">
                  <div className='listParent'>
                    <ul className="item-list header_library">
                    {
                        config.headers.map(function (v,i) {
                          return <li key={'mix'+i}><input type="image" src={v} value={v} id="image" data-index={self.props.index} onClick={() => self.update(v,  "image")} alt="" /></li>
                        })
                      }
                     
                    </ul>
                  </div>

                  </div>
                </div>
              </div>
            :null}

            {!app.getDevice()?
              <div className="tab-pane" data-id="custom">
                <CustomHeaderUpload callback={function(value){self.update(value, 'custom')}} /> 
              </div>
            :upload}

            </div>
          </div>
        </div>
      </div>
    </div>
  }
}


export class Images extends React.Component {
  constructor(props) {
    super(props);
    this.remove = this.remove.bind(this);
    this.openTabs = this.openTabs.bind(this); 
    this.state = {
      config:app.getConfig(),
      type:props.type
    }
  }
  componentDidMount() {
    let self = this
    let tabLinks = ReactDOM.findDOMNode(this).querySelectorAll(".sidebar-nav a");
    
    tabLinks.forEach(function (el) {
      el.addEventListener("click", self.openTabs);
    });

    const domLinks = ReactDOM.findDOMNode(this).querySelectorAll(".sidebar-pannel a");
    const domLibrary = ReactDOM.findDOMNode(this).querySelectorAll(".library");
    domLinks.forEach(function (v, i) {
      v.addEventListener("click", function () { 
        if(document.querySelector(".listParent")){
          document.querySelector(".listParent").scroll(0,0)
        } 
        domLinks.forEach(function (v, i) {
          v.classList.remove("active");
        })
        domLibrary.forEach(function (v, i) {
          v.style.display = "none";
        })
        domLinks[i].classList.add("active");
        domLibrary[i].style.display = "flex";
      })
    })
    tabLinks[0].click();
    //domLinks[0].click();
  }
  openTabs(el) {
    let btnTarget = el.currentTarget;
    let currentTarget = el.currentTarget.getAttribute('data-id');
    let tabLinks = ReactDOM.findDOMNode(this).querySelectorAll(".sidebar-nav a");
    let tabContent = ReactDOM.findDOMNode(this).querySelectorAll(".tab-content .tab-pane");
    tabContent.forEach(function (el) {
      el.classList.remove("active");
      let currentContent = el.getAttribute('data-id');
      if (currentTarget === currentContent) {
        el.classList.add("active");
      }
    });
    tabLinks.forEach(function (el) {
      el.classList.remove("active");
    });
    btnTarget.classList.add("active");
  }
  remove() {
    ReactDOM.findDOMNode(this).parentElement.remove();
  }
  update(value) {
    let self = this; 
    if(self.state.type){
      self.props.callback(self.state.type, value)
    } 
    self.props.callback("src", value)
  }
  render() {
    let self = this;
    const {text, src} = self.props;
    let { config } = self.state; 
    // let tabs = ["Generate", "Library", "Custom Upload"];
    let tabs = [
        {key:"library",value:app.getLang("library")},
        {key:"custom_upload",value:app.getLang("custom_upload")},
        // {key:"generated_images",value:app.getLang("generated_images")}
      ];
    if(self.state.type) {
      // tabs = ["Icons", "Generate", "Library", "Custom Upload"];
      tabs = [{key:"icons",value:app.getLang("icons")},{key:"library",value:app.getLang("library")},{key:"custom_upload",value:app.getLang("custom_upload")}];
    }
    if(app.getProject() === "admin") { 
      tabs = [{key:"library",value:app.getLang("library")},{key:"custom_upload",value:app.getLang("custom_upload")}];
      if(self.state.type) {
        tabs = [{key:"icons",value:app.getLang("icons")},{key:"library",value:app.getLang("library")},{key:"custom_upload",value:app.getLang("custom_upload")}];
      }
    }
 
    return <div className="modal" style={{ display: "block" }}>
      <div className="modal-dialog modal-dialog-scrollable modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{app.getLang("chooseImage")}</h5>
            <button type="button" className="close-popup modal-close position-relative fa-sharp icon-cancel icon-cancel" onClick={() => this.remove()}></button>
          </div>
          <div className="modal-body d-block d-sm-flex d-md-flex d-lg-flex d-xl-flex p-0 row m-0">
            <div className="col-lg-3 col-md-4 col-sm-5 border-custom mh-100">
                <nav className="nav w-100 h-100 p-3 pt-2 d-block sidebar-nav overflow-auto">
                  {
                    tabs.map(function(v,i) {
                      return  <a key={v.key} className="nav-link" data-id={v.key}>{v.value}</a>
                    })
                  }
                </nav>
            </div> 

            <div className="tab-content col-lg-9 col-md-8 col-sm-7 sidebar-right p-4">
              {
                tabs.map(function(v) {
                  if(v.key === "icons") {
                    return <div className="tab-pane" data-id={v.key} key={v.key}> 
                      <IconList callback={function(value){self.update(value)}}/> 
                    </div>
                  }
                 
                  else if(v.key === "library") {
                    return <div className="tab-pane" data-id={v.key} key={v.key}> 
                     <div className="category-items sidebar-pannel">
                    {
                      config.categories.map(function (v, i) {
                        let active = ""
                        if(i == 0){
                          active = "active"
                        }
                        return <a key={i} data-id={v.folder} className={`${active}`}>{app.getLang(v.key)}</a>
                      })
                    }
                  </div> 
                    <div className='listParent'>
                    {
                      config.categories.map(function (val, ind) {
                        let active = {display:"none"}
                        if(ind == 0){
                          active = {display:"flex"}
                        }
                        return <ul key={ind} className="item-list library" id={val.folder} style={active}>
                          {
                            val.data.map(function (v,i) {
                              return <li key={i}><input type="image" src={v.thumbnail} id="background" value={v.image}  onClick={() => self.update(v.image)} alt="" /></li>
                            })
                          }
                          
                        </ul> 
                      })
                    }  
                    </div>
                    </div>
                  }
                  else if(v.key === "generated_images") {
                    return <div className="tab-pane" data-id={v.key}>
                      <ImageGenerator callback={function(value){self.update(value)}}/>
                    </div>
                  }
                  else if(v.key === "custom_upload") {
                    if(app.getProject() === "admin") {
                      return <div className="tab-pane" data-id={v.key}>
                        <AdminUpload callback={function(value){self.update(value)}}/>
                      </div>
                    }
                    else {
                      return <div className="tab-pane" data-id={v.key}>
                        <CustomUpload callback={function(value){self.update(value)}}/>
                      </div>
                    }
                  }
                })
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}

export class ConnectionModel extends React.Component {
  constructor(props) {
    super(props); 
    this.state = {
      value: props.value, 
      send:false,
      dataType:props.type, 
      searchCountry:""
    }
    this.remove = this.remove.bind(this);
    this.update = this.update.bind(this);
    this.save = this.save.bind(this);  
    this.clear = this.clear.bind(this);  
    this.checkCodeWhatsapp = this.checkCodeWhatsapp.bind(this);  
    this.checkCode = this.checkCode.bind(this);
  }

  componentDidMount() {
    const self = this;
    let data = self.props.value; 
    if(self.state.dataType){
      self.showTab(self.state.dataType) 
    }else{
      self.showTab("url") 
    }
    
    setTimeout(function(){
      let tabContent = ReactDOM.findDOMNode(self).querySelector(".tab-content .tab-pane.active");

    if(self.state.dataType === "textHtml") { 
      tabContent.querySelector('.form-control').value = data;
      self.setState({
        value:data
      })
    }

    if(self.state.dataType === "url") { 
      tabContent.querySelector('.form-control').value = data;
      self.setState({
        value:data
      })
    }

    if(self.state.dataType === "email") {   
      tabContent.querySelector('.form-control').value = data;
      self.setState({
        value:data
      })
    }

    if(self.state.dataType === "whatsapp") {   
      let row = data.replace("tel:", ""); 
      if(row.indexOf("+") === 0) {
        row = row.split('-')
        tabContent.querySelector('#country-codes-whatsapp').innerHTML = row[0];
        tabContent.querySelector('#whatsappNumber').value = row[1]; 
      }
      else {
        tabContent.querySelector('#country-codes-whatsapp').innerHTML = "none";
        tabContent.querySelector('#whatsappNumber').value = row; 
      }
      self.setState({
        value:data
      })
      // let row = data.split('-')
      // tabContent.querySelector('#country-codes-whatsapp').innerHTML = row[0];
      // tabContent.querySelector('#whatsappNumber').value = row[1];  
      //  this.setState({
      //   value:data
      // })
    }

    if(self.state.dataType === "skype") {   
      tabContent.querySelector('.form-control').value = data;
      self.setState({
        value:data
      })
    } 

    if(self.state.dataType === "phone") {  
      let row = data.replace("tel:", ""); 
      if(row.indexOf("+") === 0) {
        row = row.split('-')
        tabContent.querySelector('#country-codes').innerHTML = row[0];
        tabContent.querySelector('#phoneNumber').value = row[1]; 
      }
      else {
        tabContent.querySelector('#country-codes').innerHTML = "none";
        tabContent.querySelector('#phoneNumber').value = row; 
      }
      self.setState({
        value:data
      })
    } 
    if(self.state.dataType === "location") {   
      tabContent.querySelector('.form-control').value = data;
      self.setState({
        value:data
      })
    }
    }, 300)
  }
  showTab(tab){  
  if(document.querySelector('.mobile-ai.mobile-view')){ 
    window.restoreSelection(); 
  }
  let tabLinks = ReactDOM.findDOMNode(this).querySelectorAll(".sidebar-nav a");
  let tabContent = ReactDOM.findDOMNode(this).querySelectorAll(".tab-content .tab-pane");
	switch(tab) 
    {
      case tab:
        tabContent.forEach(function (el) {
          el.classList.remove("active"); 
          if (tab === el.getAttribute('data-id')) {
            el.classList.add("active");
          }
        });
        tabLinks.forEach(function (el) {
          el.classList.remove("active");
          if (tab === el.getAttribute('data-id')) {
            el.classList.add("active");
          }
        }); 
      break;  
      }
  } 
  remove() {
    ReactDOM.findDOMNode(this).parentElement.remove();
  }
  validateEmail(emailId) {
    if (emailId) {
      var atpos = emailId.indexOf("@");
      var dotpos = emailId.lastIndexOf(".");
      if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= emailId.length) {
        return;
      }
      return true;
    } else {
      return;
    }
  }
  validatePhone(phoneno) { 
    if (phoneno.length > 5) return phoneno;
  }
  validateWhatsUpPhone(phoneno) { 
    if (phoneno.length > 5) return phoneno;
  }
  validateURL(url) { 
    let regex = /^https:\/\/.+/i; 
    return regex.test(url); 

    // var res = url.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
    // if(res == null)
    //     return false;
    // else
    //     return true;
  }
  validateField(data) {  
    if(data){
      return true;
    }
    return false;
  }
 
  clear() {
    this.props.callback("");
    this.remove();
  }
  update(e) {
    const self = this;
    const o = e.currentTarget;
    const t = o.getAttribute("data-type");
    const domEle = ReactDOM.findDOMNode(this);

    let value = o.value;
    //textHtml
    if (t === "textHtml") {
      value = domEle.querySelector("#textHtml").value
    }
    if (t === "url") {
      value = domEle.querySelector("#url").value
    }
    if (t === "email") {
      value = domEle.querySelector("#email").value
    } 
    if (t === "whatsapp") {
      value = value = `${self.getPhoneValue("country-codes-whatsapp", "whatsappNumber")}`;
    }
    if (t === "skype") {
      value = domEle.querySelector("#skype").value
    } 
    if (t === "phone") {
      value = `${self.getPhoneValue("country-codes", "phoneNumber")}`;
    } 
    if (t === "location") {
      value = domEle.querySelector("#location").value
    }

    this.setState({
      value
    })

  }
  getPhoneValue(countryId, phoneId) {
    const domEle = ReactDOM.findDOMNode(this);
    let countryCode = domEle.querySelector(`#${countryId}`).innerHTML;
    if(countryCode === "none") {
      countryCode = "";
    }
    else {
      countryCode = countryCode + "-";
    }
    return `${countryCode}${domEle.querySelector(`#${phoneId}`).value}`;
  } 
  checkCodeWhatsapp(event){
    let self = this;
    let el = event.currentTarget.parentElement;   
    const domEle = ReactDOM.findDOMNode(this);
    if (el.classList.contains('active')) {
      el.classList.remove('active');
    }
    else {
      el.classList.add('active');
      let list = document.querySelectorAll("ul.country-code.whatsapp li a"); 
      list.forEach(function (v) {
        v.addEventListener("mousedown", function() { 
          document.getElementById('country-codes-whatsapp').innerHTML = this.getAttribute('data-code');
          let value = `${self.getPhoneValue("country-codes-whatsapp", "whatsappNumber")}`;
          self.setState({value}) 
          el.classList.remove('active'); 
        })
      })
    } 
  }


  checkCode(event){
    let self = this;
    let el = event.currentTarget.parentElement;   
    if (el.classList.contains('active')) {
      el.classList.remove('active');
    }
    else {
      el.classList.add('active');
      let list = document.querySelectorAll("ul.country-code.phoneNumber li a"); 
      list.forEach(function (v) {
        v.addEventListener("mousedown", function() { 
          document.getElementById('country-codes').innerHTML = this.getAttribute('data-code'); 
          let value = `${self.getPhoneValue("country-codes", "phoneNumber")}`;
          self.setState({value})
          el.classList.remove('active'); 
        })
      })
    } 
  }

  save() {

    let self = this; 
    const domEle = ReactDOM.findDOMNode(this);
    
    const textHtml = domEle.querySelector('#textHtml'); 
    const url = domEle.querySelector('#url');
    const email = domEle.querySelector('#email');
    const whatsappNumber = domEle.querySelector('#whatsappNumber');
    const skype = domEle.querySelector('#skype');
    const phoneNumber = domEle.querySelector('#phoneNumber'); 
    const location = domEle.querySelector('#location'); 

    //textHtml
    domEle.querySelectorAll('.linkModel .tab-pane.active').forEach(function(v){
      let dataID = v.getAttribute('data-id'); 

      if(dataID === 'textHtml'){ 
        if(!self.validateField(textHtml.value)){ 
          textHtml.parentElement.classList.add("error-field");
          textHtml.parentElement.classList.remove("valid-field"); 
          errorAlert(app.getLang("validUrl"), textHtml) 
          return false
        }else{
          self.setState({send:true})
          textHtml.parentElement.classList.remove("error-field");
          textHtml.parentElement.classList.add("valid-field");
          errorAlert("", textHtml) 
          self.props.callback(self.state.value, "textHtml");
          self.remove();
        }
      }

      if(dataID === 'url'){ 
        if(!self.validateURL(url.value)){ 
          url.parentElement.classList.add("error-field");
          url.parentElement.classList.remove("valid-field"); 
          errorAlert(app.getLang("validUrl"), url) 
          return false
        }else{
          self.setState({send:true})
          url.parentElement.classList.remove("error-field");
          url.parentElement.classList.add("valid-field");
          errorAlert("", url) 
          self.props.callback(self.state.value, "url");
          self.remove();
        }
      }
      if(dataID === 'email'){  
        if(!self.validateEmail(email.value)){ 
          email.parentElement.classList.add("error-field");
          email.parentElement.classList.remove("valid-field");
          errorAlert(app.getLang("validEmail"), email) 
          return false
        }else{
          self.setState({send:true})
          email.parentElement.classList.remove("error-field");
          email.parentElement.classList.add("valid-field");
          errorAlert("", email)
          self.props.callback(self.state.value, "email");
          self.remove();
        } 
      }
     
      if(dataID === 'whatsapp'){ 
        if(!self.validateWhatsUpPhone(whatsappNumber.value)){ 
          whatsappNumber.parentElement.classList.add("error-field");
          whatsappNumber.parentElement.classList.remove("valid-field");
          errorAlert(app.getLang("enterWhatsAppNumber"), whatsappNumber)  
          return false
        }else{ 
          whatsappNumber.parentElement.classList.remove("error-field");
          whatsappNumber.parentElement.classList.add("valid-field");
          errorAlert("", whatsappNumber) 
          self.props.callback(self.state.value, "whatsapp");
          self.remove();
        }
      }

      if(dataID === 'skype'){ 
        if(!self.validateField(skype.value)){ 
          skype.parentElement.classList.add("error-field");
          skype.parentElement.classList.remove("valid-field"); 
          errorAlert(app.getLang("validUrl"), skype) 
          return false
        }else{
          self.setState({send:true})
          skype.parentElement.classList.remove("error-field");
          skype.parentElement.classList.add("valid-field");
          errorAlert("", skype) 
          self.props.callback(self.state.value, "skype");
          self.remove();
        }
      }
      if(dataID === 'phone'){ 
        if(!self.validatePhone(phoneNumber.value)){ 
          phoneNumber.parentElement.classList.add("error-field");
          phoneNumber.parentElement.classList.remove("valid-field");
          errorAlert(app.getLang("enterPhoneNumber"), phoneNumber)  
          return false
        }else{ 
          phoneNumber.parentElement.classList.remove("error-field");
          phoneNumber.parentElement.classList.add("valid-field");
          errorAlert("", phoneNumber) 
          self.props.callback(self.state.value, "phone");
          self.remove();
        }
      }
      if(dataID === 'location'){ 
        if(!self.validateField(location.value)){ 
          location.parentElement.classList.add("error-field");
          location.parentElement.classList.remove("valid-field"); 
          errorAlert(app.getLang("validUrl"), location) 
          return false
        }else{
          self.setState({send:true})
          location.parentElement.classList.remove("error-field");
          location.parentElement.classList.add("valid-field");
          errorAlert("", location) 
          self.props.callback(self.state.value, "location");
          self.remove();
        }
      } 
    }) 
  }

  handleSearchChange = (e) => {
    this.setState({ searchCountry: e.target.value.toLowerCase() });
  };

  render() {
    let self = this;
    let disabled = true; 
    if (this.state.value !== "") {
      disabled = false;
    } 

    return <div className="modal model-sidebar linkModel link-editor-contact" style={{ display: "block" }}>
      <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{app.getLang("linkEditor")}</h5>
            <button type="button" className="close-popup modal-close position-relative fa-sharp icon-cancel icon-cancel" onClick={() => this.remove()}></button>
          </div>
          <div className="modal-body d-block d-sm-flex d-md-flex d-lg-flex d-xl-flex p-0 row m-0">
 
            <div className="col-lg-3 col-md-4 col-sm-5 border-custom mh-100">
              <nav className="nav sidebar-nav w-100 h-100 p-3 pt-2 d-block overflow-auto"> 
                <a className="nav-link" onClick={()=> self.showTab('textHtml')} data-id="textHtml">{app.getLang("text")}</a>
                <a className="nav-link" onClick={()=> self.showTab('url')} data-id="url">{app.getLang("url")}</a>
                <a className="nav-link" onClick={()=> self.showTab('email')} data-id="email">{app.getLang("email")}</a>
                <a className="nav-link" onClick={()=> self.showTab('whatsapp')} data-id="whatsapp">{app.getLang("whatsapp")}</a>
                <a className="nav-link" onClick={()=> self.showTab('skype')} data-id="skype">{app.getLang("skype")}</a>
                <a className="nav-link" onClick={()=> self.showTab('phone')} data-id="phone">{app.getLang("phone")}</a>
                <a className="nav-link" onClick={()=> self.showTab('location')} data-id="location">{app.getLang("location")}</a> 
              </nav>
            </div>

            <div className="tab-content col-lg-9 col-md-8 col-sm-7 sidebar-right p-4">
               
            <div className="tab-pane" data-id="textHtml">
                <div className="builder-widget">
                  <label className="d-block m-0">{app.getLang("text")}</label>
                  <input type="text" id="textHtml" className="form-control" placeholder="Lorem Ipsum is simply dummy text" onInput={self.update} data-type="textHtml"/>
                </div> 
              </div>

              <div className="tab-pane" data-id="url">
                <div className="builder-widget">
                  <label className="d-block m-0">{app.getLang("url")}</label>
                  <input type="text" id="url" className="form-control" placeholder="https://example.com" onInput={self.update} data-type="url"/>
                </div> 
              </div>

              <div className="tab-pane" data-id="email"> 
                <div className="builder-widget">
                  <label className="d-block m-0">{app.getLang("to")}</label>
                  <input type="text" id="email" className="form-control" placeholder="example@example.com" onInput={self.update} data-type="email" defaultValue={self.state.email}/>
                </div> 
              </div>
 
              <div className="tab-pane" data-id="whatsapp"> 
                <div className="builder-widget">
                  <label className="d-block m-0">{app.getLang("whatsappNumber")}</label>
                  <div className="input-group mb-3">
                    <div className="dropdown input-group-text bg-transparent border-0 border-bottom px-0 rounded-0 me-3 position-relative">
                      <button className="btn form-control bg-transparent border-0 rounded-0 dropdown-toggle px-0 shadow-none" onMouseDown={this.checkCodeWhatsapp} id="country-codes-whatsapp">
                        none
                      </button>
                      <div className="outer-dropdown" onMouseDown={self.checkCodeWhatsapp}></div>
                      <ul className="dropdown-menu country-code whatsapp">
                      <input type="text" className='form-control px-3 p-2 mb-3' placeholder="Search Country Name" value={self.state.searchCountry} onChange={this.handleSearchChange}/>
                      {
                        countryCode.map(function(v,i){
                          return <li key={i} style={{display:v.name.toLowerCase().includes(self.state.searchCountry) || self.state.searchCountry === ""? "block": "none",}}><a className="dropdown-item" href="#" value={v.dialCode} data-code={v.dialCode} data-type="whatsapp">{v.dialCode} {v.name}</a></li>
                         })
                      }
                      </ul>
                      
                    </div> 
                    <input type="text" id="whatsappNumber" className="form-control" placeholder="xx-xxxx-xxxx" onInput={self.update} maxLength={16} onKeyDown={app.phoneKeyDown} data-type="whatsapp" />
                  </div> 
                </div>
              </div>

              <div className="tab-pane" data-id="skype">
                <div className="builder-widget">
                  <label className="d-block m-0">{app.getLang("skype")}</label>
                  <input type="text" id="skype" className="form-control" placeholder="UserId" onInput={self.update} data-type="skype"/>
                </div> 
              </div> 

              <div className="tab-pane" data-id="phone">
                {/* <h5 className="mb-4">Phone</h5> */}
                <div className="builder-widget">
                  <label className="d-block m-0">{app.getLang("phoneNumber")}</label>
                  <div className="input-group mb-3">
                    <div className="dropdown input-group-text bg-transparent border-0 border-bottom px-0 rounded-0 me-3 position-relative">
                      <button className="btn form-control bg-transparent border-0 rounded-0 dropdown-toggle px-0 shadow-none" onMouseDown={self.checkCode} id="country-codes">
                      none
                      </button>
                      <div className="outer-dropdown" onMouseDown={self.checkCode}></div>
                      <ul className="dropdown-menu country-code phoneNumber">
                      <input type="text" className='form-control px-3 p-2 mb-3' placeholder="Search Country Name" value={ self.state.searchCountry} onChange={this.handleSearchChange}/>
                      {
                        countryCode.map(function(v,i){
                          return <li key={i} style={{display:v.name.toLowerCase().includes(self.state.searchCountry) || self.state.searchCountry === ""? "block": "none",}}><a className="dropdown-item" href="#" value={v.dialCode} data-code={v.dialCode} data-type="phone">{v.dialCode} {v.name}</a></li>
                         })
                      }
                      </ul>
                      
                    </div> 
                    <input type="text" id="phoneNumber" className="form-control" placeholder="xx-xxx-xxx-xxxx" autoComplete="off" onInput={self.update} maxLength={16} onKeyDown={app.phoneKeyDown} data-type="phone" />
                  </div> 
                </div>
              </div>
 
              <div className="tab-pane" data-id="location">
                <div className="builder-widget">
                  <label className="d-block m-0">{app.getLang("location")}</label>
                  <input type="text" id="location" className="form-control" placeholder="Noida, India" onInput={self.update} data-type="location"/>
                </div> 
              </div>
              
              <button className="btn btn-primary float-end ms-3" disabled={disabled} onClick={this.save}>{app.getLang("save")}</button>
              <button className="btn btn-secondary float-end" onClick={this.clear}>{app.getLang("clear")}</button>


            </div>
          </div>
        </div>
      </div>
    </div>
  }
}

export class Blocks extends React.Component {
  constructor(props) {
    super(props);
    this.remove = this.remove.bind(this);
    this.state = {
      blocks: [],
    }
  }
  openTabs(el) {
    let btnTarget = el.currentTarget;
    let currentTarget = el.currentTarget.getAttribute('data-id');
    let tabLinks = document.querySelectorAll(".sidebar-nav a");
    let tabContent = document.querySelectorAll(".tab-content .tab-pane");
    tabContent.forEach(function (el) {
      el.classList.remove("active");
      let currentContent = el.getAttribute('data-id');
      if (currentTarget === currentContent) {
        el.classList.add("active");
      }
    });
    tabLinks.forEach(function (el) {
      el.classList.remove("active");
    });
    btnTarget.classList.add("active");
  }
  remove() {
    ReactDOM.findDOMNode(this).parentElement.remove();
  }
  selectSection(val) {
    const self = this;
    //ReactDOM.findDOMNode(this).parentElement.remove();
    app.preloader(true, "Crafting Your Content and Images with AI");
    // generatePrompt(val).then(function(val){
    //   generateImages(val).then(function(val){
    //     self.props.callback(val);
    //     app.preloader(false);
    //   })
    // })
  }
  render() {
    let self = this;
    let { blocks } = this.state;
    return <div className="modal model-sidebar" style={{ display: "block" }}>
      <div className="modal-dialog modal-dialog-scrollable modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{app.getLang("addSection")}</h5>
            <button type="button" className="btn-close modal-close close-popup position-relative fa-sharp icon-cancel" onClick={() => this.remove()}></button>
          </div>
          <div className="modal-body row">
       
            <div className="tab-content col-lg-12 col-md-8 col-sm-7 sidebar-right p-4">
              <div className="tab-pane active">
                <div className="row">
                  <div className="col-md-12 img-list">
                    {
                      blocks.map(function (item, i) {
                        if(i >  38) {
                          return null;
                        }
                        return <img key={i} src={`${window.aiHost}/images/image-2x1.png`} data-index={i} alt="" onClick={() => self.selectSection(item)} style={{ background: `url(https://home.mediadirhub.com/images/blocks-ai/${item.id}.png)` }} />
                      })
                    }
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </div>
  }
}

export class Blocks2 extends React.Component {
  constructor(props) {
    super(props);
    this.remove = this.remove.bind(this);
    this.state = {
      blocks: JSON.parse(localStorage.getItem("blocks")),
      types: JSON.parse(localStorage.getItem("types")),
      typeId: ''
    }
    this.clickType = this.clickType.bind(this);
  }
  componentWillMount() {
    // const self = this;
    // app.getTypes().then(function(response){
    //   self.setState({
    //     types:response.blockType
    //   })
    // })
    // app.getBlocks().then(function(response){
    //   self.setState({
    //     data:response.blocks
    //   })
    // })
  }
  clickType(typeId) {
    this.setState({
      typeId
    })
  }
  componentDidMount() {
    // const self = this;
    // let tabLinks = ReactDOM.findDOMNode(self).querySelectorAll(".sidebar-nav a"); 
    // tabLinks.forEach(function(el) {
    //   //el.addEventListener("click", self.openTabs);
    // });

  }
  openTabs(el) {
    let btnTarget = el.currentTarget;
    let currentTarget = el.currentTarget.getAttribute('data-id');
    let tabLinks = document.querySelectorAll(".sidebar-nav a");
    let tabContent = document.querySelectorAll(".tab-content .tab-pane");
    tabContent.forEach(function (el) {
      el.classList.remove("active");
      let currentContent = el.getAttribute('data-id');
      if (currentTarget === currentContent) {
        el.classList.add("active");
      }
    });
    tabLinks.forEach(function (el) {
      el.classList.remove("active");
    });
    btnTarget.classList.add("active");
  }
  remove() {
    ReactDOM.findDOMNode(this).parentElement.remove();
  }
  render() {
    let self = this;
    let { types, blocks, typeId } = this.state;
    return <div className="modal model-sidebar" style={{ display: "block" }}>
      <div className="modal-dialog modal-dialog-scrollable modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{app.getLang("addSection")}</h5>
            <button type="button" className="btn-close modal-close close-popup position-relative fa-sharp icon-cancel" onClick={() => this.remove()}></button>
          </div>
          <div className="modal-body row">
          <div className="col-lg-3 col-md-4 col-sm-5 border-custom mh-100">
            <nav className="nav w-100 h-100 p-3 pt-2 d-block sidebar-nav overflow-auto"> 
                  {
                    [{typeId:"",name:"All"}, ...types].map(function (v,i ) {
                      let active = "";
                      if (typeId === v.typeId) {
                        active = "active"
                      }
                      return <a key={'nav-'+i} className={`nav-link ${active}`} data-id={v.typeId} onClick={() => self.clickType(v.typeId)}>{v.name}</a>
                    })
                  } 
              </nav>
          </div> 
            <div className="tab-content col-lg-9 col-md-8 col-sm-7 sidebar-right p-4">
              <div className="tab-pane active">
                <div className="row">
                  <div className="col-md-12 img-list">
                    {
                      blocks.map(function (item) {
                        if (typeId) {
                          if (typeId === item.blockType) {
                            return <img src={`${window.aiHost}/images/image-2x1.png`} alt="" onClick={() => self.props.callback(item)} style={{ background: `url(${item.blockImage})` }} />
                          }
                          return null;
                        }
                        else {
                          return <img src={`${window.aiHost}/images/image-2x1.png`} alt="" onClick={() => self.props.callback(item)} style={{ background: `url(${item.blockImage})` }} />
                        }
                      })
                    }
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </div>
  }
}

export class HideSideBar extends React.Component {
  constructor(props) {
    super(props);
    this.hideShow = this.hideShow.bind(this);
  }
  hideShow(event) {
    const body = document.body;
    if (body.classList.contains('w-full')) {
      body.classList.remove('w-full');
    }
    else {
      body.classList.add('w-full');
    }
    // let el = event.target; 
    // let el_parent = document.querySelector(".app-html");
    // let sidebar = document.querySelector("#sidebar-panel"); 
    // if (el.classList.contains('on')) {
    //   el.classList.remove("on");
    //   el_parent.classList.remove('w-full');
    //   el.parentElement.classList.remove('side-action') 
    //   if(sidebar){ 
    //     sidebar.classList.remove('d-none');
    //   }
    // }
    // else {
    //     el.classList.add("on");
    //     el_parent.classList.add('w-full')
    //     el.parentElement.classList.add('side-action') 
    //     if(sidebar){ 
    //       sidebar.classList.add('d-none')
    //     }
    // } 
  }
  render() {
    let self = this
    return <a className="collapse-toggle fa fa-angle-right" id="toggle" onClick={self.hideShow}></a>
  }
}

export class ViewPort extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      device:localStorage.getItem("device")
    }
    this.action = this.action.bind(this);
  }
  componentWillMount() {
    if(localStorage.getItem("device")) {
      this.setState({
        device:localStorage.getItem("device")
      })
    }
  }
  componentDidMount() {
    const {device} = this.state;
    ["mobile-ai", "desktop-ai"].forEach(function (v) {
      document.querySelector('body').classList.remove(v);
    })
    if(device === "mobile") {
      ReactDOM.findDOMNode(this).querySelectorAll("a")[0].click();
    }
    else {
      ReactDOM.findDOMNode(this).querySelectorAll("a")[1].click();
    } 
  }
  action(device) {
    let deviceAi = "desktop-ai";
    if(device === "mobile"){
        deviceAi = "mobile-ai"
    }

    const body = document.querySelector('body');
    ["mobile-ai", "desktop-ai"].forEach(function (v) {
      body.classList.remove(v);
    })
    body.classList.add(deviceAi);
    localStorage.setItem("device", device)
    this.props.change();
    this.props.unselect();
  }
  render() {
    let self = this;
    let {device} = self.state;
    return <div className="wb-col view-ui">
      {
        [
          {key:"mobile", className:"h-mobile fa-light appyslim-phone-smartphone"},
          {key:"desktop", className:"h-desktop fa-light appyslim-hardware-laptop"}
        ].map(function(v, i){
          let active = "";
          if(device === v.key) {
            active = "active";
          }
          return <a data-type={v.key} key={v.key+i} onClick={() => self.action(v.key)} className={`${v.className} ${active}`}></a>
        })
      }
      
      
    </div>
  }
}

export class AlertBox extends React.Component{
  constructor(props) {
    super(props); 
  }
  rander(){
    let self = this;
    return <div className="popover bs-popover-bottom popover-custom">
    <i className="fa-sharp icon-cancel"></i>
    <div className="popover-arrow"></div>
    <div className="popover-body">{self.props.data}</div>
  </div>
  }
}

export const MenuModel = function({index, subIndex, data, update}) {
  const rootRef = useRef();
  const [tab, setTab] = useState(data.type === "none"?"page":data.type);
  const [value, setValue] = useState(data.value);
  const [country, setCountry] = useState("");

  useEffect(() => {
    
    if(rootRef.current.querySelector(".sidebar-nav a[data-id='"+tab+"']")) {
      rootRef.current.querySelector(".sidebar-nav a[data-id='"+tab+"']").click();
    }
    if(tab === "phone") {
      if(value.indexOf("+") === 0) {
        const countryCode = value.split("-")[0];
        rootRef.current.querySelector('#countryCode').innerHTML = countryCode;
        rootRef.current.querySelector('#phone').value = value.replace(countryCode + "-", "");
      }
      
      
    }
    if(tab === "email") {
      rootRef.current.querySelector("#email").value = value.replace("mailto:", "").split("?")[0];
      rootRef.current.querySelector("#subject").value = value.split("?")[1].split("&")[0].replace("subject=", "");
      rootRef.current.querySelector("#body").value = value.split("?")[1].split("&")[1].replace("body=", "");
      console.log(value);
      // if(value.indexOf("+") === 0) {
      //   const countryCode = value.split("-")[0];
      //   rootRef.current.querySelector('#countryCode').innerHTML = countryCode;
      //   rootRef.current.querySelector('#phone').value = value.replace(countryCode + "-", "");
      // }
    }
  },[])
 
  const action = function(event) {
    const type = event.currentTarget.getAttribute("data-type");
    if(type === "remove") {
      rootRef.current.parentElement.remove();
    }
    if(type === "save") {
      console.log(value);
      update({value:value, type:tab}, index, subIndex);
      rootRef.current.parentElement.remove();
    }
    if(type === "clear") {
      update({value:"", type:"none"}, index, subIndex);
      rootRef.current.parentElement.remove();
    }
  }
  const onInput = function(runValue) {
    if(tab === "email") {
      setValue(`mailto:${rootRef.current.querySelector("#email").value}?subject=${rootRef.current.querySelector("#subject").value}&body=${rootRef.current.querySelector("#body").value}`)
    }
    if(tab === "link") {
      setValue(`${rootRef.current.querySelector("#link").value}`)
    }
    if(tab === "phone") {
      let countryCode = rootRef.current.querySelector('#countryCode').innerHTML;
      if(countryCode === "none") {
        setValue(`${rootRef.current.querySelector("#phone").value}`);
      }
      else {
        setValue(`${rootRef.current.querySelector('#countryCode').innerHTML}-${rootRef.current.querySelector("#phone").value}`);
      }
    }

    if(tab === "anchorLinks"){
      console.log(runValue,"anchorLinks-value");
      setValue(`${runValue}`);
    }

    if(tab === "page") {
      setValue(`${runValue}`);
      //console.log(runValue);
    }
  }
  const checkCode = function(event){
    let el = event.currentTarget.parentElement;   
    if (el.classList.contains('active')) {
      el.classList.remove('active');
    }
    else {
      el.classList.add('active');
      let list = document.querySelectorAll("ul.country-code.phoneNumber li a"); 
      list.forEach(function (v) {
        v.addEventListener("mousedown", function() { 
          rootRef.current.querySelector('#countryCode').innerHTML = this.getAttribute('data-code');
          let countryCode = rootRef.current.querySelector('#countryCode').innerHTML;
          if(countryCode === "none") {
            setValue(`${rootRef.current.querySelector("#phone").value}`);
          }
          else {
            setValue(`${rootRef.current.querySelector('#countryCode').innerHTML}-${rootRef.current.querySelector("#phone").value}`);
          }
          el.classList.remove('active'); 
        })
      })
    } 
  }

  const handleSearchChange = function(e){
    setCountry(e.target.value.toLowerCase());
  };

  const validateValue = function(){
    switch (tab) {
      case "email":
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.replace("mailto:", "").split("?")[0]);
  
     
       
  
      case "link":
        try {
          const url = new URL(value);
          return url.protocol === "https:";
        } catch (err) {
          return false;
        }
  
      case "phone":
        const phone = value.replace(/[^0-9]/g, ""); // remove non-digits
        return /^[\d+\-]+$/.test(value) && phone.length >= 10;

      case "page":
        if(value !== "") {
          return true;
        }
        else {
          return false;
        }

      case "anchorLinks"   :
        if(value !== "") {
          return true;
        }
        else {
          return false;
        }

       
  
      default:
        return false;
    }

    
    
  };

  const remove = function() {
    
  }

  const tabs = [
    {"key":"anchorLinks", "lang":"anchor_links"},
    {"key":"page", "lang":"internalPage"},
    {"key":"link", "lang":"web_address"},
    {"key":"email", "lang":"email"},
    {"key":"phone", "lang":"phone"}
  ]

  //console.log("validateValue", validateValue());
 

  return <div ref={rootRef} className={`modal model-sidebar linkModel`} style={{ display: "block" }}>
    <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">{app.getLang("link_editor")}</h5>
          <button type="button" className="close-popup modal-close position-relative fa-sharp icon-cancel icon-cancel" data-type="remove" onClick={action}></button>
        </div>
        <div className="modal-body d-block d-sm-flex d-md-flex d-lg-flex d-xl-flex p-0 row m-0">

          <div className="col-lg-3 col-md-4 col-sm-5 border-custom mh-100">
            <nav className="nav sidebar-nav w-100 h-100 p-3 pt-2 d-block overflow-auto">
              {
                tabs.map(function(v){
                  return <a className={`nav-link ${tab === v.key?"active":""}`} onClick={()=> setTab(v.key)} data-id={v.key}>{app.getLang(v.lang)}</a>
                })
              }
            </nav>
          </div>

          <div className="tab-content col-lg-9 col-md-8 col-sm-7 sidebar-right p-4">
            {
              tabs.map(function(v){
                let active = "";
                if(v.key === tab) {
                  active = "active";
                }
                if(v.key === "anchorLinks") {
                  return <div className={`tab-pane ${active}`} data-id="anchor-links"> 
                    <LinkBlocks update={onInput} value={data.value} />
                  </div>
                }
                if(v.key === "page") {
                  return <div className={`tab-pane ${active}`} data-id="internal-page"> 
                    <ManagePages2 update={onInput} value={data.value} />
                  </div>
                }
                else if(v.key === "link") {
                  return <div className={`tab-pane ${active}`} data-id="web-address">
                  <div className="builder-widget">
                    <label className="d-block m-0">{app.getLang("url")}</label>
                    <input type="text" id="link" className="form-control" value={value} placeholder="https://example.com" onInput={onInput} />
                  </div> 
                  </div>
                }
                else if(v.key === "email") {
                  return   <div className={`tab-pane ${active}`} data-id="email">
                  <div className="builder-widget">
                    <label className="d-block m-0">{app.getLang("to")}</label>
                    <input type="text" id="email" className="form-control" placeholder="example@example.com" onInput={onInput} />
                  </div>
                  <div className="builder-widget">
                    <label className="d-block m-0">{app.getLang("subject")}</label>
                    <input type="text" id="subject" className="form-control" placeholder="Add an email subject" onInput={onInput} />
                  </div>
                  <div className="builder-widget">
                    <label className="d-block m-0">{app.getLang("body")}</label>
                    <input type="text" id="body" className="form-control" placeholder="Optional" onInput={onInput} />
                  </div>
                </div>
    
                }
                else if(v.key === "phone") {
                  return <div className={`tab-pane ${active}`} data-id="phone">
                  <div className="builder-widget">
                    <label className="d-block m-0">{app.getLang("phoneNumber")}</label>
                    <div className="input-group position-static">
                      <div className="dropdown input-group-text bg-transparent border-0 border-bottom px-0 rounded-0 me-3 position-relative">
                        <button className="btn form-control bg-transparent border-0 rounded-0 dropdown-toggle px-0 shadow-none" onMouseDown={checkCode} id="countryCode">
                          none
                        </button>
                        <div className="outer-dropdown" onMouseDown={checkCode}></div>
                        <ul className="dropdown-menu country-code phoneNumber">
                        <input type="text" className='form-control px-3 p-2 mb-3' placeholder="Search Country Name"  onChange={handleSearchChange}/>
                        {
                          countryCode.map(function(v){
                            return <li style={{display:v.name.toLowerCase().includes(country) || country === ""? "block": "none"}}><a className="dropdown-item" href="#" value={v.dialCode} data-code={v.dialCode} data-type="phone">{v.dialCode} {v.name}</a></li>
                           })
                        }
                        </ul>
                      </div> 
                      <input type="number" id="phone" className="form-control" placeholder="xx-xxxx-xxxx" autoComplete="off" onInput={onInput} data-type="phone" />
                    </div> 
                  </div>
                </div>
                }
                
              })
            }
            

            

          

            
   
            
            <div className='w-100 d-inline-block'>
                <button className="btn btn-primary float-end ms-3" disabled={validateValue()?false:true} onClick={action} data-type="save">{app.getLang("save")}</button>
                <button className="btn btn-secondary float-end" onClick={action} data-type="clear">{app.getLang("clear")}</button>
            </div>
           
          </div>
        </div>
      </div>
    </div>
  </div>

}

export class LinkModel extends React.Component {
  constructor(props) {
    super(props);
    let dataType = "";   
    if(props.data){ 
      if(props.data.indexOf("mailto:") === 0){
        dataType = 'email' 
      }
      else if(props.data.indexOf("javascript:opendeeplinkpage") === 0){
        dataType = 'internal-page';  
      }
      else if(props.data.indexOf("tel:") === 0){
        dataType = 'phone';  
      }
      else if((props.data.indexOf("https://") === 0) || (props.data.indexOf("https://") === 0)){
        dataType = 'web-address'; 
      } 
      else {
        socialIcons.forEach(function (val) { 
          if(props.data.indexOf(val.link) === 0){
            dataType = 'social-link';  
          } 
        })
        if(dataType !== "social-link"){
          dataType = 'phone';
        }
      }
    }
    this.state = {
      value: "",
      social: null,
      socialData:'',
      send:false,
      dataType:dataType ,
      searchCountry:"",
      pages:[],
      identity:props.identity,
      widgetType:null,
      viewType:props.viewType
    }
    this.remove = this.remove.bind(this);
    this.update = this.update.bind(this);
    this.save = this.save.bind(this); 
    this.social = this.social.bind(this); 
    this.clear = this.clear.bind(this); 
    this.updateInternallink = this.updateInternallink.bind(this); 
    this.checkCode = this.checkCode.bind(this);
    this.getPhoneValue = this.getPhoneValue.bind(this);
  }
  componentWillMount() {
    const self = this;
    app.loadPages().then(function(pages){
      self.setState({
        pages
      })
    })
    let domWin = document.querySelector("#iframe");
    if(domWin){
      let win = domWin.contentWindow.document
      if(win.querySelector(".activeHover")){
        let widgetType = win.querySelector(".activeHover").getAttribute('widget-type');
        if(widgetType){
          self.setState({
            widgetType
          })
        } 
      } 
    } 
  }
  componentDidMount() {
    let self = this;
    let data = self.props.data; 
     
    if(self.state.widgetType){
      if(self.state.widgetType === "webAppConverterTwo"){
        this.setState({
          dataType:"web-address"
        })
        self.showTab('web-address')
      }
      else{
        if(self.state.dataType){
          self.showTab(self.state.dataType)
        }else{
          self.showTab('web-address')
        } 
      }

      let tabContent = ReactDOM.findDOMNode(this).querySelector(".tab-content .tab-pane.active");
      setTimeout(function(){
        if(self.state.dataType === "internal-page") { 
            tabContent.querySelector('.form-control').value = data;
            self.setState({
              value:data
            })
          }
          if(self.state.dataType === "web-address") { 
            tabContent.querySelector('.form-control').value = data;
            self.setState({
              value:data
            })
          }
          if(self.state.dataType === "email") {   
            const temp = [data.replace("mailto:", "").split('?')[0], ...data.replace("mailto:", "").split('?')[1].split("&").map(function(v){
              return v.split("=")[1]
            })]; 
            ["email", "subject", "body"].forEach(function(v, i){  
              if(temp[i]){ 
              tabContent.querySelector('#'+v).value = temp[i]
              }
            }) 
            self.setState({
              value:data
            })
          }
          if(self.state.dataType === "phone") {
            let row = data.replace("tel:", "");
            if(row.indexOf("+") === 0) {
              row = row.split('-')
              tabContent.querySelector('#country-codes').innerHTML = row[0];
              tabContent.querySelector('#phoneNumber').value = row[1];
            }
            else {
              tabContent.querySelector('#country-codes').innerHTML = "none";
              tabContent.querySelector('#phoneNumber').value = row;
            }
            self.setState({
              value:data
            })
          }
          if(self.state.dataType === "social-link") { 
            let social = null;
            let valueLink = "";
            socialIcons.forEach(function(v){
              if(data.indexOf(v.link) === 0) {
                social = v;
                valueLink = data.replace(v.link, "");
              }
            }) 
            
            self.setState({
              social:social,
              value:data
            },function(){
              if(tabContent.querySelector('#socialUrl')){
                tabContent.querySelector('#socialUrl').value = valueLink;
              } 
            })  
          } 
      },100) 
    }
    else{
      if(self.state.dataType){
        self.showTab(self.state.dataType)
      }else{
        self.showTab('web-address')
      }
      let tabContent = ReactDOM.findDOMNode(this).querySelector(".tab-content .tab-pane.active");
      if(self.state.dataType === "internal-page") { 
        tabContent.querySelector('.form-control').value = data;
        this.setState({
          value:data
        })
      }
      if(self.state.dataType === "web-address") { 
        tabContent.querySelector('.form-control').value = data;
        this.setState({
          value:data
        })
      }
      if(self.state.dataType === "email") {   
        const temp = [data.replace("mailto:", "").split('?')[0], ...data.replace("mailto:", "").split('?')[1].split("&").map(function(v){
          return v.split("=")[1]
        })]; 
        ["email", "subject", "body"].forEach(function(v, i){  
          if(temp[i]){ 
           tabContent.querySelector('#'+v).value = temp[i]
          }
        }) 
        this.setState({
          value:data
        })
      }
      if(self.state.dataType === "phone") {  
        let row = data.replace("tel:", "");
        if(row.indexOf("+") === 0) {
          row = row.split('-')
          tabContent.querySelector('#country-codes').innerHTML = row[0];
          tabContent.querySelector('#phoneNumber').value = row[1];
        }
        else {
          tabContent.querySelector('#country-codes').innerHTML = "none";
          tabContent.querySelector('#phoneNumber').value = row;
        }
        this.setState({
          value:data
        })
      }
      if(self.state.dataType === "social-link") { 
        let social = null;
        let valueLink = "";
        socialIcons.forEach(function(v){
          if(data.indexOf(v.link) === 0) {
            social = v;
            valueLink = data.replace(v.link, "");
          }
        }) 
        
        self.setState({
          social:social,
          value:data
        },function(){
          if(tabContent.querySelector('#socialUrl')){
            tabContent.querySelector('#socialUrl').value = valueLink;
          } 
        })  
      } 
    }
    
  }
  showTab(tab){  
  if(document.querySelector('.mobile-ai.mobile-view')){ 
    window.restoreSelection(); 
  }
  let tabLinks = ReactDOM.findDOMNode(this).querySelectorAll(".sidebar-nav a");
  let tabContent = ReactDOM.findDOMNode(this).querySelectorAll(".tab-content .tab-pane");
	switch(tab) 
    {
      case tab:
        tabContent.forEach(function (el) {
          el.classList.remove("active"); 
          if (tab === el.getAttribute('data-id')) {
            el.classList.add("active");
          }
        });
        tabLinks.forEach(function (el) {
          el.classList.remove("active");
          if (tab === el.getAttribute('data-id')) {
            el.classList.add("active");
          }
        }); 
      break;  
      }
  } 
  remove() {
    ReactDOM.findDOMNode(this).parentElement.remove();
  }
  handleSearchChange = (e) => {
    this.setState({ searchCountry: e.target.value.toLowerCase() });
  };
  validateEmail(emailId) {
    if (emailId) {
      var atpos = emailId.indexOf("@");
      var dotpos = emailId.lastIndexOf(".");
      if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= emailId.length) {
        return;
      }
      return true;
    } else {
      return;
    }
  }
  validatePhone(phoneno) { 
    if (phoneno.length > 5) return phoneno;
  } 
  validateURL(url) { 
    let regex = /^https:\/\/.+/i; 
    return regex.test(url); 
  }

  social(social) {
    const socialEle = ReactDOM.findDOMNode(this).querySelector("#socialUrl");
    if(socialEle) {
      let value = social.link + socialEle.value;
      this.setState({
        social,
        value
      })
    }
    else {
      this.setState({
        social
      })
    }
    
   
  }
  clear() {
    if(this.state.identity){
      window.iframeUnlink()
    }else{
      this.props.callback("");
    } 
    this.remove();
  }
  update(e) {
    const self = this;
    const o = e.currentTarget;
    const t = o.getAttribute("data-type");
    const domEle = ReactDOM.findDOMNode(this);

    let value = o.value;
 
    if (t === "page") {
      //value = value;
    } 
    if (t === "phone") {
      value = `tel:${self.getPhoneValue("country-codes", "phoneNumber")}`;
    }
    if (t === "email") {
      value = `mailto:${domEle.querySelector("#email").value}?subject=${domEle.querySelector("#subject").value}&body=${domEle.querySelector("#body").value}`;
    }
    if (t === "social") { 
      value = this.state.social.link + value;
    }

    

    this.setState({
      value
    })

  }
  getPhoneValue(countryId, phoneId) {
    const domEle = ReactDOM.findDOMNode(this);
    let countryCode = domEle.querySelector(`#${countryId}`).innerHTML;
    if(countryCode === "none") {
      countryCode = "";
    }
    else {
      countryCode = countryCode + "-";
    }
    return `${countryCode}${domEle.querySelector(`#${phoneId}`).value}`;
  } 
  updateInternallink(value) {
    this.setState({
      value
    })
    
  }


  checkCode(event){
    let self= this;
    let el = event.currentTarget.parentElement;   
    if (el.classList.contains('active')) {
      el.classList.remove('active');
    }
    else {
      el.classList.add('active');
      let list = document.querySelectorAll("ul.country-code.phoneNumber li a"); 
      list.forEach(function (v) {
        v.addEventListener("mousedown", function() { 
          document.getElementById('country-codes').innerHTML = this.getAttribute('data-code');
          let value = `tel:${self.getPhoneValue("country-codes", "phoneNumber")}`;
          // console.log("value 1", value)
          self.setState({value})
          el.classList.remove('active'); 
        })
      })
    } 
  }

  

  save() {

    let self = this; 
    const domEle = ReactDOM.findDOMNode(this);  
    const appPage = domEle.querySelector('#appPage');
    const pageUrl = domEle.querySelector('#pageUrl');
    const email = domEle.querySelector('#email');
    const subject = domEle.querySelector('#subject');
    const phoneNumber = domEle.querySelector('#phoneNumber');
    const socialUrl = domEle.querySelector('#socialUrl');

   

    domEle.querySelectorAll('.linkModel .tab-pane.active').forEach(function(v){
      let dataID = v.getAttribute('data-id');
      if(dataID === 'internal-page'){  
        if(appPage.value === ""){ 
          pageUrl.parentElement.classList.add("error-field");
          pageUrl.parentElement.classList.remove("valid-field"); 
          errorAlert(app.getLang("validUrl"), appPage) 
          return false
        }
        else {

          let errorMode = false;
          if(document.querySelector(".linkModel-search-container a")) {
            if(document.querySelector(".linkModel-search-container a").classList.contains("on")) {
              const parent = document.querySelector(".linkModel-search-container .on").parentElement;
              if(parent.querySelector("#radioText").checked) {
                if(parent.querySelector("#inputSearch").value.trim() === "") {
                  errorMode = true;
                }
              }
            }
          }
          
          if(!errorMode) {
            self.setState({send:true})
            pageUrl.parentElement.classList.remove("error-field");
            pageUrl.parentElement.classList.add("valid-field");
            errorAlert("", appPage) 

            let internalPageLink = appPage.value;
            if (internalPageLink.indexOf("javascript:opendeeplinkpage") === -1) {
              internalPageLink = `javascript:opendeeplinkpage('${appPage.value}')`;
            }
            self.props.callback(internalPageLink);

            // self.props.callback(appPage.value);
            self.remove();
          }
          else {
            app.showAlert("danger", "Please select category or product for selected page!")
          }
         
        }
      }
      if(dataID === 'web-address'){  
        if(!self.validateURL(pageUrl.value)){ 
          pageUrl.parentElement.classList.add("error-field");
          pageUrl.parentElement.classList.remove("valid-field"); 
          errorAlert(app.getLang("validUrl"), pageUrl) 
          return false
        }else{
          self.setState({send:true})
          pageUrl.parentElement.classList.remove("error-field");
          pageUrl.parentElement.classList.add("valid-field");
          errorAlert("", pageUrl) 
          self.props.callback(self.state.value);
          self.remove();
        }
      }
      if(dataID === 'email'){  
        if(!self.validateEmail(email.value)){ 
          email.parentElement.classList.add("error-field");
          email.parentElement.classList.remove("valid-field");
          errorAlert(app.getLang("validEmail"), email) 
          return false
        }else{
          self.setState({send:true})
          email.parentElement.classList.remove("error-field");
          email.parentElement.classList.add("valid-field");
          errorAlert("", email);
          self.props.callback(self.state.value);
          self.remove();
        }

        if(subject.value.length){ 
          self.setState({send:true})
          subject.parentElement.classList.remove("error-field");
          subject.parentElement.classList.add("valid-field");
          errorAlert("", subject) 
          self.props.callback(self.state.value);
          self.remove();
          // subject.parentElement.classList.add("error-field");
          // subject.parentElement.classList.remove("valid-field");
          // errorAlert(app.getLang("enterEmailSubject"), subject)
          // return false 
        } 

      }
      if(dataID === 'phone'){ 
        if(!self.validatePhone(phoneNumber.value)){ 
          phoneNumber.parentElement.classList.add("error-field");
          phoneNumber.parentElement.classList.remove("valid-field");
          errorAlert(app.getLang("enterPhoneNumber"), phoneNumber)  
          return false
        }else{ 
          phoneNumber.parentElement.classList.remove("error-field");
          phoneNumber.parentElement.classList.add("valid-field");
          errorAlert("", phoneNumber) 
          self.props.callback(self.state.value);
          self.remove();
        }
      }
      if(dataID === 'social-link'){ 
        if(socialUrl.value.length < 3){ 
          socialUrl.parentElement.classList.add("error-field");
          socialUrl.parentElement.classList.remove("valid-field");
          errorAlert(app.getLang("enterId"), socialUrl) 
          return false
        }else{ 
          socialUrl.parentElement.classList.remove("error-field");
          socialUrl.parentElement.classList.add("valid-field");
          errorAlert("", socialUrl)
          self.props.callback(self.state.value);
          self.remove();
        }
      }
    }) 
  }
 

  render() {
    let self = this;
    
    let {pages} = self.state;
    let disabled = true; 
    if (this.state.value !== "") {
      disabled = false;
    } 
    let socialLink = "";
    if (this.state.social) {
      disabled = false;
      socialLink = <div className="builder-widget">
       <label className="d-block m-0">{app.getLang("enterId")}</label>
         
          <div className='w-100 d-flex'>
             <span className="form-control w-auto pe-2 border-0 opacity-75" style={{opacity:"0.7"}}>{this.state.social.link}</span>
              <input type="text" id="socialUrl" className="form-control" onInput={self.update} data-type="social" />
          </div>
        
      </div>;
    }   

    return <div className={`modal model-sidebar linkModel link-editor-button model-${self.state.widgetType}`} style={{ display: "block" }}>
      <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{app.getLang("link_editor")}</h5>
            <button type="button" className="close-popup modal-close position-relative fa-sharp icon-cancel icon-cancel" onClick={() => this.remove()}></button>
          </div>
          <div className="modal-body d-block d-sm-flex d-md-flex d-lg-flex d-xl-flex p-0 row m-0">

            <div className="col-lg-3 col-md-4 col-sm-5 border-custom mh-100">
              <nav className="nav sidebar-nav w-100 h-100 p-3 pt-2 d-block overflow-auto">
                {/* <a className="nav-link" onClick={()=> self.showTab('anchor-links')} data-id="anchor-links">{app.getLang("anchor_links")}</a> */}
                <a className={self.state.viewType === "advanceSocialLinks" || self.state.viewType === "socialLinks"?`nav-link  d-none`:`nav-link`} onClick={()=> self.showTab('internal-page')} data-id="internal-page">{app.getLang("internalPage")}</a>
                <a className="nav-link" onClick={()=> self.showTab('web-address')} data-id="web-address">{app.getLang("web_address")}</a>
                <a className="nav-link" onClick={()=> self.showTab('email')} data-id="email">{app.getLang("email")}</a>
                <a className="nav-link" onClick={()=> self.showTab('phone')} data-id="phone">{app.getLang("phone")}</a>
                 <a className="nav-link" onClick={()=> self.showTab('social-link')} data-id="social-link">{app.getLang("social_link")}</a> 
              </nav>
            </div>

            <div className="tab-content col-lg-9 col-md-8 col-sm-7 sidebar-right p-4">
            {/* <div className="tab-pane" data-id="anchor-links">
               
               <LinkBlocks update={self.updateInternallink} value={this.state.value} />
              </div> */}

              <div className="tab-pane" data-id="internal-page"> 
               <ManagePages update={self.updateInternallink} value={this.state.value} />
              </div>

              <div className="tab-pane" data-id="web-address">
                <div className="builder-widget">
                  <label className="d-block m-0">{app.getLang("url")}</label>
                  <input type="text" id="pageUrl" className="form-control" placeholder="https://example.com" onInput={self.update} data-type="link"/>
                </div> 
              </div>

              <div className="tab-pane" data-id="email">
                {/* <h5 className="mb-4">Email</h5> */}
                <div className="builder-widget">
                  <label className="d-block m-0">{app.getLang("to")}</label>
                  <input type="text" id="email" className="form-control" placeholder={app.getLang("add_email")} onInput={self.update} data-type="email" defaultValue={self.state.email}/>
                </div>
                <div className="builder-widget">
                  <label className="d-block m-0">{app.getLang("subject")}</label>
                  <input type="text" id="subject" className="form-control" placeholder={app.getLang("email_subject")} onInput={self.update} data-type="email" />
                </div>
                <div className="builder-widget">
                  <label className="d-block m-0">{app.getLang("body")}</label>
                  <input type="text" id="body" className="form-control" placeholder={app.getLang("email_content")} onInput={self.update} data-type="email" />
                </div>
                <div className="builder-widget" style={{ display: "none" }}>
                  <label className="d-block m-0">CC</label>
                  <input type="text" className="form-control" placeholder="Optional" />
                </div>
                <div className="builder-widget" style={{ display: "none" }}>
                  <label className="d-block m-0">BCC</label>
                  <input type="text" className="form-control" placeholder="Optional" />
                </div>
              </div>
 

              <div className="tab-pane" data-id="phone">
                {/* <h5 className="mb-4">Phone</h5> */}
                <div className="builder-widget">
                  <label className="d-block m-0">{app.getLang("phoneNumber")}</label>
                  <div className="input-group position-static">
                    <div className="dropdown input-group-text bg-transparent border-0 border-bottom px-0 rounded-0 me-3 position-relative">
                      <button className="btn form-control bg-transparent border-0 rounded-0 dropdown-toggle px-0 shadow-none" onMouseDown={self.checkCode} id="country-codes">
                        none
                      </button>
                      <div className="outer-dropdown" onMouseDown={self.checkCode}></div>
                      <ul className="dropdown-menu country-code phoneNumber">
                      <input type="text" className='form-control px-3 p-2 mb-3' placeholder="Search Country Name" value={ self.state.searchCountry} onChange={this.handleSearchChange}/>
                      {
                        countryCode.map(function(v){
                          return <li style={{display:v.name.toLowerCase().includes(self.state.searchCountry) || self.state.searchCountry === ""? "block": "none",}}><a className="dropdown-item" href="#" value={v.dialCode} data-code={v.dialCode} data-type="phone">{v.dialCode} {v.name}</a></li>
                         })
                      }
                      </ul>
                    </div> 
                    <input type="text" id="phoneNumber" className="form-control" placeholder="xx-xxxx-xxxx" autoComplete="off" onInput={self.update} maxLength={16} onKeyDown={app.phoneKeyDown} data-type="phone" />
                  </div> 
                </div>
              </div>
              <div className="tab-pane" data-id="social-link"> 
                <div className="form-group builder-widget">{
                  socialIcons.map(function (v) { 
                    let active = "";
                    if (self.state.social === v) {
                      active = "active";
                    } 
                    if(v.icon.indexOf("<svg") !== -1) {
                      return <button className={`btn-social  ${active}`} onClick={() => self.social(v)} dangerouslySetInnerHTML={{__html:v.icon}}></button>
                    }
                    return <button className={`btn-social ${v.icon} ${active}`} onClick={() => self.social(v)}></button>
                  })
                }
                </div>
                {socialLink}
              </div>
              
              <div className='w-100 d-inline-block'>
                  <button className="btn btn-primary float-end ms-3" disabled={disabled} onClick={this.save}>{app.getLang("save")}</button>
                  <button className="btn btn-secondary float-end" onClick={this.clear}>{app.getLang("clear")}</button>
              </div>
             
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}
 
export class Congratulations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      url:props.url
    }
    this.remove = this.remove.bind(this);
    this.showAgain = this.showAgain.bind(this);
    
  }
  remove() {
    ReactDOM.findDOMNode(this).parentElement.remove();
  }
  showAgain(e) {
    if(e.currentTarget.checked) {
      localStorage.setItem("notShowAgain", "true")
    }
    else {
      localStorage.removeItem("notShowAgain")
    }
  }
  render() {
    return <div className="modal" style={{ display: "block",userSelect:'none' }}>
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header border-0" style={{minHeight:"50px"}}> 
            <button type="button" className="btn-close modal-close close-popup position-relative fa-sharp icon-cancel" onClick={this.remove}></button>
          </div>
          <div className="modal-body">
          <div className="congratulations d-flex flex-column align-items-center justify-content-center h-100 text-center">
            <h2 className="fw-bold" style={{fontSize:'30px',marginBottom:'5px'}}>Congratulations!</h2>
            <small style={{fontSize:'19px',fontWeight:'600'}}>Your site is published and live online</small>
            <div className="w-75  mt-5 mb-5">
              <div className="d-lg-flex d-block"> 
                  <div className="in-outer"><i className="fa-solid fa-ellipsis" style={{fontSize:'30px'}}></i><div className="form-control rounded-3 ms-2 text-start" id="inputGroupFile04">{this.state.url}</div></div>
                  <a className="btn btn-outline-secondary ms-3 rounded-pill" href={`${this.state.url}`} target="_blank">View Site</a>
              </div>
            </div>
          </div>
          </div>
          <div className="modal-footer justify-content-start border-0">
            <div className="form-check">
              <input className="form-check-input" type="checkbox" id="notShowAgain" onChange={this.showAgain} />
              <label className="form-check-label" for="notShowAgain">{app.getLang("dont_show_this_again")}</label>
            </div> 
            <button type="button" className="btn btn-primary ms-auto rounded-pill px-4 py-2" onClick={this.remove}>{app.getLang("done")}</button>
          </div>
        </div>
      </div>
    </div>
  }
}

function ImageGenerator(props) {
  // Declare a new state variable, which we'll call "count"
  const path = app.config().bucket72;
  const [data, setData] = useState("");
  const [text, setText] = useState(props.text);
  const [images, setImages] = useState(app.userAiImages());
  
  
  const generate = function() {
      const domEle = document.querySelector("#generateText");
      if(domEle.value.trim() === "") {
        app.showAlert("danger", app.getLang("writeTextForImageGeneration"));
        domEle.focus();
        return false;
      }
      if(domEle.value.trim().split(" ").length === 1) {
        // alert("Write Minimum 2 and Maximum 7 words allowed for generate image");
        // domEle.focus();
        // return false;
      }    
      app.loadImage(text.trim(), function(response){
        setData(response);
      })
  }
  const saveImage = function(image, text) {
    app.fetchPost({
      "method":"saveAiImage",
      "appId":localStorage.getItem("aiAppId"),
      "customImage":image
    }, true).then(function(response){
      const newData = [...images, response.URL.replace(path, "")];
      setImages(newData);
      app.userAiImages(newData);
      props.callback(response.URL, text)
    })
}
  
  let listHTML = "";
  if(data !== "") {
    listHTML = <li><input type="image" src={data.image} value={data.image} onClick={() => saveImage(data.image, text)} alt="" /></li>
  }

  return <div className="container-fluid p-0">
    <div className="builder-widget">
        <label className="d-block m-0">{app.getLang("generateImages")}</label>
        <input type="text" id="generateText" className="form-control" placeholder={app.getLang("writeAboutAiGeneratedImages")} value={text} onInput={function(e){
      setText(e.currentTarget.value);
    }}/>
    </div>
 
    <button className="btn btn-primary float-end ms-3 mb-5" onClick={generate}>{app.getLang("generate")}</button>
    {/* <button className="btn btn-primary" onClick={generate}>Generate</button> */}
    {/* <div className='listParent'> */}
      <ul className="item-list">
        {listHTML}
      </ul>
    {/* </div> */}
    

    {/* <h3>Old Generate Images</h3> */}
    {images.length?<div className="builder-widget"><label className="d-block m-0 mt-3">{app.getLang("oldGenerateImages")}</label></div>:null}
    <div className='listParent' style={{maxHeight:"370px"}}>
      <ul className="item-list">
      {
        images.map(function(v,i){
          const image = `${path}${v}`;
          return <li key={'img-'+i}><input type="image" src={image} value={image} onClick={() => saveImage(image)} alt="" /></li>
        })
      }
      </ul>
    </div>
    {/* </div> */}
    </div>
}

export class MasterBlocks extends React.Component {
  constructor(props) {
    super(props);
    let blocks = [];
    if(localStorage.getItem("masterBlocks")) {
      blocks = JSON.parse(localStorage.getItem("masterBlocks"));
    }
    let mode = false;
    let data = {
      title:"",
      master:"",
      page:"",
      type:"",
      status:false,
      data:{}
    }
    if(props.data) {
      data = props.data;
      mode = true;
    }
    this.state = {
      mode,
      data,
      blocks,
      config:app.getConfig()
    }
    this.remove = this.remove.bind(this);
    this.update = this.update.bind(this);
    this.save = this.save.bind(this);
  }
  remove() {
    ReactDOM.findDOMNode(this).parentElement.remove();
  }
  update(e) {
    const {data, blocks} = this.state;
    const id = e.currentTarget.getAttribute("id");
    if(id === "status") {
      data[id] = e.currentTarget.checked;
    }
    else {
      data[id] = e.currentTarget.value;
      if(id === "master") {
        blocks.forEach(function(v){
          if(v.id === e.currentTarget.value) {
           data["data"] = JSON.parse(v.data);
          }
        })
      }
    } 
    this.setState({
      data
    })
  }
  save() {
    this.remove();
    this.props.callback(this.state.data);
  }
  componentWillMount() {
    const self = this;
    app.getAllMaster().then(function(response){
        let blocks = [];
        if(response.data) {
          response.data.forEach(function(v){
            blocks.push({
              id:v.id,
              title:v.title,
              data:v.data
            })
          })
          self.setState({
            blocks
          })
          localStorage.setItem("masterBlocks", JSON.stringify(blocks));
        }
    })
  }
  
 
  render() {
    let self = this;
    let { data, config, blocks, mode } = self.state;
    return <div className="modal" style={{ display: "block" }}>
      <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered">
        <div className="modal-content">
        
          <div className="modal-header">
            <h5 className="modal-title">{app.getLang("chooseBackground")}</h5>
            <button type="button" className="close-popup modal-close position-relative fa-sharp icon-cancel icon-cancel" onClick={() => this.remove()}></button>
          </div> 

          <div className="modal-body d-block p-0 row m-0 p-2">

          <div className="mb-3">
          <label for="title" className="form-label">Block Title</label>
          <input type="text" className="form-control" id="title" defaultValue={data.title} onChange={self.update} />
          </div>
          <div className="mb-3">
          <label for="master" className="form-label">Select Master Block</label>
          <select className="form-control" id="master" defaultValue={data.master} disabled={mode} onChange={self.update}>
          <option value="">Select</option>
          {
            blocks.map(function(v){
              return <option value={v.id}>{v.title}</option>
            })
          }
          </select>
          </div>

          <div className="mb-3">
          <label for="page" className="form-label">Select Page</label>
          <select className="form-control" id="page" defaultValue={data.page} onChange={self.update}>
          <option value="">Select</option>
          {
            config.pages.map(function(v){
              return <option value={v}>{v}</option>
            })
          }
          </select>
          </div>

          <div className="mb-3">
          <label for="type" className="form-label">Select Type</label>
          <select className="form-control" id="type" defaultValue={data.type} onChange={self.update}>
          <option value="">Select</option>
          {
            config.types.map(function(v){
              return <option value={v}>{v}</option>
            })
          }
          </select>
          </div>

          <div className="mb-3">
    <input type="checkbox" className="form-check-input" id="status" defaultChecked={data.status} onChange={self.update} /> 
    <label className="form-check-label ms-2" for="status">Status</label>
  </div>


  <button type="button" className="btn btn-primary w-auto" onClick={this.save}>{app.getLang("save")}</button>

            
          </div>
        </div>
      </div>
    </div>
  }
}

export class AppBlocks extends React.Component {
  constructor(props) {
    super(props);
    let blocks = [];
    if(app.isOnline()) {
      if(window.appBlocks) {
        blocks = window.appBlocks;
      } 
    }
    else {
      if(localStorage.getItem("appBlocks")) {
        blocks = JSON.parse(localStorage.getItem("appBlocks"));
      }
    }
    
    let mode = false;
    let data = {
      title:"",
      master:"",
      page:"",
      type:"",
      status:false,
      data:{}
    }
    if(props.data) {
      data = props.data;
      mode = true;
    }
    this.state = {
      mode,
      data,
      blocks,
      config:app.getConfig()
    }
    this.remove = this.remove.bind(this);
    this.callback = this.callback.bind(this);
  }
  remove() {
    ReactDOM.findDOMNode(this).parentElement.remove();
  }
  callback(v) {
    ReactDOM.findDOMNode(this).parentElement.remove();
    this.props.callback(v);
  }
  
  
  componentWillMount() {
    const self = this;
    if(!window.appBlocks) {
      let lang = app.appLang();
      if(lang === "jp") {
        lang = "ja";
      }
      app.fetchPost({
        "method":"getAllBlocks",
        "lang":lang
      }).then(function(response){
          let blocks = [];
          if(response.data) {
            response.data.forEach(function(v){
              blocks.push({
                id:v.id,
                title:v.title,
                data:v.data,
                reference:(app.appLang() === "en"?v.id:v.reference)
              })
            })
            self.setState({
              blocks
            })
            window.appBlocks = blocks;
            localStorage.setItem("appBlocks", JSON.stringify(blocks));
          }
      })
    }
    
  }
  
 
  render() {
    let self = this;
    let { data, config, blocks, mode } = self.state;
    const hideMobileBlocks = ["faq_one", "contact_form_one", "pricing_plan", "timeline_one", "skills_list_one", "profile_one", "tags_one"];
    
    return <div className="modal" style={{ display: "block" }}>
      <div className="modal-dialog modal-dialog-scrollable modal-xl">
        <div className="modal-content">
        
          <div className="modal-header" style={{paddingLeft:"24px"}}>
            <h5 className="modal-title">{config.languageSettings.all_sections}</h5>
            <button type="button" className="close-popup modal-close position-relative fa-sharp icon-cancel icon-cancel" onClick={() => this.remove()} style={{right:"20px"}}></button>
          </div> 

          <div className="modal-body d-block row m-0 p-0">
            <div className='listParent add_blocks' style={{padding:"24px"}}>
                  <ul className="item-list">
                    {
                      blocks.map(function (v,icon) { 
                        let widgetType = JSON.parse(v.data).widgetType;
                        if(!app.getDevice()) {
                          if(hideMobileBlocks.indexOf(widgetType) !== -1) {
                            return null;
                          }
                        }
                        // return <li widgetType={JSON.parse(v.data).widgetType}><img title={JSON.parse(v.data).widgetType} alt={JSON.parse(v.data).widgetType} style={{backgroundImage:`url(https://media.mediadirhub.com/layouts/${(app.getDevice() === true?'website':'mobile')}/blocks/${app.appLang()}/${v.id}.png)`, backgroundSize:"cover", maxHeight:"inherit"}} onClick={() => self.callback(v.data)} src={`${window.aiHost}/images/image-1x1.png`}/></li>
                        return <li key={'bl-'+icon} widgetType={widgetType}><img onClick={() => self.callback(v.data)} src={`https://media.mediadirhub.com/layouts/${(app.getDevice() === true?'website':'mobile')}/blocks/${app.appLang()}/${v.reference}.png?version=${window.aiVersion}`}/></li>
                      })
                    }
                  </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}

export class ClonePages extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data:props.data,
      config:app.getConfig()
    }
    this.update  = this.update.bind(this);
    this.save  = this.save.bind(this);
    this.remove  = this.remove.bind(this);
    
  }
  update(e) {
    const {data, blocks} = this.state;
    const id = e.currentTarget.getAttribute("id");
    data[id] = e.currentTarget.value;
    this.setState({
      data
    })
  }
  save() {
    const self = this;
    const {data} = self.state;
    app.fetchPost({
      "method":"savePages",
      "title":data.title,
      "page":data.page,
      "category":data.category,
      "status":true,
      "data":data.data
    }).then(function(response){
      window.pushState("pages", response.data._id);
    })
  }
  remove() {
    ReactDOM.findDOMNode(this).parentElement.remove();
  }
  render() {
    const self = this;
    const {data, config} = self.state;
    return <div className="modal" style={{ display: "block" }}>
    <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered">
      <div className="modal-content">
      
        <div className="modal-header">
          <h5 className="modal-title">Add Page</h5>
          <button type="button" className="close-popup modal-close position-relative fa-sharp icon-cancel icon-cancel" onClick={() => this.remove()}></button>
        </div> 
        <div className="modal-body d-block p-0 row m-0 p-2">
        <div className="mb-3">
          <label for="title" className="form-label">Title</label>
          <input type="text" className="form-control" id="title" defaultValue={data.title} onChange={self.update} />
          </div>

          <div className="mb-3">
          <label for="page" className="form-label">Select Page</label>
          <select className="form-control" id="page" defaultValue={data.page} onChange={self.update}>
          <option value="">Select</option>
          {
            config.pages.map(function(v){
              return <option value={v}>{v}</option>
            })
          }
          </select>
          </div>

          <div className="mb-3">
          <label for="type" className="form-label">Select Category</label>
          <select className="form-control" id="category" defaultValue={data.category} onChange={self.update}>
          <option value="">Select</option>
          {
            [...config.categories, ...config.newCategories].map(function(v){
              return <option value={v.folder?v.folder:v.slug}>{v.name}</option>
            })
          }
          </select>
          </div>
        

      <button type="button" className="btn btn-primary w-auto" onClick={this.save}>{app.getLang("save")}</button>
      </div>
    </div>
    </div>
    </div>
  }
}

export class EditInfo extends React.Component {
  constructor(props) {
    super(props);
    // console.log(props.data);
    this.state = {
      data:props.data,
      config:app.getConfig()
    }
    this.update  = this.update.bind(this);
    this.save  = this.save.bind(this);
    this.remove  = this.remove.bind(this);
    
  }
  update(e) {
    const {data, blocks} = this.state;
    const id = e.currentTarget.getAttribute("id");
    if(id === "status") {
      data[id] = e.currentTarget.checked;
    }
    else {
      data[id] = e.currentTarget.value;
    }
    this.setState({
      data
    })
  }
  save() {
    const self = this;
    const {data} = self.state;
    app.fetchPost({
      "id":data.id,
      "method":"savePages",
      "title":data.title,
      "page":data.page,
      "heading":data.heading,
      "category":data.category,
      "status":data.status,
      "data":data.data
    }).then(function(response){
      self.props.callback(data)
      //window.pushState("pages", response.data._id);
    })
  }
  remove() {
    ReactDOM.findDOMNode(this).parentElement.remove();
  }
  render() {
    const self = this;
    const {data, config} = self.state;
    return <div className="modal" style={{ display: "block" }}>
    <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered">
      <div className="modal-content">
      
        <div className="modal-header">
          <h5 className="modal-title">Add Page</h5>
          <button type="button" className="close-popup modal-close position-relative fa-sharp icon-cancel icon-cancel" onClick={() => this.remove()}></button>
        </div> 
        <div className="modal-body d-block p-0 row m-0 p-2">
        <div className="mb-3">
          <label for="title" className="form-label">Title</label>
          <input type="text" className="form-control" id="title" defaultValue={data.title} onChange={self.update} />
          </div>
          <div className="mb-3">
          <label for="heading" className="form-label">Heading</label>
          <input type="text" className="form-control" id="heading" defaultValue={data.heading} onChange={self.update} />
          </div>
          <div className="mb-3">
          <label for="heading" className="form-label">Status</label>
          <div className="form-check form-switch">
  <input className="form-check-input" type="checkbox" role="switch" id="status" defaultChecked={data.status} onChange={self.update} />
  <label className="form-check-label d-none" for="status">Default switch checkbox input</label>
</div>
</div>
          

          <div className="mb-3">
          <label for="page" className="form-label">Select Page</label>
          <select className="form-control" id="page" defaultValue={data.page} onChange={self.update}>
          <option value="">Select</option>
          {
            config.pages.map(function(v){
              return <option value={v}>{v}</option>
            })
          }
          </select>
          </div>

          <div className="mb-3">
          <label for="type" className="form-label">Select Category</label>
          <select className="form-control" id="category" defaultValue={data.category} onChange={self.update}>
          <option value="">Select</option>
          {
            [...config.categories, ...config.newCategories].map(function(v){
              return <option value={v.folder?v.folder:v.slug}>{v.name}</option>
            })
          }
          </select>
          </div>
        

      <button type="button" className="btn btn-primary w-auto" onClick={this.save}>{app.getLang("save")}</button>
      </div>
    </div>
    </div>
    </div>
  }
}

export class SeoPages extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data:props.data,
      config:app.getConfig()
    }
    this.update  = this.update.bind(this);
    this.save  = this.save.bind(this);
    this.remove  = this.remove.bind(this);
    
  }
  update(e) {
    const {data} = this.state;
    const id = e.currentTarget.getAttribute("id");
    data[id] = e.currentTarget.value.trim();
    this.setState({
      data
    })
  }
  save() {
    const self = this;
    const {data} = self.state;
    // console.log(data);
    app.fetchPost({
      "id":data.id,
      "method":"savePages",
      "title":data.title,
      "page":data.page,
      "category":data.category,
      "status":true,
      "data":data.data,
      "heading":data.heading,
      "seocategory":data.seocategory,
      "metatitle":data.metatitle,
      "metadescription":data.metadescription,
      "slug":data.slug
    }).then(function(response){
      alert("data updated successfully");
      //window.pushState("pages", response.data._id);
    })
  }
  remove() {
    ReactDOM.findDOMNode(this).parentElement.remove();
  }
  render() {
    const self = this;
    const {data, config} = self.state;
    // console.log(data);

    return <div className="modal" style={{ display: "block" }}>
    <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered">
      <div className="modal-content">
      
        <div className="modal-header">
          <h5 className="modal-title">Update SEO Data</h5>
          <button type="button" className="close-popup modal-close position-relative fa-sharp icon-cancel icon-cancel" onClick={() => this.remove()}></button>
        </div> 
        <div className="modal-body d-block p-0 row m-0 p-2">
        <div className="mb-3">
          <label for="heading" className="form-label">Heading</label>
          <input type="text" className="form-control" id="heading" defaultValue={data.heading} onChange={self.update} />
          </div>

          <div className="mb-3">
          <label for="heading" className="form-label">slug</label>
          <input type="text" className="form-control" id="slug" defaultValue={data.slug} onChange={self.update} />
          </div>

          <div className="mb-3">
          <label for="seocategory" className="form-label">Select Category</label>
          <select className="form-control" id="seocategory" defaultValue={data.seocategory} onChange={self.update}>
          <option value="">Select</option>
          {
            template_categories.map(function(v){
              return <option value={v.toLocaleLowerCase().replace(" ", "-").replace(" ", "-")}>{v}</option>
            })
          }
          </select>
          </div>

        <div className="mb-3">
          <label for="metatitle" className="form-label">Meta Title</label>
          <input type="text" className="form-control" id="metatitle" defaultValue={data.metatitle} onChange={self.update} />
          </div>


        <div className="mb-3">
          <label for="metadescription" className="form-label">Meta Description</label>
          <textarea type="text" style={{height:"100px"}} className="form-control" id="metadescription" defaultValue={data.metadescription} onChange={self.update} />
          </div>

          
        
        

      <button type="button" className="btn btn-primary w-auto" onClick={this.save}>{app.getLang("save")}</button>
      </div>
    </div>
    </div>
    </div>
  }
}
export class AppPages extends React.Component {
  constructor(props) {
    super(props);
    let blocks = [];
    if(localStorage.getItem("masterBlocks")) {
      blocks = JSON.parse(localStorage.getItem("masterBlocks"));
    }
    let mode = false;
    let data = {
      "title":"",
      "page":"",
      "category":"",
      "status":false,
      "data":[]
    }
    if(props.data) {
      data = props.data;
      mode = true;
    }
    this.state = {
      data,
      config:app.getConfig()
    }
    this.remove = this.remove.bind(this);
    this.update = this.update.bind(this);
    this.save = this.save.bind(this);
  }
  remove() {
    ReactDOM.findDOMNode(this).parentElement.remove();
  }
  update(e) {
    const {data, blocks} = this.state;
    const id = e.currentTarget.getAttribute("id");
    if(id === "status") {
      data[id] = e.currentTarget.checked;
    }
    else {
      data[id] = e.currentTarget.value;
      if(id === "master") {
        blocks.forEach(function(v){
          if(v.id === e.currentTarget.value) {
           data["data"] = JSON.parse(v.data);
          }
        })
      }
    } 
    this.setState({
      data
    })
  }
  save() {
    ReactDOM.findDOMNode(this).parentElement.remove();
    this.props.callback(this.state.data);
  }

  
 
  render() {
    let self = this;
    let { data, config } = self.state;
    return <div className="modal" style={{ display: "block" }}>
      <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered">
        <div className="modal-content">
        
          <div className="modal-header">
            <h5 className="modal-title">Add Page</h5>
            <button type="button" className="close-popup modal-close position-relative fa-sharp icon-cancel icon-cancel" onClick={() => this.remove()}></button>
          </div> 

          <div className="modal-body d-block p-0 row m-0 p-2">

          <div className="mb-3">
          <label for="title" className="form-label">Title</label>
          <input type="text" className="form-control" id="title" defaultValue={data.title} onChange={self.update} />
          </div>
        

          <div className="mb-3">
          <label for="page" className="form-label">Select Page</label>
          <select className="form-control" id="page" defaultValue={data.page} onChange={self.update}>
          <option value="">Select</option>
          {
            config.pages.map(function(v){
              return <option value={v}>{v}</option>
            })
          }
          </select>
          </div>

          <div className="mb-3">
          <label for="type" className="form-label">Select Category</label>
          <select className="form-control" id="category" defaultValue={data.type} onChange={self.update}>
          <option value="">Select</option>
          {
            [...config.categories, ...config.newCategories].map(function(v){
              return <option value={v.folder?v.folder:v.slug}>{v.name}</option>
            })
          }
          </select>
          </div>

          <div className="mb-3">
    <input type="checkbox" className="form-check-input" id="status" defaultChecked={data.status} onChange={self.update} /> 
    <label className="form-check-label ms-2" for="status">Status</label>
  </div>


  <button type="button" className="btn btn-primary w-auto" onClick={this.save}>{app.getLang("save")}</button>

            
          </div>
        </div>
      </div>
    </div>
  }
}

export class SelectPages extends React.Component {
  constructor(props) {
    super(props);
   
   
   
    this.state = {
      config:app.getConfig(),
      pages:[],
      title:null,
      page:null,
      data:null
    }
    this.remove = this.remove.bind(this);
    this.update = this.update.bind(this);
    this.save = this.save.bind(this);
  }
  remove() {
    ReactDOM.findDOMNode(this).parentElement.remove();
  }
  componentWillMount() {
    const self = this;
    app.fetchPost({
      "method":"getAllPages",
      "lang":"en"
    }, true).then(function(response){
      self.setState({
        pages:response.data
      })
    })
  }
  update(key, value) {
    const self = this;
    if(key === "title") {
      self.setState({
        title:value
      })
    }
    if(key === "page") {
      self.setState({
        page:value
      })
    }
    if(key === "data") {
      self.setState({
        data:value
      }, function(){
        const id = `${localStorage.getItem("joinEmail")}_${self.state.page}_${Date.now()}`;
        const nextData  =  JSON.parse(value.data);
        nextData["viewId"] = `aus_${Date.now()}`
        app.fetchBuilder({
          method:"savePage",
          data:{
            email:localStorage.getItem("joinEmail"),
            title:self.state.title,
            page:self.state.page,
            dynamicAIData:JSON.stringify(nextData),
            category:value.category
          }
        }).then(function(response){ 
          window.pushState(response.data.name);
          self.remove();
          //window.routerClick(id);
        })
      })
    }
  }
  save() {
    ReactDOM.findDOMNode(this).parentElement.remove();
    //this.props.callback(this.state.data);
  }
  render() {
    let self = this;
    let { data, config, pages, title, page } = self.state;
    

let pageModal = <div className="modal-body d-block p-2 row m-0 p-2">
<h6>Enter Page Title</h6>
<div className="p-2">
<div className="input-group input-group-lg">
  <input type="text" className="form-control" id="title" />
  <button className="btn btn-secondary" onClick={function(){
    const title = document.querySelector("#title").value.trim();
    if(title === "") {
      alert("Please enter Title");
      return false;
    }
    self.update("title", title);
  }}>next</button>
</div>
</div>
</div>
  if(title) {

    pageModal = <div className="modal-body d-block p-2 row m-0 p-2">
      <h6>Select Page</h6>
      <div className="p-2">
        {
          config.pages.map(function(v){
            return  <button type="button" className="btn btn-outline-secondary w-auto m-1 cursor-pointer" onClick={() => self.update("page", v)}>{v}</button>
          })
        }
      </div>
    </div>
  }
    if(page) {
      pageModal =<div className="modal-body d-block p-2 row m-0 p-2">
            <h6>Select Layout</h6>
            <div className="p-2">
              <div className="row">
              {
                pages.map(function(v){
                  if(v.page  === page) {
                    return  <div className="col-4 cursor-pointer mb-4">
                      <img src="https://media.mediadirhub.com/images/image-1x1.png" style={{backgroundImage:`url(https://mediadirhub.com/templates/${v.id}.png)`}} onClick={() => self.update("data", v)} className="w-100 border border-3 rounded background-fit" />
                    </div>
                  }
                  return null;
                  
                })
              }
              </div>
            </div>
          </div>
    }

    return <div className="modal" style={{ display: "block" }}>
      <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h3 className="modal-title">Add Page</h3>
            <button type="button" className="close-popup modal-close position-relative fa-sharp icon-cancel icon-cancel" onClick={() => this.remove()}></button>
          </div>
         {pageModal}
          
        </div>
      </div>
    </div>
  }
}

export const NotAllow = function(props) {
  const copyClipboard = function(copyText) {
    var input = document.createElement("input");
    input.value = copyText;
    document.body.appendChild(input);
    input.select();
    document.execCommand("copy");
    document.body.removeChild(input);
    alert("Copied: " + copyText);
  }
  
  
  if(props.visitorId) {
    return <div className="w-100 h-100 p-5 d-flex justify-content-center align-items-center">
    <div className="p-3 text-center">
      <i className="icon-cancel-circle-1 fs-1 text-danger"></i>
      <h5>you are not valid user contact to admin</h5>
      <div className={`input-group mt-3 mb-3 ${props.visitorId?"":"d-none"}`}>
        <span className="input-group-text d-none">device</span>
        <span className="input-group-text fw-bold">{props.visitorId}</span>
        <button className="btn btn-outline-secondary" onClick={() => copyClipboard(props.visitorId)}>copy</button>
      </div>
    </div>
  </div>

  }
  return <div className="app-loader">
    <div className="loader"></div>
  </div>
}

export class VideosModel extends React.Component {
  constructor(props) {
    super(props);
    this.remove = this.remove.bind(this);
    this.openTabs = this.openTabs.bind(this);  
    this.state = {
      config:app.getConfig(),
      src:props.properties.src,
      thumb:props.properties.thumb
    }
    this.save = this.save.bind(this) 
  }
  componentDidMount() {
    let self = this
    let tabLinks = ReactDOM.findDOMNode(this).querySelectorAll(".sidebar-nav a"); 
    tabLinks.forEach(function (el) {
      el.addEventListener("click", self.openTabs);
    });

    const domLinks = ReactDOM.findDOMNode(this).querySelectorAll(".sidebar-pannel a");
    const domLibrary = ReactDOM.findDOMNode(this).querySelectorAll(".library");
    domLinks.forEach(function (v, i) {
      v.addEventListener("click", function () { 
        if(document.querySelector(".listParent")){
          document.querySelector(".listParent").scroll(0,0)
        } 
        domLinks.forEach(function (v, i) {
          v.classList.remove("active");
        })
        domLibrary.forEach(function (v, i) {
          v.style.display = "none";
        })
        domLinks[i].classList.add("active");
        domLibrary[i].style.display = "flex";
      })
    })
    tabLinks[0].click();
    //domLinks[0].click();
  }
  openTabs(el) {
    let btnTarget = el.currentTarget;
    let currentTarget = el.currentTarget.getAttribute('data-id');
    let tabLinks = ReactDOM.findDOMNode(this).querySelectorAll(".sidebar-nav a");
    let tabContent = ReactDOM.findDOMNode(this).querySelectorAll(".tab-content .tab-pane");
    tabContent.forEach(function (el) {
      el.classList.remove("active");
      let currentContent = el.getAttribute('data-id');
      if (currentTarget === currentContent) {
        el.classList.add("active");
      }
    });
    tabLinks.forEach(function (el) {
      el.classList.remove("active");
    });
    btnTarget.classList.add("active");
  }
  remove() {
    ReactDOM.findDOMNode(this).parentElement.remove();
  }
  onUpdateInput(e){
    let val = e.currentTarget.value;
    this.setState({
      src:val
    })
  }
 

  save() {
    let self = this;
    let src = self.state.src;

    if (src) {
      let finalUrl = null; 
      if (src.indexOf("youtube.com") !== -1 || src.indexOf("youtu.be") !== -1) {
          // || src.indexOf('/playlist?list=') !== -1
          if (src.indexOf('/watch?v=') !== -1 || src.indexOf('youtu.be') !== -1 || src.indexOf('/embed/') !== -1) {
             app.getYoutube(src).then(youtubeData => { 
                  finalUrl = youtubeData.src;
                  self.props.callback("type", "youtube"); 
                  self.props.callback("embed", youtubeData.embed);
                  self.props.callback("thumb", youtubeData.thumb);
                  self.props.callback("videoId", youtubeData.videoId);
                  self.props.callback("src", finalUrl); 
              }).catch(error => {
                  console.error(error);
              });
          } else {
              const file = ReactDOM.findDOMNode(this).querySelector("#videoUrl");
              file.parentElement.classList.add("error-field");
              file.parentElement.classList.remove("valid-field"); 
              errorAlert(app.getLang("invalidURL"), file);  
          }
      } if (src.indexOf('dailymotion.com') !== -1) {
        let videoId;
        if (src.indexOf('/video/') !== -1) {
            videoId = src.substr(src.lastIndexOf('/') + 1);
        } else if (src.indexOf('dai.ly') !== -1) {
            videoId = src.substr(src.lastIndexOf('/') + 1);
        } else if (src.indexOf('/embed/video/') !== -1) { 
            const urlObj = new URL(src);
            videoId = urlObj.pathname.split('/').pop(); // Extract the last segment after '/'
        }
    
        if (videoId) {
            app.getDailyMotion(src).then(dailymotionData => { 
                const finalUrl = dailymotionData.src;
                self.props.callback("type", "dailymotion");
                self.props.callback("thumb", dailymotionData.thumb);
                self.props.callback("src", finalUrl);
                self.props.callback("videoId", dailymotionData.videoId);
                self.props.callback("embed", dailymotionData.embed); 
            }).catch(error => {
                console.error("Error fetching Dailymotion data:", error);
            });
        } else {
            const file = ReactDOM.findDOMNode(this).querySelector("#videoUrl");
            file.parentElement.classList.add("error-field");
            file.parentElement.classList.remove("valid-field");
            errorAlert(app.getLang("invalidURL"), file);
        }
    }
    
    else if (src.indexOf("vimeo.com") !== -1 || src.indexOf("player.vimeo.com") !== -1) {
        app.getVimeo(src).then(vimeoData => {
            finalUrl = vimeoData.src;
            self.props.callback("type", "vimeo");
            self.props.callback("thumb", vimeoData.thumb);
            self.props.callback("src", finalUrl);
            self.props.callback("videoId", vimeoData.videoId);
            self.props.callback("embed", vimeoData.embed); 
        }).catch(error => {
            console.error(error);
        });
      } else if (src.endsWith(".mp4")) {
          finalUrl = src;
          self.props.callback("type", "custom");
          self.props.callback("thumb", `https://media.mediadirhub.com/images/video-default.png`); // No thumbnail for direct MP4 links
          self.props.callback("src", finalUrl);
      } else {
          const file = ReactDOM.findDOMNode(this).querySelector("#videoUrl");
          file.parentElement.classList.add("error-field");
          file.parentElement.classList.remove("valid-field"); 
          errorAlert(app.getLang("invalidURL"), file);  
      }
  } else {
    const file = ReactDOM.findDOMNode(this).querySelector("#videoUrl");
    file.parentElement.classList.add("error-field");
    file.parentElement.classList.remove("valid-field"); 
    errorAlert(app.getLang("invalidURL"), file);  
  }
  
}



  render() {
    let self = this;
    const {text, src} = self.props;
    let { config } = self.state; 
    // let tabs = ["Generate", "Library", "Custom Upload"];
    let tabs = [
        {key:"url",value:app.getLang("url")},
        {key:"custom_upload",value:app.getLang("custom_upload")} 
      ];
      
 
    return <div className="modal VideosModel" style={{ display: "block" }}>
      <div className="modal-dialog modal-dialog-scrollable modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{app.getLang("video")}</h5>
            <button type="button" className="close-popup modal-close position-relative fa-sharp icon-cancel icon-cancel" onClick={() => this.remove()}></button>
          </div>
          <div className="modal-body d-block d-sm-flex d-md-flex d-lg-flex d-xl-flex p-0 row m-0">
            <div className="col-lg-3 col-md-4 col-sm-5 border-custom mh-100">
                <nav className="nav w-100 h-100 p-3 pt-2 d-block sidebar-nav overflow-auto">
                  {
                    tabs.map(function(v) {
                      if(app.getProject() === "admin" && v.key === "custom_upload"){
                        return ''
                      }
                      return <a className="nav-link" data-id={v.key}>{v.value}</a>
                    })
                  }
                </nav>
            </div> 

            <div className="tab-content col-lg-9 col-md-8 col-sm-7 sidebar-right p-4">
              {
                tabs.map(function(v) { 
                  if(v.key === "url") {
                    return <div className="tab-pane" data-id={v.key}>
                      <div className="builder-widget mb-4 pb-2">
                        <label className="d-block m-0">{app.getLang("url")}</label>
                        <input type="text" id="videoUrl" className="form-control" placeholder="https://example.com" data-type="videourl" defaultValue={self.state.src} onInput={(e)=>self.onUpdateInput(e)}/>
                      </div>
                      <div className='w-100 d-inline-block'>
                        <button className="btn btn-primary float-end ms-3" onClick={self.save}>{app.getLang("save")}</button>
                      </div>
                    </div>
                  }
                  else if(v.key === "custom_upload") {
                    if(app.getProject() === "admin") {
                      return ''
                    }
                    else {
                      return <div className="tab-pane" data-id={v.key}>
                        <CustomVideoUpload callback={function(value){ 
                          self.props.callback("thumb", value.image);
                          self.props.callback("src", value.video);
                          self.props.callback("type", "custom"); 
                          }}/>
                      </div>
                    }
                  }
                })
              }
             
              
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}

export const CustomSelectColor = function({value, id, callback}) {
  const selectEle = useRef();
  let colors = [];
  if(localStorage.globalSettings) {
    colors = JSON.parse(localStorage.globalSettings).colors
  }
  let selectedColor = null;
  if(colors.length) {
    selectedColor = colors.filter(function(v){
      if(v.key === value) {
        return true;
      }
      return false;
    });
    if(selectedColor[0]) {
      selectedColor = selectedColor[0];
    }
    else {
      selectedColor = null;
    }
  }  

  useEffect(() => {
    const selected = selectEle.current.querySelector('#selectedOption');
    const options = selectEle.current.querySelector('#optionList');

    selected.addEventListener('click', () => {
      options.classList.toggle('show');
    });

    options.querySelectorAll('div').forEach(option => {
      option.addEventListener('click', () => {
        const dataId = option.getAttribute('data-id');
        const color = option.getAttribute('data-color');
        const label = option.getAttribute('data-label');
        selected.innerHTML = `<span class="color-box" style="background-color: ${app.getColor(color)};"></span> ${label}`;
        options.classList.remove('show');
        if(dataId === "custom") {
          if(id === "overlayColor") {
            callback("#4D000000");
          }
          else {
            callback("#FF000000");
          }
        }
        else {
          callback(dataId);
        }
      });
    });

    // Close on outside click
    window.addEventListener('click', (e) => {
      if (!e.target.closest('.custom-select-wrapper')) {
        options.classList.remove('show');
      }
    });
  }, []);
  return <div className="custom-select-wrapper" ref={selectEle}>
  <div className="custom-select" id="selectedOption">
    <span className="color-box" style={{backgroundColor: (selectedColor?app.getColor(selectedColor.styleColor):"")}} /> {selectedColor?selectedColor.styleColorName:"Custom"}
  </div>
  <div className="custom-options" id="optionList">
    {
      colors.map(function(v){
        return <div key={v.key} data-id={v.key} data-color={v.styleColor} data-label={v.styleColorName}><span className="color-box" style={{backgroundColor: app.getColor(v.styleColor)}} /> {v.styleColorName}</div> 
      })
    }
    <div data-color="#ffc107" data-id={"custom"} data-label="Custom"><span className="color-box" style={{backgroundColor: '#ffc107'}} /> Custom</div>
  </div>
</div>

}

export const CustomSelectStyle = function({value, callback}) {
  const selectEle = useRef();
  let styles = [];
  if(localStorage.globalSettings) {
    styles = JSON.parse(localStorage.globalSettings).styles
  }
  let selectedStyle = null;
  if(styles.length) {
    selectedStyle = styles.filter(function(v){
      if(v.key === value) {
        return true;
      }
      return false;
    });
    if(selectedStyle[0]) {
      selectedStyle = selectedStyle[0];
    }
    else {
      selectedStyle = null;
    }
  } 
  

  useEffect(() => {
    const selected = selectEle.current.querySelector('#selectedOption');
    const options = selectEle.current.querySelector('#optionList');

    selected.addEventListener('click', () => {
      options.classList.toggle('show');
    });

    options.querySelectorAll('div').forEach(option => {
      option.addEventListener('click', () => {
        const id = option.getAttribute('data-id');
        const color = option.getAttribute('data-color');
        const label = option.getAttribute('data-label');
        selected.innerHTML = `<span class="color-box" style="background-color: ${color};"></span> ${label}`;
        options.classList.remove('show');
        callback(id);
      });
    });

    // Close on outside click
    window.addEventListener('click', (e) => {
      if (!e.target.closest('.custom-select-wrapper')) {
        options.classList.remove('show');
      }
    });
  }, []);
  return <div className="custom-select-wrapper custom-select-style" ref={selectEle}>
  <div className="custom-select" id="selectedOption">
    <span className="color-box" style={{backgroundColor: '#dc3545'}} /> {selectedStyle?`${selectedStyle.styleName} (${selectedStyle.key})`:"Custom"}
  </div>
  <div className="custom-options" id="optionList">
    {
      styles.map(function(v){
        return <div key={v.key} data-id={v.key} data-color="#dc3545" data-label={`${v.styleName} (${v.key})`}><span className="color-box" style={{backgroundColor: '#dc3545'}} /> {v.styleName} ({v.key})</div> 
      })
    }
    <div key={"custom"} data-id={"custom"} data-color="#dc3545" data-label="Red"><span className="color-box" style={{backgroundColor: '#dc3545'}} /> Custom</div>
  </div>
</div>

}

const ModuleCard = function({page, pageId}) {
  const data = modulesJSON.data.filter((v)=>v.page == page);
  const [id, setId] = useState(0);
  const [variables, setVariables] = useState(null);

  useEffect(function(){
    app.appkitPages(page, pageId, data[id].category).then(function(response){
      setVariables(response);
    })
  }, [])

  const changeId = function(newId) {
    setId(newId);
    setVariables(null);
    app.appkitPages(page, pageId, data[newId].category).then(function(response){
      setVariables(response);
    })
  }

  let html = "";
  if(variables) {
    console.log(variables);
    const nextDB = data[id].data;
    nextDB.card["variables"][0].value = variables;
    html = <DivkitRender data={data[id].data} />
  }
  else {
    html = <div>Loading</div>
  }

  return <div className="card">
          {/* Card Header */}
          <div className="card-header">
            <div className="row align-items-center">
              {/* Left: Heading */}
              <div className="col-md-4">
                <h6 className="mb-0 fw-semibold">{data[id].name}</h6>
              </div>
              {/* Right: Form Fields */}
              <div className="col-md-8">
                <div className="d-flex justify-content-end align-items-center gap-3 flex-wrap">
                  {/* Select */}
                  <select className="form-select form-select-sm w-auto" value={id} onChange={function(e){
                    changeId(e.currentTarget.value)
                  }}>
                    {
                      data.map(function(v, i){
                        return <option value={i}>{v.name}</option>
                      })
                    }
                  </select>
                </div>
              </div>
            </div>
          </div>
          {/* Card Body */}
          <div className="card-body">
            {html}
          </div>
        </div>
}

export const AppModules = ({ callback }) => {
  const config = app.getConfig();
  const readyPages = ["blog", "hyperstore"];
  const [data, setData] = useState(modulesJSON.data);
  const [pages, setPages] = useState([]);
  const [selectedPage, setSelectedPage] = useState({});
 
  useEffect(function(){
    app.featurePages().then(function(newPages){
      console.log(newPages);
      setPages(newPages.filter(function(v){
        return (readyPages.indexOf(v.pageIdentifier) !== -1);
      }))
    })
  }, [])

  
  const remove = useCallback((el) => {
    if (el?.parentElement) {
      el.parentElement.remove();
    }
  }, []);

  const handleClose = (e) => {
    const node = ReactDOM.findDOMNode(e.currentTarget);
    remove(node);
  };

  const handleSelect = (e, value) => {
    const node = ReactDOM.findDOMNode(e.currentTarget);
    remove(node);
    callback?.(value);
  };

  return (
    <div className="modal" style={{ display: "block" }}>
      <div className="modal-dialog modal-dialog-scrollable modal-xl">
        <div className="modal-content">
          <div className="modal-header" style={{ paddingLeft: "24px" }}>
            <h5 className="modal-title">
              All Modules
            </h5>
            <button
              type="button"
              className="close-popup modal-close position-relative fa-sharp icon-cancel icon-cancel"
              style={{ right: "20px" }}
              onClick={handleClose}
            />
          </div>

          <div className="modal-body d-block row m-0 p-0">
            <div className="accordion modules-accordion p-3 m-0" id="accordionExample">
            {pages.map((v, index) => {
                 

                  return <div className="accordion-item">
    <h2 className="accordion-header">
      <button className={`accordion-button ${selectedPage.pageId === v.pageId ? '' : 'collapsed'}`} onClick={() => setSelectedPage(v)} type="button">
        {v.pageName}
      </button>
    </h2>
    {selectedPage.pageId === v.pageId? <div id="collapseOne" className="accordion-collapse collapse show">
      <div className="accordion-body">
       <ModuleCard key={v.pageId} page={v.pageIdentifier} pageId={v.pageId} />
      </div>
    </div>:""}
   
  </div>


                })}
                </div>
          </div>
        </div>
      </div>
    </div>
  );
};